export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	Alphanumeric: any;
	Days: number;
	ISO8601DateTime: string;
	JSON: Record<string, any>;
	Upload: any;
	Url: any;
};

/** Invite accept arguments. */
export type AcceptInvitationMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The database id for the invitation. */
	databaseId?: InputMaybe<Scalars['Int']>;
	/** The generated id for the invitation. */
	guid?: InputMaybe<Scalars['String']>;
	/** The GQL ID for the invitation. */
	id?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type AcceptInvitationMutationPayload = {
	__typename?: 'AcceptInvitationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The invitation that was accepted. */
	invitation?: Maybe<Invitation>;
	success: Scalars['Boolean'];
};

/** Represents an Admin User. */
export type Admin = NodeInterface & {
	__typename?: 'Admin';
	/** The active/Inactive status. */
	active?: Maybe<Scalars['Boolean']>;
	/** The avatar associated with the Admin User. */
	avatar?: Maybe<ImageAttachment>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The email of the User. */
	email?: Maybe<Scalars['String']>;
	/** The first name of the Admin User. */
	firstName?: Maybe<Scalars['String']>;
	/** The formatted phone number of the User. */
	formattedPhone?: Maybe<Scalars['String']>;
	/** A list of Groups associated with the Admin User. */
	groups?: Maybe<AdminGroupConnection>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The initials of the user based on their first name and last name. */
	initials?: Maybe<Scalars['String']>;
	/** The job title of the User. */
	jobTitle?: Maybe<Scalars['String']>;
	/** The last name of the Admin User. */
	lastName?: Maybe<Scalars['String']>;
	/** The full name of the Admin User. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** The permalink for the Admin User. */
	permalink?: Maybe<Scalars['String']>;
	/** A list of Permissions associated with the currently authenticated User and the Admin. */
	permissions: AdminPermissions;
	/** The phone number of the Admin User. */
	phone?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The username of the User. */
	username?: Maybe<Scalars['String']>;
};


/** Represents an Admin User. */
export type AdminGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type AdminGroupConnection = {
	__typename?: 'AdminGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<AdminGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the AdminGroupConnection. */
	permissions: AdminGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type AdminGroupConnectionPermissions = {
	__typename?: 'AdminGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type AdminGroupEdge = {
	__typename?: 'AdminGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type AdminPermissions = {
	__typename?: 'AdminPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Represents an Organization's API Token. */
export type ApiToken = NodeInterface & {
	__typename?: 'ApiToken';
	/** A flag indicating whether the API Token has access to all Groups in the Organization. */
	allGroups?: Maybe<Scalars['Boolean']>;
	/** The datetime the API Token was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The User that created the API Token. */
	creator?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The Groups the API Token has access to. */
	groups?: Maybe<Array<Group>>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The datetime the API Token was last used. */
	lastAccessedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The name of the API Token. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization the API Token belongs to. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ApiToken. */
	permissions: ApiTokenPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** A JWT token. */
	token?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ApiTokenPermissions = {
	__typename?: 'ApiTokenPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type Archive = NodeInterface & {
	__typename?: 'Archive';
	/** The asset associated with this archive. */
	asset?: Maybe<Asset>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of file names contained in the archive. */
	fileNames?: Maybe<Array<Scalars['String']>>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Archive. */
	permissions: ArchivePermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The type of archive file, such as ZIP or RAR. */
	type?: Maybe<ArchiveTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ArchivePermissions = {
	__typename?: 'ArchivePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ArchiveTypeEnum {
	/** A file in the RAR archive format. */
	Rar = 'RAR',
	/** A file in the ZIP archive format. */
	Zip = 'ZIP'
}

/** Represents a asset associated with a Scope Create Project. */
export type Asset = NodeInterface & {
	__typename?: 'Asset';
	/** The archive file associated with this asset. */
	archive?: Maybe<Archive>;
	/** The timestamp indicating when the asset was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The user who originally created the asset. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Indicates whether there was an error during the asset's processing. */
	errorProcessing?: Maybe<Scalars['String']>;
	/** The folder where this asset is stored. */
	folder?: Maybe<Asset>;
	/** Indicates whether the asset includes animations. */
	hasAnimations?: Maybe<Scalars['Boolean']>;
	/** Indicates whether the asset includes a skeleton structure. */
	hasSkeleton?: Maybe<Scalars['Boolean']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Indicates whether the asset is currently in use in any project version, including deleted projects. */
	inUse?: Maybe<Scalars['Boolean']>;
	/** The library location of the asset. */
	location?: Maybe<Scalars['String']>;
	/** The number of meshes in the asset. */
	meshCount?: Maybe<Scalars['Int']>;
	/** List of model processing jobs associated with the asset. */
	modelProcessJobs?: Maybe<AssetModelProcessJobConnection>;
	/** The name of the Asset. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The original version of the asset file before any processing. */
	originalFile?: Maybe<Attachment>;
	/** The original file extension of the asset. */
	originalFileExtension?: Maybe<Scalars['String']>;
	/** The current owner of the asset. */
	owner?: Maybe<NodeInterface>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Asset. */
	permissions: AssetPermissions;
	/** The number of polygons in the asset. */
	polyCount?: Maybe<Scalars['Int']>;
	/** A smaller, optimized preview version of the asset file. */
	previewFile?: Maybe<Attachment>;
	/** The processed version of the asset file, ready for use. */
	processedFile?: Maybe<Attachment>;
	/** Save files that the asset is a part of. */
	projectSaveFiles?: Maybe<AssetProjectSaveFileConnection>;
	/** A list of revisions made to the asset. */
	revisions?: Maybe<Array<AssetRevision>>;
	/** The version of the schema used for the asset. */
	schemaVersion?: Maybe<Scalars['Int']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The type of the Asset. */
	type?: Maybe<AssetTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents a asset associated with a Scope Create Project. */
export type AssetModelProcessJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assetDatabaseId?: InputMaybe<Scalars['String']>;
	assetId?: InputMaybe<Scalars['ID']>;
	baseRevisionDatabaseId?: InputMaybe<Scalars['String']>;
	baseRevisionId?: InputMaybe<Scalars['ID']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ModelProcessJobStatusEnum>>;
	queuedAt?: InputMaybe<DateRangeInputObject>;
};


/** Represents a asset associated with a Scope Create Project. */
export type AssetOriginalFileArgs = {
	fileSource?: InputMaybe<FileSourceEnum>;
};


/** Represents a asset associated with a Scope Create Project. */
export type AssetPreviewFileArgs = {
	fileSource?: InputMaybe<FileSourceEnum>;
};


/** Represents a asset associated with a Scope Create Project. */
export type AssetProcessedFileArgs = {
	fileSource?: InputMaybe<FileSourceEnum>;
};


/** Represents a asset associated with a Scope Create Project. */
export type AssetProjectSaveFilesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	includeDeleted?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
	saveTypes?: InputMaybe<Array<ProjectSaveFileSaveTypeEnum>>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
};

/** A connection from a Node. */
export type AssetModelProcessJobConnection = {
	__typename?: 'AssetModelProcessJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<AssetModelProcessJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ModelProcessJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the AssetModelProcessJobConnection. */
	permissions: AssetModelProcessJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type AssetModelProcessJobConnectionPermissions = {
	__typename?: 'AssetModelProcessJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type AssetModelProcessJobEdge = {
	__typename?: 'AssetModelProcessJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ModelProcessJob>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type AssetPermissions = {
	__typename?: 'AssetPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type AssetProjectSaveFileConnection = {
	__typename?: 'AssetProjectSaveFileConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<AssetProjectSaveFileEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectSaveFile>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the AssetProjectSaveFileConnection. */
	permissions: AssetProjectSaveFileConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type AssetProjectSaveFileConnectionPermissions = {
	__typename?: 'AssetProjectSaveFileConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type AssetProjectSaveFileEdge = {
	__typename?: 'AssetProjectSaveFileEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectSaveFile>;
};

/** A Node in the graph. */
export type AssetRevision = NodeInterface & {
	__typename?: 'AssetRevision';
	/** The original asset associated with this revision. */
	asset?: Maybe<Asset>;
	/** The timestamp indicating when this revision was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Indicates whether the asset revision includes animations. */
	hasAnimations?: Maybe<Scalars['Boolean']>;
	/** Indicates whether the asset revision includes a skeleton structure. */
	hasSkeleton?: Maybe<Scalars['Boolean']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Indicates whether the asset revision is currently in use in any project version, including deleted projects. */
	inUse?: Maybe<Scalars['Boolean']>;
	/** The number of meshes in the asset revision. */
	meshCount?: Maybe<Scalars['Int']>;
	/** A file containing metadata related to the asset revision. */
	metadataFile?: Maybe<Attachment>;
	/** Model processing job associated with the asset revision. */
	modelProcessJob?: Maybe<ModelProcessJob>;
	/** The name of the asset revision. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the AssetRevision. */
	permissions: AssetRevisionPermissions;
	/** The number of polygons in the asset revision. */
	polyCount?: Maybe<Scalars['Int']>;
	/** The preprocessed version of the asset revision, before final processing. */
	preprocessedFile?: Maybe<Attachment>;
	/** A smaller, optimized preview version of the asset revision. */
	previewFile?: Maybe<Attachment>;
	/** The processed version of the asset revision. */
	processedFile?: Maybe<Attachment>;
	/** Save files that the asset revision is a part of. */
	projectSaveFiles?: Maybe<AssetRevisionProjectSaveFileConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** A Node in the graph. */
export type AssetRevisionProjectSaveFilesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	includeDeleted?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
	saveTypes?: InputMaybe<Array<ProjectSaveFileSaveTypeEnum>>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type AssetRevisionPermissions = {
	__typename?: 'AssetRevisionPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type AssetRevisionProjectSaveFileConnection = {
	__typename?: 'AssetRevisionProjectSaveFileConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<AssetRevisionProjectSaveFileEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectSaveFile>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the AssetRevisionProjectSaveFileConnection. */
	permissions: AssetRevisionProjectSaveFileConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type AssetRevisionProjectSaveFileConnectionPermissions = {
	__typename?: 'AssetRevisionProjectSaveFileConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type AssetRevisionProjectSaveFileEdge = {
	__typename?: 'AssetRevisionProjectSaveFileEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectSaveFile>;
};

export enum AssetTypeEnum {
	/** An audio file. */
	Audio = 'AUDIO',
	/** A document. */
	Document = 'DOCUMENT',
	/** A folder. */
	Folder = 'FOLDER',
	/** An image. */
	Image = 'IMAGE',
	/** A 3D model. */
	Model = 'MODEL',
	/** A video file. */
	Video = 'VIDEO'
}

/** Represents a digital asset associated with an object (e.g. a text file, photo, screenshot, etc.). */
export type Attachment = {
	__typename?: 'Attachment';
	/**
   * The User that authored the Attachment.
   * @deprecated Not yet implemented.
   */
	author?: Maybe<User>;
	/** The content type of the file associated with the Attachment. */
	fileContentType?: Maybe<Scalars['String']>;
	/** The number of times the file associated with the Attachment has been downloaded. */
	fileDownloadCount?: Maybe<Scalars['Int']>;
	/** The checksum of the file associated with the Attachment. */
	fileFingerprint?: Maybe<Scalars['String']>;
	/** The name of the file associated with the Attachment. */
	fileName?: Maybe<Scalars['String']>;
	/** The size of the file associated with the Attachment in bytes. */
	fileSize?: Maybe<Scalars['Int']>;
	/** The date and time when the file associated with the Attachment was last updated. */
	fileUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Current status of the S3 file upload process. */
	fileUploadStatus?: Maybe<AttachmentFileUploadStatusEnum>;
	/** S3 Pre-signed URL for uploading the attachment file. */
	fileUploadUrl?: Maybe<Scalars['Url']>;
	/** Expiration timestamp for the S3 file upload URL. */
	fileUploadUrlExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The authorized url of the Attachment. */
	fileUrl?: Maybe<Scalars['Url']>;
	/** The date and time when the authorized url of the Attachment expires. */
	fileUrlExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The name of the Attachment. */
	name?: Maybe<Scalars['String']>;
	/**
   * The Organization associated with the Attachment.
   * @deprecated Not yet implemented.
   */
	organization?: Maybe<Organization>;
	/**
   * The object that the Attachment belongs to.
   * @deprecated Not yet implemented.
   */
	owner?: Maybe<AttachmentOwner>;
	/**
   * A list of SharedAttachments associated with the Attachment.
   * @deprecated Not yet implemented.
   */
	shares?: Maybe<AttachmentSharedAttachmentConnection>;
	/**
   * The type of the Attachment.
   * @deprecated Not yet implemented.
   */
	type?: Maybe<AttachmentTypeEnum>;
};


/** Represents a digital asset associated with an object (e.g. a text file, photo, screenshot, etc.). */
export type AttachmentSharesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

export enum AttachmentFileUploadStatusEnum {
	/** The file upload encountered an error. */
	Error = 'ERROR',
	/** The file upload is pending. */
	Pending = 'PENDING',
	/** The file upload was successful. */
	Success = 'SUCCESS'
}

/** A union of types that have an Attachment. */
export type AttachmentOwner = Call | CallLog | CallRecording | Device | Feedback | Group | Invitation | License | Organization | Photo | ProductRelease | Scenario | ScenarioRelease | ScenarioSequence | ScenarioSession | ScenarioSessionEvent | ScenarioSessionPart | ScenarioSessionStep | ScenarioStep | ScenarioStepItem | User;

/** A connection from a Node. */
export type AttachmentSharedAttachmentConnection = {
	__typename?: 'AttachmentSharedAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<AttachmentSharedAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<SharedAttachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the AttachmentSharedAttachmentConnection. */
	permissions: AttachmentSharedAttachmentConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type AttachmentSharedAttachmentConnectionPermissions = {
	__typename?: 'AttachmentSharedAttachmentConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type AttachmentSharedAttachmentEdge = {
	__typename?: 'AttachmentSharedAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<SharedAttachment>;
};

export enum AttachmentTypeEnum {
	/** A photo captured using a Device's camera while completing a Scenario checklist item. */
	Checklistphoto = 'CHECKLISTPHOTO',
	/** A photo captured using a Device's camera. */
	Photo = 'PHOTO',
	/** A screenshot of a users Device. */
	Screenshot = 'SCREENSHOT',
	/** An image that AR technology can detect and track. AR engines detect and track images by comparing extracted natural features from the camera image against a known target resource database. */
	Target = 'TARGET'
}

/** Represents a log generated upon a user or system event. */
export type AuditLog = NodeInterface & {
	__typename?: 'AuditLog';
	/** The API Token that executed the action that generated the AuditLog. */
	apiToken?: Maybe<ApiToken>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** AuditLog details. */
	data?: Maybe<Scalars['JSON']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** The date and time the AuditLog was recorded. */
	date?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the AuditLog. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the AuditLog. */
	permissions: AuditLogPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The object that is subject of the AuditLog. */
	subject?: Maybe<NodeInterface>;
	/** The GraphQL type of the object that is subject of the AuditLog. */
	subjectType?: Maybe<Scalars['String']>;
	/** The WebhookTopic associated with the AuditLog, describing the operation that generate the AuditLog. */
	topic?: Maybe<WebhookTopic>;
	/** The type of the AuditLog. One of AuditLogTypeEnum. */
	type?: Maybe<AuditLogTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User that executed the action that generated the AuditLog. */
	user?: Maybe<User>;
	/** The name of the User that executed the action that generated the AuditLog. */
	userName?: Maybe<Scalars['String']>;
};

/** A connection to Audit Logs. */
export type AuditLogConnection = {
	__typename?: 'AuditLogConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectAuditLogEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<AuditLog>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the AuditLogConnection. */
	permissions: AuditLogConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
	/** A list of users for all Audit Logs in the connection. */
	users?: Maybe<Array<User>>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type AuditLogConnectionPermissions = {
	__typename?: 'AuditLogConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type AuditLogPermissions = {
	__typename?: 'AuditLogPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum AuditLogTypeEnum {
	/** Log entries for when an admin makes any change. */
	AdminActivity = 'ADMIN_ACTIVITY',
	/** Log entries for when a user makes any change from Worklink Create app. */
	CreateActivity = 'CREATE_ACTIVITY',
	/** Log entries for when a user accesses data. */
	DataAccess = 'DATA_ACCESS',
	/** Log entries for when the system denies access to a user or service because of a security policy violation. */
	PolicyDenied = 'POLICY_DENIED',
	/** Log entries for internal services that modify data. */
	SystemEvent = 'SYSTEM_EVENT'
}

/** Autogenerated nested input type of AuditLogs */
export type AuditLogsDataInput = {
	/** The external data key (or JSON key path) to be used to filter audit logs. */
	key?: InputMaybe<Scalars['String']>;
	/** A field path within the data object to be used to filter the audit logs. */
	path?: InputMaybe<Scalars['String']>;
	/** The type of way to find the key-value pair in the data. Can be MATCH or CONTAINS. */
	type?: InputMaybe<Scalars['String']>;
	/** The value of the data key to be used to filter audit logs. */
	value?: InputMaybe<Scalars['Alphanumeric']>;
	/** The array of values of the data key to be used to filter audit logs. */
	values?: InputMaybe<Array<Scalars['Alphanumeric']>>;
};

/** Represents the result of applying a policy rule to a graph element. */
export type AuthorizationResult = {
	__typename?: 'AuthorizationResult';
	/** Result of applying a policy rule. */
	value: Scalars['Boolean'];
};

/** An Object. */
export type BulkOperation = {
	__typename?: 'BulkOperation';
	/** Bulk Operation Id. */
	id?: Maybe<Scalars['String']>;
	/** Success message contains how many record ben changed. */
	successMessage?: Maybe<Scalars['String']>;
};

export enum BulkOperationTypeEnum {
	/** User. */
	User = 'USER'
}

/** Represents a remote A/V interaction involving two Users. */
export type Call = NodeInterface & {
	__typename?: 'Call';
	/** The User that received the Call. */
	callee?: Maybe<User>;
	/** The Device of the User that received the Call. */
	calleeDevice?: Maybe<CallSessionDevice>;
	/** The id of the User that received the Call. */
	calleeId?: Maybe<Scalars['ID']>;
	/** The name of the User that received the Call. */
	calleeName?: Maybe<Scalars['String']>;
	/** The User that originated the Call. */
	caller?: Maybe<User>;
	/** The Device of the User that originated the Call. */
	callerDevice?: Maybe<CallSessionDevice>;
	/** The id of the User that originated the Call. */
	callerId?: Maybe<Scalars['ID']>;
	/** The name of the User that originated the Call. */
	callerName?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The duration of the Call in seconds. */
	duration?: Maybe<Scalars['Int']>;
	/** The date and time when the Call terminated. */
	endedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The external data added to the Call. */
	externalData?: Maybe<Scalars['JSON']>;
	/** A list of Feedbacks associated with the Call. */
	feedbacks?: Maybe<CallFeedbackConnection>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** A list of CallLogs associated with the Call. */
	logs?: Maybe<CallCallLogConnection>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the Call. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Call. */
	permissions: CallPermissions;
	/** A list of Photos associated with the Call. */
	photos?: Maybe<CallCallPhotoConnection>;
	/** A list of CallRecordings associated with the Call. */
	recordings?: Maybe<CallCallRecordingConnection>;
	/** A list of reviews that can be associated with reviewable. */
	reviews?: Maybe<Array<ReviewReviewable>>;
	/** The ScenarioSession associated with the Call. */
	scenarioSession?: Maybe<ScenarioSession>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The date and time when the Call started. */
	startedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** Worklink version. */
	worklinkVersion?: Maybe<Scalars['String']>;
};


/** Represents a remote A/V interaction involving two Users. */
export type CallFeedbacksArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a remote A/V interaction involving two Users. */
export type CallLogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a remote A/V interaction involving two Users. */
export type CallPhotosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a remote A/V interaction involving two Users. */
export type CallRecordingsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assembled?: InputMaybe<Scalars['Boolean']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	userId?: InputMaybe<Scalars['ID']>;
};

/** A connection from a Node. */
export type CallCallLogConnection = {
	__typename?: 'CallCallLogConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<CallCallLogEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallLog>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the CallCallLogConnection. */
	permissions: CallCallLogConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type CallCallLogConnectionPermissions = {
	__typename?: 'CallCallLogConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type CallCallLogEdge = {
	__typename?: 'CallCallLogEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallLog>;
};

/** A connection from a Node. */
export type CallCallPhotoConnection = {
	__typename?: 'CallCallPhotoConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<CallCallPhotoEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallPhoto>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the CallCallPhotoConnection. */
	permissions: CallCallPhotoConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type CallCallPhotoConnectionPermissions = {
	__typename?: 'CallCallPhotoConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type CallCallPhotoEdge = {
	__typename?: 'CallCallPhotoEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallPhoto>;
};

/** A connection from a Node. */
export type CallCallRecordingConnection = {
	__typename?: 'CallCallRecordingConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<CallCallRecordingEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallRecording>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the CallCallRecordingConnection. */
	permissions: CallCallRecordingConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type CallCallRecordingConnectionPermissions = {
	__typename?: 'CallCallRecordingConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type CallCallRecordingEdge = {
	__typename?: 'CallCallRecordingEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallRecording>;
};

/** A connection from a Node. */
export type CallFeedbackConnection = {
	__typename?: 'CallFeedbackConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<CallFeedbackEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Feedback>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the CallFeedbackConnection. */
	permissions: CallFeedbackConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type CallFeedbackConnectionPermissions = {
	__typename?: 'CallFeedbackConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type CallFeedbackEdge = {
	__typename?: 'CallFeedbackEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Feedback>;
};

/** Represents a log submitted by one participant in a Call. */
export type CallLog = NodeInterface & {
	__typename?: 'CallLog';
	/** The Call associated with the CallLog. */
	call?: Maybe<Call>;
	/** The date the CallLog was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A flag indicating whether the call log represents an error. */
	error?: Maybe<Scalars['Boolean']>;
	/** The content of the CallLog. */
	externalData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The log of the call log. */
	log?: Maybe<Scalars['JSON']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the CallLog. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the CallLog. */
	permissions: CallLogPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The type of the CallLog. */
	type?: Maybe<CallLogTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User that owns the Device associated with the CallLog. */
	user?: Maybe<User>;
	/** Version metadata. */
	version?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type CallLogPermissions = {
	__typename?: 'CallLogPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum CallLogTypeEnum {
	/** An apple debug CallLog. */
	AppleDebug = 'APPLE_DEBUG',
	/** An audio error CallLog. */
	AudioError = 'AUDIO_ERROR',
	/** An did not answer CallLog. */
	DidNotAnswer = 'DID_NOT_ANSWER',
	/** A dismissed Feedback CallLog. */
	DismissedFeedback = 'DISMISSED_FEEDBACK',
	/** An exception CallLog. */
	Exception = 'EXCEPTION',
	/** A failed to connect CallLog. */
	FailedToConnect = 'FAILED_TO_CONNECT',
	/** A negative Feedback CallLog. */
	NegativeFeedback = 'NEGATIVE_FEEDBACK',
	/** An other side CallLog. */
	OtherSide = 'OTHER_SIDE',
	/** A quality CallLog. */
	Quality = 'QUALITY'
}

export enum CallParticipantTypeEnum {
	/** A User receiving a Call. */
	Expert = 'EXPERT',
	/** A User starting a Call. */
	Tech = 'TECH'
}

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type CallPermissions = {
	__typename?: 'CallPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type CallPhoto = NodeInterface & {
	__typename?: 'CallPhoto';
	/** The Call associated with the CallPhoto. */
	call?: Maybe<Call>;
	/** The date the CallPhoto was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the CallPhoto. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the CallPhoto. */
	permissions: CallPhotoPermissions;
	/** The Photo associated with the CallPhoto. */
	photo?: Maybe<Photo>;
	/** The User that received the CallPhoto. */
	receiver?: Maybe<User>;
	/** The name of the User that received the CallPhoto. */
	receiverName?: Maybe<Scalars['String']>;
	/** The User that sent the CallPhoto. */
	sender?: Maybe<User>;
	/** The name of the User that sent the CallPhoto. */
	senderName?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type CallPhotoPermissions = {
	__typename?: 'CallPhotoPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Represents an A/V recording of a Call (note: resuming a paused CallRecording creates a new record). */
export type CallRecording = NodeInterface & {
	__typename?: 'CallRecording';
	/** The annotations associated with the CallRecording (overlayed on top of the AV recording). */
	annotations?: Maybe<Attachment>;
	/** Boolean to show whether the call recording was processed and assembled. */
	assembled?: Maybe<Scalars['Boolean']>;
	/** Describes any errors that occured while assembling the Attachments associated with the CallRecording. */
	assemblyFailureReason?: Maybe<Scalars['String']>;
	/** The Call associated with the CallRecording. */
	call?: Maybe<Call>;
	/** The date the CallRecording was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Urls for associated files. */
	expiringUrlsForFiles?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The MKV version of A/V recording associated with the CallRecording. */
	mkvVideo?: Maybe<Attachment>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The index of the CallRecording within the context of a Call. */
	orderIndex?: Maybe<Scalars['Int']>;
	/** The Organization associated with the CallRecording. */
	organization?: Maybe<Organization>;
	/** A list of CallRecordingParts associated with the CallRecording. */
	parts?: Maybe<CallRecordingCallRecordingPartConnection>;
	/** Number of parts received. */
	partsReceived?: Maybe<Scalars['Int']>;
	/** The total number of parts. */
	partsTotal?: Maybe<Scalars['Int']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the CallRecording. */
	permissions: CallRecordingPermissions;
	/** The reason why the processing failed. */
	processingFailure?: Maybe<Scalars['String']>;
	/** Number of retries taken to process this call recording. */
	retries?: Maybe<Scalars['Int']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/**
   * The state of the CallRecording.
   * 
   * The default value is "UPLOADING".
   */
	state?: Maybe<CallRecordingStateEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The completed percentage of a CallRecording upload. */
	uploadPercentComplete?: Maybe<Scalars['Float']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User the CallRecording was created by. */
	user?: Maybe<User>;
	/** The name of the User the CallRecording was created by. */
	userName?: Maybe<Scalars['String']>;
	/** The A/V recording associated with the CallRecording. */
	video?: Maybe<Attachment>;
};


/** Represents an A/V recording of a Call (note: resuming a paused CallRecording creates a new record). */
export type CallRecordingPartsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type CallRecordingCallRecordingPartConnection = {
	__typename?: 'CallRecordingCallRecordingPartConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<CallRecordingCallRecordingPartEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallRecordingPart>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the CallRecordingCallRecordingPartConnection. */
	permissions: CallRecordingCallRecordingPartConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type CallRecordingCallRecordingPartConnectionPermissions = {
	__typename?: 'CallRecordingCallRecordingPartConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type CallRecordingCallRecordingPartEdge = {
	__typename?: 'CallRecordingCallRecordingPartEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallRecordingPart>;
};

/** Call Recording arguments. */
export type CallRecordingInputObject = {
	/** ID of the record. */
	id?: InputMaybe<Scalars['ID']>;
};

/** Represents one part of a muli-part CallRecording. */
export type CallRecordingPart = NodeInterface & {
	__typename?: 'CallRecordingPart';
	/** The CallRecording associated with the CallRecordingPart. */
	callRecording?: Maybe<CallRecording>;
	/** The content associated with the CallRecordingPart. */
	content?: Maybe<Attachment>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The index of the CallRecordingPart within the context of a CallRecording. */
	orderIndex?: Maybe<Scalars['Int']>;
	/** The Organization associated with the CallRecordingPart. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the CallRecordingPart. */
	permissions: CallRecordingPartPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type CallRecordingPartPermissions = {
	__typename?: 'CallRecordingPartPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type CallRecordingPermissions = {
	__typename?: 'CallRecordingPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum CallRecordingStateEnum {
	/** A CallRecording that has been assembled. */
	Assembled = 'ASSEMBLED',
	/** A CallRecording that is assembling. */
	Assembling = 'ASSEMBLING',
	/** A CallRecording that failed to assemble. */
	AssemblyFailed = 'ASSEMBLY_FAILED',
	/** A CallRecording that has been deleted. */
	Deleted = 'DELETED',
	/** A CallRecording that is uploading. */
	Uploading = 'UPLOADING'
}

/** Represents a device, used by a user during a call. */
export type CallSessionDevice = NodeInterface & {
	__typename?: 'CallSessionDevice';
	/** The altitude of the CallSessionDevice during a Call. */
	altitude?: Maybe<Scalars['Float']>;
	/** The ArPlatform of the CallSessionDevice during a call. */
	arPlatform?: Maybe<Scalars['String']>;
	/** The type of call participant during a call. */
	callParticipantType?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Device information. */
	device?: Maybe<Device>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The latitude of the CallSessionDevice during a Call. */
	latitude?: Maybe<Scalars['Float']>;
	/** The longitude of the CallSessionDevice during a Call. */
	longitude?: Maybe<Scalars['Float']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the CallSessionDevice. */
	permissions: CallSessionDevicePermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The version of the CallSessionDevice during a Call. */
	version?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type CallSessionDevicePermissions = {
	__typename?: 'CallSessionDevicePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Autogenerated nested input type of Calls */
export type CallsExternalDataInput = {
	/** The external data key (or JSON key path) to be used to filter call sessions. */
	key?: InputMaybe<Scalars['String']>;
	/** The value of the external data key to be used to filter call sessions. */
	value?: InputMaybe<Scalars['Alphanumeric']>;
};

/** Autogenerated nested input type of Calls */
export type CallsParticipantInput = {
	/** The GQL ID of a user to filter the calls by. Can be a caller or callee. */
	id?: InputMaybe<Scalars['ID']>;
	/** The username to filter the calls. Can be a caller or callee. */
	username?: InputMaybe<Scalars['String']>;
};

/** Calls query arguments. */
export type CallsQueryInputObject = {
	/** String matching the name of callers or callees. */
	fullText?: InputMaybe<Scalars['String']>;
	/** A sort order input object. */
	orderBy?: InputMaybe<SortOrderInputObject>;
	/** List of quality ratings submitted in a Review by the caller or callee. */
	quality?: InputMaybe<Array<Scalars['String']>>;
	/** A date range input object with starting and ending call started at values. */
	startedAt?: InputMaybe<DateRangeInputObject>;
};

/** Represents the client certificate created. */
export type ClientCertificate = NodeInterface & {
	__typename?: 'ClientCertificate';
	/** The Certificate Authority (issuer) certificate that was used to create the client cert. */
	caCert?: Maybe<Scalars['String']>;
	/** The actual client certificate pem. */
	clientCert?: Maybe<Scalars['String']>;
	/** The key used to create the client certificate. */
	clientKey?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The pem used to construct the certificate signing request (CSR). */
	csrPem?: Maybe<Scalars['String']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** When the client certificate will expire and no longer be valid. */
	expiringAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The organization or company associated with this certificate. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ClientCertificate. */
	permissions: ClientCertificatePermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** When the client certificate was created and allowed to be used. */
	startingAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ClientCertificatePermissions = {
	__typename?: 'ClientCertificatePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Autogenerated input type of CloseOrganizationMutation */
export type CloseOrganizationMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Closing date for organization. */
	closedAt: Scalars['ISO8601DateTime'];
	/** id of organizartion to close. */
	id: Scalars['ID'];
};

/** An Object. */
export type CloseOrganizationMutationPayload = {
	__typename?: 'CloseOrganizationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	/** Organization that were closed. */
	closedOrganization?: Maybe<Organization>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CloseOrganizationsMutation */
export type CloseOrganizationsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Closing date for organizations. */
	closedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
	/** ids of organizations to close. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type CloseOrganizationsMutationPayload = {
	__typename?: 'CloseOrganizationsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	/** Organizations that were closed. */
	closedOrganizations: Array<Organization>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** API Token upsert arguments. */
export type CreateApiTokenMutationInput = {
	/** Whether the API Token has permissions on all Groups in the Organization. */
	allGroups: Scalars['Boolean'];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of Groups the API Token has permissions over. */
	groups?: InputMaybe<Array<Scalars['ID']>>;
	/** Name of the API Token. */
	name: Scalars['String'];
};

/** An Object. */
export type CreateApiTokenMutationPayload = {
	__typename?: 'CreateApiTokenMutationPayload';
	/** Resulted API Token. */
	apiToken?: Maybe<ApiToken>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Input object for creating a new asset. */
export type CreateAssetMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The user ID of the asset author. Admins can create assets on behalf of other authors. */
	createdById?: InputMaybe<Scalars['ID']>;
	/** The file data for the asset being created. */
	file?: InputMaybe<Scalars['Upload']>;
	/** Name of the asset file being uploaded. */
	fileName?: InputMaybe<Scalars['String']>;
	/** The asset database ID of the folder where the new asset will be stored. */
	folderDatabaseId?: InputMaybe<Scalars['String']>;
	/** The asset ID of the folder where the new asset will be stored. */
	folderId?: InputMaybe<Scalars['ID']>;
	/** The name of the asset to be created. */
	name?: InputMaybe<Scalars['String']>;
	/** The ID of the new owner of the asset. It can either be a user, an organization. */
	ownerId?: InputMaybe<Scalars['ID']>;
	/** Requests an S3 pre-signed URL for uploading a new asset file. */
	requestFileUploadUrl?: InputMaybe<Scalars['Boolean']>;
	/** The type of the asset, such as image, video, document, etc. */
	type?: InputMaybe<AssetTypeEnum>;
};

/** An Object. */
export type CreateAssetMutationPayload = {
	__typename?: 'CreateAssetMutationPayload';
	/** The newly created asset. */
	asset?: Maybe<Asset>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateBulkOperationMutation */
export type CreateBulkOperationMutationInput = {
	/** CSV File contains data to be create/invite. */
	bulkImportFile: Scalars['Upload'];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Boolean value decide to create users invite or to add into cms. */
	shouldCreateInvites?: InputMaybe<Scalars['Boolean']>;
	/** A type to identifiy for which resource we need to run bulk import. */
	type: BulkOperationTypeEnum;
};

/** An Object. */
export type CreateBulkOperationMutationPayload = {
	__typename?: 'CreateBulkOperationMutationPayload';
	/** Bulk Operation Instance. */
	bulkOperation?: Maybe<BulkOperation>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Call log arguments. */
export type CreateCallLogMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The log of the call log. */
	log: Scalars['JSON'];
	/** Verstion metadata for the call log. */
	version?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type CreateCallLogMutationPayload = {
	__typename?: 'CreateCallLogMutationPayload';
	/** A call log instance. */
	callLog?: Maybe<CallLog>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Call Create Arguments. */
export type CreateCallMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** ID of the expert. */
	expertId: Scalars['ID'];
	/** JSON object of any externally provided data. */
	externalData?: InputMaybe<Scalars['JSON']>;
	/** GUID that can be provided to the call. */
	guid?: InputMaybe<Scalars['String']>;
	/** ID of the tech user. */
	userId: Scalars['ID'];
};

/** An Object. */
export type CreateCallMutationPayload = {
	__typename?: 'CreateCallMutationPayload';
	/** A call instance. */
	call?: Maybe<Call>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Client Certificate arguments. */
export type CreateClientCertificateMutationInput = {
	/** Optional CA Certificate to be used to create a client cert. */
	caCert?: InputMaybe<Scalars['String']>;
	/** Optional CA Certificate passphrase to create new client certs. */
	caCertPassphrase?: InputMaybe<Scalars['String']>;
	/** Optional CA Key to be used to create a client certificate. */
	caKey?: InputMaybe<Scalars['String']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** When the cert expires. */
	expiringAt?: InputMaybe<Scalars['ISO8601DateTime']>;
	/** When the cert will start being enforced. */
	startingAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** An Object. */
export type CreateClientCertificateMutationPayload = {
	__typename?: 'CreateClientCertificateMutationPayload';
	/** Created Client Certificate. */
	clientCertificate?: Maybe<ClientCertificate>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateEulaMutation */
export type CreateEulaMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Content for EULA. */
	content: Scalars['String'];
	/** Boolean value for identified update/create eula for company or system-wide. */
	forScope?: InputMaybe<Scalars['Boolean']>;
	/** Name for EULA. */
	name: Scalars['String'];
};

/** An Object. */
export type CreateEulaMutationPayload = {
	__typename?: 'CreateEulaMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted EULA. */
	eula?: Maybe<Eula>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateGroupMutation */
export type CreateGroupMutationInput = {
	/** List of GQL group ids. */
	callRecipientGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Name for group. */
	name: Scalars['String'];
	/** List of GQL group ids. */
	scenarioRecipientGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** An Object. */
export type CreateGroupMutationPayload = {
	__typename?: 'CreateGroupMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted group. */
	group?: Maybe<Group>;
	success: Scalars['Boolean'];
};

/** Integration upsert arguments. */
export type CreateIntegrationMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	config?: InputMaybe<IntegrationUpsertInputObjectConfigInput>;
	/** Description of the Integration. */
	description?: InputMaybe<Scalars['String']>;
	/** Id of the Integration. */
	id?: InputMaybe<Scalars['ID']>;
	/** Name of the Integration, generally the provider name. */
	name?: InputMaybe<Scalars['String']>;
	/** The integration provider. */
	provider: IntegrationProviderEnum;
};

/** An Object. */
export type CreateIntegrationMutationPayload = {
	__typename?: 'CreateIntegrationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Upserted Integration if the mutation is successful. */
	integration?: Maybe<Integration>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateInvitationMutation */
export type CreateInvitationMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** A boolean to determine if the user is a guest or not. */
	guest?: InputMaybe<Scalars['Boolean']>;
	/** groups requested for invitation. */
	requestedGroups: Array<Scalars['String']>;
	/** licenses requested for invitation. */
	requestedLicenses?: InputMaybe<Array<LicenseTypeEnum>>;
	/** Extra configuration options for the Licenses requested in the invitation. */
	requestedLicensesExtraData?: InputMaybe<Array<LicenseExtraDataInputObject>>;
	/** origin group requested for user. */
	requestedOriginGroup?: InputMaybe<Scalars['String']>;
	/** Fields for invitation reciever. */
	user: CreateInvitationMutationUserInput;
};

/** An Object. */
export type CreateInvitationMutationPayload = {
	__typename?: 'CreateInvitationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Invitation object if mutation is successful. */
	invitation?: Maybe<Invitation>;
	success: Scalars['Boolean'];
};

/** Autogenerated nested input type of CreateInvitationMutation */
export type CreateInvitationMutationUserInput = {
	/** Email to send invitation. */
	email: Scalars['String'];
	/** First name of receiver. */
	firstName: Scalars['String'];
	/** Job title of receiver. */
	jobTitle?: InputMaybe<Scalars['String']>;
	/** Last name of receiver. */
	lastName: Scalars['String'];
	/** Location of the receiver. */
	location?: InputMaybe<Scalars['String']>;
	/** Phone number to send invitation. */
	phone?: InputMaybe<Scalars['String']>;
	/** The sms of the user. */
	sms?: InputMaybe<Scalars['String']>;
	/** ID of the SsoDetail associated with the User. */
	ssoDetailId?: InputMaybe<Scalars['String']>;
	/** The unique identifier for the user in the SSO provider. */
	ssoUid?: InputMaybe<Scalars['String']>;
	/** Username for the new user/receiver. */
	username?: InputMaybe<Scalars['String']>;
};

/** Input object for creating a model processing job. */
export type CreateModelProcessJobMutationInput = {
	/** Database ID of the asset to be processed. */
	assetDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the asset to be processed. */
	assetId?: InputMaybe<Scalars['ID']>;
	/** Database ID of the base revision. */
	baseRevisionDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the base revision used for the processing job. */
	baseRevisionId?: InputMaybe<Scalars['ID']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Converter options to apply during processing. */
	converterOptions?: InputMaybe<Scalars['String']>;
	/** List of operations to perform on the model. */
	operations?: InputMaybe<Scalars['String']>;
	/** Name of the revision for the model processing job. */
	revisionName?: InputMaybe<Scalars['String']>;
	/** Root file name to use in the model processing job. */
	rootFileName?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type CreateModelProcessJobMutationPayload = {
	__typename?: 'CreateModelProcessJobMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The newly created model processing job. */
	modelProcessJob?: Maybe<ModelProcessJob>;
	success: Scalars['Boolean'];
};

/** Organization Create Arguments. */
export type CreateOrganizationMutationInput = {
	/** Number of days Organization Audit Logs will be retained for. */
	auditLogsRetentionPeriod?: InputMaybe<Scalars['Days']>;
	/** Boolean value enabled/disabled call recording option in organization. */
	callRecordingEnabled?: InputMaybe<Scalars['Boolean']>;
	/** Calling access for organization. */
	callingAccess?: InputMaybe<OrganizationUpsertInputObjectCallingAccessInput>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The data storage region for the Organization. Do not edit this or otherwise files might not be available. Proceed with caution! */
	dataStorageRegion?: InputMaybe<OrganizationDataStorageRegionEnum>;
	/** Default expiration duration for attachments. */
	defaultAttachmentExpirationDuration?: InputMaybe<Scalars['Days']>;
	guestAccountPolicy?: InputMaybe<OrganizationUpsertInputObjectGuestAccountPolicyInput>;
	/** Company Logo. */
	logo?: InputMaybe<Scalars['Upload']>;
	/** Name for organization. */
	name: Scalars['String'];
	/** Boolean to determine if the company is on-prem or not. */
	onPrem?: InputMaybe<Scalars['Boolean']>;
	/** Boolean value for company reopen confirmation. */
	reopen?: InputMaybe<Scalars['Boolean']>;
	/** Scenario access for organization. */
	scenarioAccess?: InputMaybe<OrganizationUpsertInputObjectScenarioAccessInput>;
	/** Type for organization. */
	type?: InputMaybe<OrganizationTypeEnum>;
};

/** An Object. */
export type CreateOrganizationMutationPayload = {
	__typename?: 'CreateOrganizationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted organization. */
	organization?: Maybe<Organization>;
	success: Scalars['Boolean'];
};

/** Organization Server License input Arguments. */
export type CreateOrganizationServerLicenseMutationInput = {
	/** calling license. */
	callingAccess?: InputMaybe<Scalars['Boolean']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** encryption key of the associated on-prem organization. */
	encryptionKey?: InputMaybe<Scalars['String']>;
	/** When the license expires. */
	expiresAt: Scalars['ISO8601DateTime'];
	/** author licenses. */
	licensesAllottedToAuthors?: InputMaybe<Scalars['Int']>;
	/** expert licenses. */
	licensesAllottedToExperts?: InputMaybe<Scalars['Int']>;
	/** tech+ licenses. */
	licensesAllottedToTechPluses?: InputMaybe<Scalars['Int']>;
	/** tech licenses. */
	licensesAllottedToTechs?: InputMaybe<Scalars['Int']>;
	/** viewer licenses. */
	licensesAllottedToViewers?: InputMaybe<Scalars['Int']>;
	/** name of the Organization Server License. */
	name: Scalars['String'];
	organizationServer: OrganizationServerLicenseUpsertInputObjectOrganizationServerInput;
	/** permalink of the associated on-prem organization. */
	permalink?: InputMaybe<Scalars['String']>;
	/** scenario access. */
	scenarioAccess?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type CreateOrganizationServerLicenseMutationPayload = {
	__typename?: 'CreateOrganizationServerLicenseMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The OrganizationServerLicense object. */
	organizationServerLicense?: Maybe<OrganizationServerLicense>;
	success: Scalars['Boolean'];
};

/** Organization Server input Arguments. */
export type CreateOrganizationServerMutationInput = {
	/** server address. */
	address?: InputMaybe<Scalars['String']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** the type of server. */
	installationType: OrganizationServerInstallationTypeEnum;
	/** the name of the server. */
	name: Scalars['String'];
};

/** An Object. */
export type CreateOrganizationServerMutationPayload = {
	__typename?: 'CreateOrganizationServerMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The OrganizationServer object. */
	organizationServer?: Maybe<OrganizationServer>;
	success: Scalars['Boolean'];
};

/** Organization SSO Details input Arguments. */
export type CreateOrganizationSsoDetailMutationInput = {
	/** The full URL for the SSO provider. */
	baseUrl?: InputMaybe<Scalars['String']>;
	/** The Client ID generated by the SSO provider for authentication. */
	clientId?: InputMaybe<Scalars['String']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The Client Secret generated by the SSO provider for authentication. */
	clientSecret?: InputMaybe<Scalars['String']>;
	config?: InputMaybe<OrganizationSsoDetailInputObjectConfigInput>;
	/** List of Organization SSO Domains. */
	domains?: InputMaybe<Array<OrganizationSsoDomainInputObject>>;
	/** The name for the SSO provider. */
	name?: InputMaybe<Scalars['String']>;
	/** The SSO provider used by the Organization. */
	providerName?: InputMaybe<SsoProviderEnum>;
	/** The Tenant ID of the Azure AD. */
	tenantId?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type CreateOrganizationSsoDetailMutationPayload = {
	__typename?: 'CreateOrganizationSsoDetailMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted SSO detail. */
	organizationSsoDetail?: Maybe<OrganizationSsoDetail>;
	success: Scalars['Boolean'];
};

/** Input object to create a photo. */
export type CreatePhotoMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** A photo image file. */
	image: Scalars['Upload'];
};

/** An Object. */
export type CreatePhotoMutationPayload = {
	__typename?: 'CreatePhotoMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The new photo. */
	photo?: Maybe<Photo>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateProductReleaseMutation */
export type CreateProductReleaseMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The content associated with the ProductRelease. */
	content?: InputMaybe<Scalars['Upload']>;
	/** External url where the ProductRelease content can be found. */
	externalUrl?: InputMaybe<Scalars['String']>;
	/** The name of the ProductRelease. */
	name: Scalars['String'];
	/** Flag to indicate whether the ProductRelease is publicly visible. */
	public?: InputMaybe<Scalars['Boolean']>;
	/** Flag to indicate whether the ProductRelease has been released. */
	released?: InputMaybe<Scalars['Boolean']>;
	/** The product type of the ProductRelease. */
	type: ProductReleaseTypeEnum;
	/** The fully qualified version of the ProductRelease. */
	version: Scalars['String'];
};

/** An Object. */
export type CreateProductReleaseMutationPayload = {
	__typename?: 'CreateProductReleaseMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The created ProductRelease. */
	productRelease?: Maybe<ProductRelease>;
	success: Scalars['Boolean'];
};

/** Input object for creating a Project Export Job. */
export type CreateProjectExportJobMutationInput = {
	/** The packaging method for assets in the project export job. */
	assetPackaging: ProjectExportJobAssetPackagingEnum;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The database ID of the project for which the export job is being created. */
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	/** The ID of the project for which the export job is being created. */
	projectId?: InputMaybe<Scalars['ID']>;
	/** The database ID of the save file for the project export job. */
	projectSaveFileDatabaseId?: InputMaybe<Scalars['String']>;
	/** The ID of the save file for the project export job. */
	projectSaveFileId?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type CreateProjectExportJobMutationPayload = {
	__typename?: 'CreateProjectExportJobMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The Project Export Job that was created. */
	projectExportJob?: Maybe<ProjectExportJob>;
	success: Scalars['Boolean'];
};

/** Input object for creating a project import job. */
export type CreateProjectImportJobMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** File name of a demo project. */
	demoProjectFileName?: InputMaybe<Scalars['String']>;
	/** File to be imported in the project import job. */
	file?: InputMaybe<Scalars['Upload']>;
	/** Database ID of the project associated with the import job. */
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the project associated with the import job. */
	projectId?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type CreateProjectImportJobMutationPayload = {
	__typename?: 'CreateProjectImportJobMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The newly created project import job. */
	projectImportJob?: Maybe<ProjectImportJob>;
	success: Scalars['Boolean'];
};

/** Input object for creating a project merge job. */
export type CreateProjectMergeJobMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** File to be imported in the project merge job. */
	file: Scalars['Upload'];
	/** Database ID of the project associated with the merge job. */
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the project associated with the merge job. */
	projectId?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type CreateProjectMergeJobMutationPayload = {
	__typename?: 'CreateProjectMergeJobMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The newly created project merge job. */
	projectMergeJob?: Maybe<ProjectMergeJob>;
	success: Scalars['Boolean'];
};

/** A project. */
export type CreateProjectMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The name of the project. When revision management is enabled, this will set the name of the revision group. */
	name?: InputMaybe<Scalars['String']>;
	/** The name of the revision group. */
	revisionGroupName?: InputMaybe<Scalars['String']>;
	/** Name assigned to the initial revision of the new project. */
	revisionName?: InputMaybe<Scalars['String']>;
	/** Notes or comments for the initial revision of the new project. */
	revisionNotes?: InputMaybe<Scalars['String']>;
	/** Database ID of the ProjectSaveFile file used as the revision source. */
	revisionSourceProjectSaveFileDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the ProjectSaveFile used as the revision source. */
	revisionSourceProjectSaveFileId?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type CreateProjectMutationPayload = {
	__typename?: 'CreateProjectMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The created project. */
	project?: Maybe<Project>;
	success: Scalars['Boolean'];
};

/** A project save file. */
export type CreateProjectSaveFileMutationInput = {
	/** The database ids of the assets in the Project. */
	assetDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	/** The ids of the assets in the Project. */
	assetIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Boolean value to determine if the save file creation should create a project duplicate. */
	duplicate?: InputMaybe<Scalars['Boolean']>;
	/** The version of the Extensions the Project was created with. */
	extensionsVersion?: InputMaybe<Scalars['String']>;
	/** The binary file data of the save file. */
	file: Scalars['Upload'];
	/** The name of the save file. */
	name: Scalars['String'];
	/** The database id of the project the save file is associated with. */
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	/** The id of the project the save file is associated with. */
	projectId?: InputMaybe<Scalars['ID']>;
	/** The type of save file. */
	saveType: ProjectSaveFileSaveTypeEnum;
	/** The version of the Create build the Project was created with. */
	scopeCreateVersion: Scalars['String'];
};

/** An Object. */
export type CreateProjectSaveFileMutationPayload = {
	__typename?: 'CreateProjectSaveFileMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The created project save file. */
	projectSaveFile?: Maybe<ProjectSaveFile>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreatePublicUserMutation */
export type CreatePublicUserMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Shortcode for resource catalog we're creating the user for (deprecated in favor of resourceShortcode). */
	resourceCatalogShortcode?: InputMaybe<Scalars['String']>;
	/** Database ID of the resource associated with the public user. */
	resourceDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the resource associated with the public user. */
	resourceId?: InputMaybe<Scalars['ID']>;
	/** Shortcode for resource we're creating the user for. */
	resourceShortcode?: InputMaybe<Scalars['String']>;
	/** Type of the resource associated with the public user. */
	resourceType?: InputMaybe<PublicResourceTypeEnum>;
};

/** An Object. */
export type CreatePublicUserMutationPayload = {
	__typename?: 'CreatePublicUserMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
	/** Authentication token for the user. */
	token?: Maybe<Scalars['String']>;
};

/** Input object for creating a render preview job. */
export type CreateRenderPreviewJobMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Rendering direction for the preview. */
	direction?: InputMaybe<Scalars['String']>;
	/** The file to use for rendering the preview. */
	file: Scalars['Upload'];
};

/** An Object. */
export type CreateRenderPreviewJobMutationPayload = {
	__typename?: 'CreateRenderPreviewJobMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The newly created render preview job. */
	renderPreviewJob?: Maybe<RenderPreviewJob>;
	success: Scalars['Boolean'];
};

/** Scenario catalog create arguments. */
export type CreateScenarioCatalogMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** String argument takes a id of external asset. */
	externalAssetId?: InputMaybe<Scalars['String']>;
	/** String argument takes a name of external asset. */
	externalAssetName?: InputMaybe<Scalars['String']>;
	/** Catalog name. */
	name: Scalars['String'];
	/** Boolean argument decide to make catalog public to all user or not. */
	public?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type CreateScenarioCatalogMutationPayload = {
	__typename?: 'CreateScenarioCatalogMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** scenario catalog instance. */
	scenarioCatalog?: Maybe<ScenarioCatalog>;
	success: Scalars['Boolean'];
};

/** Scenario create arguments. */
export type CreateScenarioMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** groups requested for scenario. */
	requestedGroups?: InputMaybe<Array<Scalars['ID']>>;
	scenario: ScenarioCreateInputObjectScenarioInput;
	/** Scope file binary for direct upload. */
	scopeFile?: InputMaybe<Scalars['Upload']>;
	/** ID of S3 uploaded scope file. */
	uploadId?: InputMaybe<Scalars['Int']>;
};

/** An Object. */
export type CreateScenarioMutationPayload = {
	__typename?: 'CreateScenarioMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Scenario object updated or created. */
	scenario?: Maybe<Scenario>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateScenarioSessionEventMutation */
export type CreateScenarioSessionEventMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Array of ScenarioSessionEventCreateInputObject types. */
	events: Array<ScenarioSessionEventCreateInputObject>;
	/** d of the scenario release for this scenario session event. */
	scenarioReleaseId: Scalars['ID'];
};

/** An Object. */
export type CreateScenarioSessionEventMutationPayload = {
	__typename?: 'CreateScenarioSessionEventMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The events created by the mutation. */
	scenarioSessionEvents?: Maybe<Array<ScenarioSessionEvent>>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateScenarioSessionPartMutation */
export type CreateScenarioSessionPartMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** JSON hash object of data to be associated with this scenario session part. */
	externalData?: InputMaybe<Scalars['JSON']>;
	/** Another way to append external data but through a string param query. */
	externalQuery?: InputMaybe<Scalars['String']>;
	/** Previous scenario session part guid. */
	previousSessionGuid?: InputMaybe<Scalars['String']>;
	/** Id of the scenario release for this scenario session part. */
	scenarioReleaseId: Scalars['ID'];
	/** Session type to apply to a newly created session. This will not apply to continued sessions. */
	sessionType?: InputMaybe<ScenarioReleaseTypeEnum>;
};

/** An Object. */
export type CreateScenarioSessionPartMutationPayload = {
	__typename?: 'CreateScenarioSessionPartMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The scenario session part created. */
	scenarioSessionPart?: Maybe<ScenarioSessionPart>;
	/** Boolean of whether the mutation succeeded. */
	success: Scalars['Boolean'];
};

/** User upsert arguments. */
export type CreateUserMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of Groups the user is requesting to join. */
	requestedGroups?: InputMaybe<Array<Scalars['String']>>;
	/** List of Licenses the user is requesting. */
	requestedLicenses?: InputMaybe<Array<LicenseTypeEnum>>;
	/** Extra configuration options for the Licenses requested by the user. */
	requestedLicensesExtraData?: InputMaybe<Array<LicenseExtraDataInputObject>>;
	/** origin group requested for user. */
	requestedOriginGroup?: InputMaybe<Scalars['String']>;
	/** Fields for user to be created. */
	user?: InputMaybe<UserCreateInputObjectUserInput>;
};

/** An Object. */
export type CreateUserMutationPayload = {
	__typename?: 'CreateUserMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
	/** Resulted user. */
	user?: Maybe<User>;
};

/** WebhookSubscription upsert arguments. */
export type CreateWebhookSubscriptionMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Set this to true and it will test the webhook request in the transaction. */
	testWebhook?: InputMaybe<Scalars['Boolean']>;
	webhookSubscription: WebhookSubscriptionUpsertInputObjectWebhookSubscriptionInput;
};

/** An Object. */
export type CreateWebhookSubscriptionMutationPayload = {
	__typename?: 'CreateWebhookSubscriptionMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
	/** The WebhookSubscription modified by the mutation. */
	webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Represents the daily usage on a particular day across licenses. */
export type DailyUsage = NodeInterface & {
	__typename?: 'DailyUsage';
	/** Number of active sessions for this scenario. */
	activeSessionsCount?: Maybe<Scalars['Int']>;
	/** Number of active work instructions sessions for this scenario. */
	activeWorkInstructionSessionCount?: Maybe<Scalars['Int']>;
	/** The User that authored the Scenario. */
	author?: Maybe<User>;
	/** A list of Scenario ScenarioCatalogs associated with the Scenario. */
	catalogs?: Maybe<ScenarioScenarioCatalogConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The ScenarioRelease to be used when creating new ScenarioSessions associated with the Scenario. */
	currentRelease?: Maybe<ScenarioRelease>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Deferred link for active scenario content. */
	deferredLink?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The description of the Scenario. */
	description?: Maybe<Scalars['String']>;
	/** Global ID of the Scenario record. This should be persistent if data is migrated and is recommended to use. */
	guid?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** User of most recently started scenario session. */
	lastAccessedBy?: Maybe<User>;
	/** The last ScenarioRelease associated with the Scenario. */
	latestRelease?: Maybe<ScenarioRelease>;
	/** The name of the Scenario. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** A list of non default Groups that can access the Scenario. */
	nonOriginGroups?: Maybe<ScenarioGroupConnection>;
	/** The Organization associated with the Scenario. */
	organization?: Maybe<Organization>;
	/** The origin Group associated with the Scenario. */
	originGroup?: Maybe<Group>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the DailyUsage. */
	permissions: DailyUsagePermissions;
	/** The Scenario's plan usage status. */
	planUsageStatus?: Maybe<PlanUsageStatusEnum>;
	/** The Project associated with the Scenario. */
	project?: Maybe<Project>;
	/** Whether the Scenario belongs to a public Catalog. */
	public?: Maybe<Scalars['Boolean']>;
	/** The date and time when the first ScenarioRelease associated with the Scenario was published. */
	publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Link to download qr code for the current release. */
	qrCodeImageLink?: Maybe<Scalars['String']>;
	/** A list of Groups that can access the Scenario. */
	recipientGroups?: Maybe<ScenarioGroupConnection>;
	/** A list of Groups except origin group that can access the Scenario. */
	recipientGroupsWithoutOriginGroup?: Maybe<ScenarioGroupConnection>;
	/** The date and time when the Scenario was first released. */
	releasedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of ScenarioReleases associated with the Scenario. */
	releases?: Maybe<ScenarioScenarioReleaseConnection>;
	/** The resource permissions for the Scenario. */
	resourcePermissions?: Maybe<Array<ResourcePermission>>;
	/** Name of the revision group associated with the scenario. */
	revisionGroupName?: Maybe<Scalars['String']>;
	/** Name of the current Scenario revision. */
	revisionName?: Maybe<Scalars['String']>;
	/** Notes or comments associated with the current Scenario revision. */
	revisionNotes?: Maybe<Scalars['String']>;
	/** List of revisions associated with the Scenario. */
	revisions?: Maybe<Array<Scenario>>;
	/** Attached scope file of latest version. */
	scopeFile?: Maybe<Scalars['String']>;
	/** A list of ScenarioSequences associated with the ScenarioRelease. */
	sequences?: Maybe<ScenarioScenarioSequenceConnection>;
	/** A list of ScenarioSessions associated with the Scenario. */
	sessions?: Maybe<ScenarioScenarioSessionConnection>;
	/** Number of ScenarioSessions associated with the Scenario. */
	sessionsCount?: Maybe<Scalars['Int']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The shortcode of the Scenario. */
	shortcode?: Maybe<Scalars['String']>;
	/** The state of the Scenario based on the associated Project. */
	state?: Maybe<ProjectStateEnum>;
	/** A list of ScenarioSteps associated with the ScenarioRelease. */
	steps?: Maybe<ScenarioScenarioStepConnection>;
	/** The number of steps within the scenario. */
	totalSteps?: Maybe<Scalars['Int']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The most recent version of the scenario. */
	version?: Maybe<Scalars['Int']>;
	/** A Json object that has the licenses and views. */
	views?: Maybe<Scalars['JSON']>;
	/** A list of ScenarioSessionParts associated with the Scenario. */
	workInstructionSessions?: Maybe<ScenarioScenarioSessionPartConnection>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageCatalogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageNonOriginGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageRecipientGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageRecipientGroupsWithoutOriginGroupArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageRevisionsArgs = {
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageSequencesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	externalData?: InputMaybe<ScenarioSessionsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionsUserInput>;
	versions?: InputMaybe<Array<Scalars['Int']>>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	externalData?: InputMaybe<Scalars['JSON']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	type?: InputMaybe<ScenarioStepTypeEnum>;
};


/** Represents the daily usage on a particular day across licenses. */
export type DailyUsageWorkInstructionSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	excludeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	externalData?: InputMaybe<ScenarioSessionPartsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	includeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionPartsUserInput>;
};

/** A connection from an Organization Scenarios Daily Usages. */
export type DailyUsageConnection = {
	__typename?: 'DailyUsageConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationDailyUsageEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<DailyUsage>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the DailyUsageConnection. */
	permissions: DailyUsageConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
	/** An object including company wide daily usage stats. */
	totalViews?: Maybe<Scalars['JSON']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type DailyUsageConnectionPermissions = {
	__typename?: 'DailyUsageConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type DailyUsagePermissions = {
	__typename?: 'DailyUsagePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Scenarios daily usage query arguments. */
export type DailyUsageQueryInputObject = {
	/** Used by the Worklink App to correctly return a list of scenarios for display purposes. */
	appList?: InputMaybe<Scalars['Boolean']>;
	/** Array of GQL scenario author ids. */
	authorIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A Catalog ID. */
	catalogId?: InputMaybe<Scalars['ID']>;
	/** Array of scenario database ids. */
	databaseIds?: InputMaybe<Array<Scalars['Int']>>;
	/** A date range. */
	dateRange?: InputMaybe<DateRangeInputObject>;
	/** Array of excluded GQL scenario catalog ids. */
	excludeCatalogIds?: InputMaybe<Array<Scalars['ID']>>;
	/** Array of excluded GQL scenario group ids. */
	excludeGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
	/** Exclude sessions that belong to ScopeAR users. */
	filterOutScope?: InputMaybe<Scalars['Boolean']>;
	/** String matching the name of a Scenario. */
	fullText?: InputMaybe<Scalars['String']>;
	/** Array of GQL scenario group ids. */
	groupIds?: InputMaybe<Array<Scalars['ID']>>;
	/** Array of GQL scenario ids. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
	/** A boolean input to also get deleted Scenarios. */
	includeDeleted?: InputMaybe<Scalars['Boolean']>;
	/** Include Scenarios without sessions, deleted and unreleased. */
	includeEmptyScenarios?: InputMaybe<Scalars['Boolean']>;
	/** A boolean input to get a list with only the latest revision of each scenario. */
	latestRevisionOnly?: InputMaybe<Scalars['Boolean']>;
	/** A sort order input object. */
	orderBy?: InputMaybe<SortOrderInputObject>;
	/** A distinct list of scenario origin group ids. */
	originGroupIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A list of plan usage statuses. */
	planUsageStatus?: InputMaybe<Array<PlanUsageStatusEnum>>;
	/** A boolean input to get only Public or Private Scenarios. */
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	/** A boolean input to get only published Scenarios. */
	published?: InputMaybe<Scalars['Boolean']>;
	/** A date range input object with starting and ending published at values. */
	publishedAt?: InputMaybe<DateRangeInputObject>;
	/** A boolean input to get only released Scenarios. */
	released?: InputMaybe<Scalars['Boolean']>;
	/** A date range input object with starting and ending released at values. */
	releasedAt?: InputMaybe<DateRangeInputObject>;
	/** A list of project states. */
	states?: InputMaybe<Array<ScenarioStateEnum>>;
	/** A list of work instruction types. */
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};

/** Date Range. */
export type DateRangeInputObject = {
	/** Ending datetime string in ISO8601 format. */
	endingAt: Scalars['ISO8601DateTime'];
	/** Staring datetime string in ISO8601 format. */
	startingAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of DeleteApiTokenMutation */
export type DeleteApiTokenMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** API Token ID. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteApiTokenMutationPayload = {
	__typename?: 'DeleteApiTokenMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteApiTokensMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteApiTokensMutationPayload = {
	__typename?: 'DeleteApiTokensMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** The items that were not deleted due to an error. */
	undeletedItems?: Maybe<Array<ApiToken>>;
};

/** Autogenerated input type of DeleteAssetMutation */
export type DeleteAssetMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database ID of the asset to delete. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** ID of the asset to delete. */
	id?: InputMaybe<Scalars['ID']>;
	/** Boolean flag indicating whether the deletion should be permanent. */
	permanent?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type DeleteAssetMutationPayload = {
	__typename?: 'DeleteAssetMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteAssetsMutation */
export type DeleteAssetsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of database IDs for assets to delete. */
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	/** List of asset IDs to delete. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
	/** Boolean flag indicating whether the deletions should be permanent. */
	permanent?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type DeleteAssetsMutationPayload = {
	__typename?: 'DeleteAssetsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Indicates if the assets were successfully deleted. */
	success: Scalars['Boolean'];
	/** List of assets that could not be deleted. */
	undeletedItems?: Maybe<Array<Asset>>;
};

/** Autogenerated input type of DeleteCallMutation */
export type DeleteCallMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Call id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteCallMutationPayload = {
	__typename?: 'DeleteCallMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteCallPhotosMutation */
export type DeleteCallPhotosMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of GQL call photo ids. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteCallPhotosMutationPayload = {
	__typename?: 'DeleteCallPhotosMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** The items that were not deleted due to an error. is false. */
	undeletedItems?: Maybe<Array<CallPhoto>>;
};

/** Autogenerated input type of DeleteCallRecordingsMutation */
export type DeleteCallRecordingsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of GQL call recording ids. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteCallRecordingsMutationPayload = {
	__typename?: 'DeleteCallRecordingsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** The items that were not deleted due to an error. is false. */
	undeletedItems?: Maybe<Array<CallRecording>>;
};

/** Autogenerated input type of DeleteCallsMutation */
export type DeleteCallsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of GQL calls ids. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteCallsMutationPayload = {
	__typename?: 'DeleteCallsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** The items that were not deleted due to an error. is false. */
	undeletedItems?: Maybe<Array<Call>>;
};

/** Autogenerated input type of DeleteClientCertificateMutation */
export type DeleteClientCertificateMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The ID of the Client Certificate to be deleted. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteClientCertificateMutationPayload = {
	__typename?: 'DeleteClientCertificateMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteEulaMutation */
export type DeleteEulaMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Eula id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteEulaMutationPayload = {
	__typename?: 'DeleteEulaMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteGroupMutation */
export type DeleteGroupMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Group id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteGroupMutationPayload = {
	__typename?: 'DeleteGroupMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteGroupsMutation */
export type DeleteGroupsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of GQL group ids. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteGroupsMutationPayload = {
	__typename?: 'DeleteGroupsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of groups to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<Group>>;
};

/** Autogenerated input type of DeleteIntegrationMutation */
export type DeleteIntegrationMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Integration id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteIntegrationMutationPayload = {
	__typename?: 'DeleteIntegrationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteIntegrationsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteIntegrationsMutationPayload = {
	__typename?: 'DeleteIntegrationsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of Integrations to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<Integration>>;
};

/** Any record object. */
export type DeleteInvitationsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteInvitationsMutationPayload = {
	__typename?: 'DeleteInvitationsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Whether the operation succeeded or not. */
	success: Scalars['Boolean'];
	/** The items that were not deleted due to an error. */
	undeletedItems?: Maybe<Array<Invitation>>;
};

/** Autogenerated input type of DeleteOrganizationServerLicenseMutation */
export type DeleteOrganizationServerLicenseMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** OrganizationServerLicense id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteOrganizationServerLicenseMutationPayload = {
	__typename?: 'DeleteOrganizationServerLicenseMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteOrganizationServerLicensesMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteOrganizationServerLicensesMutationPayload = {
	__typename?: 'DeleteOrganizationServerLicensesMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of OrganizationServerLicenses to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<OrganizationServer>>;
};

/** Autogenerated input type of DeleteOrganizationServerMutation */
export type DeleteOrganizationServerMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The ID of the OrganizationServer to delete. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteOrganizationServerMutationPayload = {
	__typename?: 'DeleteOrganizationServerMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteOrganizationServersMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteOrganizationServersMutationPayload = {
	__typename?: 'DeleteOrganizationServersMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of OrganizationServers to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<OrganizationServer>>;
};

/** Autogenerated input type of DeleteOrganizationSsoDetailMutation */
export type DeleteOrganizationSsoDetailMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Id of WebhookError to delete. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteOrganizationSsoDetailMutationPayload = {
	__typename?: 'DeleteOrganizationSsoDetailMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteOrganizationSsoDetailsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteOrganizationSsoDetailsMutationPayload = {
	__typename?: 'DeleteOrganizationSsoDetailsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of calls to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<OrganizationSsoDetail>>;
};

/** Autogenerated input type of DeletePhotosMutation */
export type DeletePhotosMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Group of Photo ids. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeletePhotosMutationPayload = {
	__typename?: 'DeletePhotosMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of photos to be displayed by the UI when success. */
	undeletedItems?: Maybe<Array<Photo>>;
};

/** Autogenerated input type of DeleteProductReleaseMutation */
export type DeleteProductReleaseMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** ProductRelease id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteProductReleaseMutationPayload = {
	__typename?: 'DeleteProductReleaseMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteProductReleasesMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteProductReleasesMutationPayload = {
	__typename?: 'DeleteProductReleasesMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of ProductReleases to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<ProductRelease>>;
};

/** Autogenerated input type of DeleteProjectMutation */
export type DeleteProjectMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database Id of project. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** Id of project. */
	id?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type DeleteProjectMutationPayload = {
	__typename?: 'DeleteProjectMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteProjectsMutation */
export type DeleteProjectsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database Ids of projects to delete. */
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	/** Ids of projects to delete. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
};

/** An Object. */
export type DeleteProjectsMutationPayload = {
	__typename?: 'DeleteProjectsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of projects to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<Project>>;
};

/** Autogenerated input type of DeleteScenarioCatalogMutation */
export type DeleteScenarioCatalogMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Catalog id which need to be delete. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteScenarioCatalogMutationPayload = {
	__typename?: 'DeleteScenarioCatalogMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteScenarioMutation */
export type DeleteScenarioMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Id of scenario. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteScenarioMutationPayload = {
	__typename?: 'DeleteScenarioMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteScenarioReleaseMutation */
export type DeleteScenarioReleaseMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Id of scenario release. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteScenarioReleaseMutationPayload = {
	__typename?: 'DeleteScenarioReleaseMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteScenarioSessionMutation */
export type DeleteScenarioSessionMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Scenario Session id. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteScenarioSessionMutationPayload = {
	__typename?: 'DeleteScenarioSessionMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteScenarioSessionsMutation */
export type DeleteScenarioSessionsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of GQL scenario session ids. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteScenarioSessionsMutationPayload = {
	__typename?: 'DeleteScenarioSessionsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of scenario sessions to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<ScenarioSession>>;
};

/** Autogenerated input type of DeleteScenariosMutation */
export type DeleteScenariosMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of scenario to delete. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteScenariosMutationPayload = {
	__typename?: 'DeleteScenariosMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of scenarios to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<Scenario>>;
};

/** Autogenerated input type of DeleteUsersMutation */
export type DeleteUsersMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of user emails. */
	emails?: InputMaybe<Array<Scalars['String']>>;
	/** List of GQL user ids. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
	/** List of user usernames. */
	usernames?: InputMaybe<Array<Scalars['String']>>;
};

/** An Object. */
export type DeleteUsersMutationPayload = {
	__typename?: 'DeleteUsersMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of users to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<User>>;
};

/** Autogenerated input type of DeleteWebhookErrorMutation */
export type DeleteWebhookErrorMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Id of WebhookError to delete. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteWebhookErrorMutationPayload = {
	__typename?: 'DeleteWebhookErrorMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteWebhookErrorsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteWebhookErrorsMutationPayload = {
	__typename?: 'DeleteWebhookErrorsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of calls to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<WebhookError>>;
};

/** Autogenerated input type of DeleteWebhookSubscriptionMutation */
export type DeleteWebhookSubscriptionMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Id of WebhookSubscription to delete. */
	id: Scalars['ID'];
};

/** An Object. */
export type DeleteWebhookSubscriptionMutationPayload = {
	__typename?: 'DeleteWebhookSubscriptionMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Any record object. */
export type DeleteWebhookSubscriptionsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the records. */
	ids: Array<Scalars['ID']>;
};

/** An Object. */
export type DeleteWebhookSubscriptionsMutationPayload = {
	__typename?: 'DeleteWebhookSubscriptionsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
	/** List of WebhookSubscriptions to be displayed by the UI when success is false. */
	undeletedItems?: Maybe<Array<WebhookSubscription>>;
};

/** A graph_element composed of other objects. */
export type DemoProject = {
	__typename?: 'DemoProject';
	/** The primary file associated with the demo project. */
	file?: Maybe<Attachment>;
	/** A JSON file containing metadata for the demo project. */
	jsonFile?: Maybe<Attachment>;
	/** The file name of the demo project. */
	name?: Maybe<Scalars['String']>;
	/** A preview image for the demo project. */
	previewFile?: Maybe<Attachment>;
};

/** Represents a physical Device (e.g. an iPhone). */
export type Device = NodeInterface & {
	__typename?: 'Device';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The identifier of the Device. */
	identifier?: Maybe<Scalars['String']>;
	/** The model of the Device. */
	model?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/**
   * The Organization associated with the Device.
   * @deprecated Not yet implemented.
   */
	organization?: Maybe<Organization>;
	/** The os of the Device. */
	os?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Device. */
	permissions: DevicePermissions;
	/** The platform type of the device. */
	platform?: Maybe<PlatformTypeEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type DevicePermissions = {
	__typename?: 'DevicePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Represents a temporary access to embedded analytics (metabase). */
export type EmbeddedAnalytics = {
	__typename?: 'EmbeddedAnalytics';
	/** EmbeddedAnalyticsDashboard for calling dashboard analytics. */
	callingDashboard?: Maybe<EmbeddedAnalyticsDashboard>;
	/** EmbeddedAnalyticsDashboard for organization dashboard analytics. */
	organizationDashboard?: Maybe<EmbeddedAnalyticsDashboard>;
	/** EmbeddedAnalyticsDashboard for scenarios dashboard analytics. */
	scenariosDashboard?: Maybe<EmbeddedAnalyticsDashboard>;
};

/** Represents a temporary access to an embedded analytics dashboard (metabase). */
export type EmbeddedAnalyticsDashboard = {
	__typename?: 'EmbeddedAnalyticsDashboard';
	/** URL for the embedded analytics dashboard. */
	url?: Maybe<Scalars['Url']>;
};

/** Object representing an error encountered. */
export type Error = {
	__typename?: 'Error';
	/** A human-readable message to display. E.g. 'Email is already in use'. */
	fullMessage: Scalars['String'];
	/** A human-readable message without attribute. E.g. 'is already in use'. */
	message: Scalars['String'];
	/** Which argument is caused error. E.g. ['reciever', 'email']. */
	path: Array<Scalars['String']>;
	/** Error type. E.g. 'taken'. */
	type?: Maybe<Scalars['String']>;
};

/** Represents an end-User License agreement. */
export type Eula = NodeInterface & {
	__typename?: 'Eula';
	/** The content of the Eula. */
	content?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the Eula. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The index of the Eula within the context of an Organization & EulaProduct. */
	orderIndex?: Maybe<Scalars['Int']>;
	/** The Organization associated with the Eula. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Eula. */
	permissions: EulaPermissions;
	/**
   * The products that the Eula is applicable to.
   * @deprecated Not yet implemented.
   */
	products?: Maybe<Array<EulaProductEnum>>;
	/** A list of EulaPrompts associated with the Eula. */
	prompts?: Maybe<EulaEulaPromptConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents an end-User License agreement. */
export type EulaPromptsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type EulaEulaPromptConnection = {
	__typename?: 'EulaEulaPromptConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<EulaEulaPromptEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<EulaPrompt>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the EulaEulaPromptConnection. */
	permissions: EulaEulaPromptConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type EulaEulaPromptConnectionPermissions = {
	__typename?: 'EulaEulaPromptConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type EulaEulaPromptEdge = {
	__typename?: 'EulaEulaPromptEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<EulaPrompt>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type EulaPermissions = {
	__typename?: 'EulaPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum EulaProductEnum {
	/** Worklink Classic. */
	WorklinkClassic = 'WORKLINK_CLASSIC',
	/** Worklink Create. */
	WorklinkCreate = 'WORKLINK_CREATE',
	/** Worklink Prime. */
	WorklinkPrime = 'WORKLINK_PRIME'
}

/** Represents an end-User License agreement that has been presented to a User. */
export type EulaPrompt = NodeInterface & {
	__typename?: 'EulaPrompt';
	/** Whether the User agreed to the EualPrompt. */
	agreed?: Maybe<Scalars['Boolean']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The Eula associated with the EulaPrompt. */
	eula?: Maybe<Eula>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the EulaPrompt. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the EulaPrompt. */
	permissions: EulaPromptPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User associated with the EulaPrompt. */
	user?: Maybe<User>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type EulaPromptPermissions = {
	__typename?: 'EulaPromptPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Feature flag. */
export type FeatureFlagInputObject = {
	/** Is feature enabled. */
	enabled: Scalars['Boolean'];
	/** Feature name. */
	name: Scalars['String'];
};

/** Represents Feedback provided by a User. */
export type Feedback = NodeInterface & {
	__typename?: 'Feedback';
	/** The written content of the Feedback. */
	content?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The efficiency rating of the Feedback. */
	efficiencyRating?: Maybe<StarRatingEnum>;
	/** The average bitrate experienced by the User. */
	externalData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the Feedback. */
	organization?: Maybe<Organization>;
	/** The object that the Feedback belongs to. */
	owner?: Maybe<FeedbackOwner>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Feedback. */
	permissions: FeedbackPermissions;
	/** The quality rating of the Feedback. */
	qualityRating?: Maybe<StarRatingEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A union of types that have a Feedback. */
export type FeedbackOwner = Call;

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type FeedbackPermissions = {
	__typename?: 'FeedbackPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum FileSourceEnum {
	/** Request a private URL for the file. */
	Private = 'PRIVATE',
	/** Request a public URL for the file. */
	Public = 'PUBLIC'
}

/** Autogenerated input type of FindOrCreateReviewMutation */
export type FindOrCreateReviewMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	review: FindOrCreateReviewMutationReviewInput;
	reviewable: FindOrCreateReviewMutationReviewableInput;
};

/** An Object. */
export type FindOrCreateReviewMutationPayload = {
	__typename?: 'FindOrCreateReviewMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The review object along with the reviewable properties. */
	review?: Maybe<ReviewReviewable>;
	success: Scalars['Boolean'];
};

/** Autogenerated nested input type of FindOrCreateReviewMutation */
export type FindOrCreateReviewMutationReviewInput = {
	/** Unique identifier to the review. Used to look up the review. */
	key: Scalars['String'];
};

/** Autogenerated nested input type of FindOrCreateReviewMutation */
export type FindOrCreateReviewMutationReviewableInput = {
	/** Database ID of the reviewable object record. This will change if the data is migrated. */
	databaseId?: InputMaybe<Scalars['ID']>;
	/** Global ID of the reviewable object record. This should be persistent if data is migrated and is recommended to use. */
	id?: InputMaybe<Scalars['ID']>;
	/** The class name of the reviewable object. */
	type: Scalars['String'];
};

/** Represents a set of Groups. */
export type Group = NodeInterface & {
	__typename?: 'Group';
	/** A list of Group Ids associated with the Group through a GroupPolicy of type Calls. */
	callRecipientGroupsIds?: Maybe<Array<Scalars['ID']>>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Whether the Group is the company's Default Group. */
	default?: Maybe<Scalars['Boolean']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Global ID of the Group record. This should be persistent if data is migrated and is recommended to use. */
	guid?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** A list of Users that are associated with the Group. */
	members?: Maybe<GroupUserConnection>;
	/** The name of the Group. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the Group. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Group. */
	permissions: GroupPermissions;
	/** A list of Group policies associated with the Group. */
	policies?: Maybe<GroupGroupPolicyConnection>;
	/** A list of Groups associated with the Group through a GroupPolicy of type Scenarios. */
	scenarioRecipientGroups?: Maybe<GroupGroupConnection>;
	/** A list of Group Ids associated with the Group through a GroupPolicy of type Scenarios. */
	scenarioRecipientGroupsIds?: Maybe<Array<Scalars['ID']>>;
	/** A list of Scenarios originated in the Group. */
	scenarios?: Maybe<GroupScenarioConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** A list of Scenarios viewable by with the Group members. */
	viewableScenarios?: Maybe<GroupScenarioConnection>;
};


/** Represents a set of Groups. */
export type GroupMembersArgs = {
	active?: InputMaybe<Scalars['Boolean']>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	emails?: InputMaybe<Array<Scalars['String']>>;
	excludeGroups?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	groupNames?: InputMaybe<Array<Scalars['String']>>;
	groups?: InputMaybe<Array<Scalars['String']>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	jobTitles?: InputMaybe<Array<Scalars['String']>>;
	last?: InputMaybe<Scalars['Int']>;
	licenseTypes?: InputMaybe<Array<LicenseTypeEnum>>;
	memberType?: InputMaybe<MemberTypeEnum>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	originGroupIds?: InputMaybe<Array<Scalars['ID']>>;
	usernames?: InputMaybe<Array<Scalars['String']>>;
};


/** Represents a set of Groups. */
export type GroupPoliciesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of Groups. */
export type GroupScenarioRecipientGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of Groups. */
export type GroupScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** Represents a set of Groups. */
export type GroupViewableScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type GroupGroupConnection = {
	__typename?: 'GroupGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<GroupGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the GroupGroupConnection. */
	permissions: GroupGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type GroupGroupConnectionPermissions = {
	__typename?: 'GroupGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type GroupGroupEdge = {
	__typename?: 'GroupGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A connection from a Node. */
export type GroupGroupPolicyConnection = {
	__typename?: 'GroupGroupPolicyConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<GroupGroupPolicyEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<GroupPolicy>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the GroupGroupPolicyConnection. */
	permissions: GroupGroupPolicyConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type GroupGroupPolicyConnectionPermissions = {
	__typename?: 'GroupGroupPolicyConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type GroupGroupPolicyEdge = {
	__typename?: 'GroupGroupPolicyEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<GroupPolicy>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type GroupPermissions = {
	__typename?: 'GroupPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/**
 * Represents privileges that govern interactions between Groups.
 * 
 * The presence of a record indicates that members of the recipient Group maybe granted access to Scenarios managed by the origin Group, or initiate Calls with the origin Group members (depending on the type of policy). The presence of a record also indicates that Admins may transwer management of Scenarios to the recipient Group &/ Group members.
 * 
 * Note that the presence of a record does not in and of itself grant Scenario access to recipient Group members, only that access may be granted.
 * 
 * ●      Group Policies are individual (i.e. A => B and A => C are two separate policies)
 * ●       Group Policies are directional (i.e. A => B does not enable B => A)
 * ●       Group Policies are non-transitive (i.e. A => B and B => C doesn’t allow A => C).
 */
export type GroupPolicy = NodeInterface & {
	__typename?: 'GroupPolicy';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the GroupPolicy. */
	organization?: Maybe<Organization>;
	/** The Group that orginated the GroupPolicy. */
	originGroup?: Maybe<Group>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the GroupPolicy. */
	permissions: GroupPolicyPermissions;
	/** The Group that received the GroupPolicy. */
	recipientGroup?: Maybe<Group>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/**
   * The type of the GroupPolicy.
   * @deprecated Not yet implemented.
   */
	type?: Maybe<GroupPolicyTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type GroupPolicyPermissions = {
	__typename?: 'GroupPolicyPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum GroupPolicyTypeEnum {
	/** A GroupPolicy that applies to Calls. */
	Calls = 'CALLS',
	/** A GroupPolicy that is inactive. */
	Inactive = 'INACTIVE',
	/** A GroupPolicy that applies to Scenario sessions. */
	Scenarios = 'SCENARIOS'
}

/** A connection from a Node. */
export type GroupScenarioConnection = {
	__typename?: 'GroupScenarioConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<GroupScenarioEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Scenario>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the GroupScenarioConnection. */
	permissions: GroupScenarioConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type GroupScenarioConnectionPermissions = {
	__typename?: 'GroupScenarioConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type GroupScenarioEdge = {
	__typename?: 'GroupScenarioEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Scenario>;
};

/** A connection from a Node. */
export type GroupUserConnection = {
	__typename?: 'GroupUserConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<GroupUserEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<User>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the GroupUserConnection. */
	permissions: GroupUserConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type GroupUserConnectionPermissions = {
	__typename?: 'GroupUserConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type GroupUserEdge = {
	__typename?: 'GroupUserEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<User>;
};

/** Represents a digital asset associated with an object (e.g. a text file, photo, screenshot, etc.). */
export type ImageAttachment = {
	__typename?: 'ImageAttachment';
	/**
   * The User that authored the Attachment.
   * @deprecated Not yet implemented.
   */
	author?: Maybe<User>;
	/** The content type of the file associated with the Attachment. */
	fileContentType?: Maybe<Scalars['String']>;
	/** The number of times the file associated with the Attachment has been downloaded. */
	fileDownloadCount?: Maybe<Scalars['Int']>;
	/** The checksum of the file associated with the Attachment. */
	fileFingerprint?: Maybe<Scalars['String']>;
	/** The name of the file associated with the Attachment. */
	fileName?: Maybe<Scalars['String']>;
	/** The size of the file associated with the Attachment in bytes. */
	fileSize?: Maybe<Scalars['Int']>;
	/** The date and time when the file associated with the Attachment was last updated. */
	fileUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The authorized url of the Attachment. */
	fileUrl?: Maybe<Scalars['Url']>;
	/** The date and time when the authorized url of the Attachment expires. */
	fileUrlExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The name of the Attachment. */
	name?: Maybe<Scalars['String']>;
	/**
   * The Organization associated with the Attachment.
   * @deprecated Not yet implemented.
   */
	organization?: Maybe<Organization>;
	/**
   * The object that the Attachment belongs to.
   * @deprecated Not yet implemented.
   */
	owner?: Maybe<AttachmentOwner>;
	/**
   * A list of SharedAttachments associated with the Attachment.
   * @deprecated Not yet implemented.
   */
	shares?: Maybe<ImageAttachmentSharedAttachmentConnection>;
	/**
   * The type of the Attachment.
   * @deprecated Not yet implemented.
   */
	type?: Maybe<AttachmentTypeEnum>;
};


/** Represents a digital asset associated with an object (e.g. a text file, photo, screenshot, etc.). */
export type ImageAttachmentSharesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type ImageAttachmentSharedAttachmentConnection = {
	__typename?: 'ImageAttachmentSharedAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ImageAttachmentSharedAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<SharedAttachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ImageAttachmentSharedAttachmentConnection. */
	permissions: ImageAttachmentSharedAttachmentConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ImageAttachmentSharedAttachmentConnectionPermissions = {
	__typename?: 'ImageAttachmentSharedAttachmentConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ImageAttachmentSharedAttachmentEdge = {
	__typename?: 'ImageAttachmentSharedAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<SharedAttachment>;
};

/** Represents an integration with a 3rd party provider. */
export type Integration = NodeInterface & {
	__typename?: 'Integration';
	/** Set of configuration attributes. */
	config?: Maybe<IntegrationConfiguration>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The description of the Integration. */
	description?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the Integration, generally the provider name. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the Integration. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Integration. */
	permissions: IntegrationPermissions;
	/** The integration provider. */
	provider?: Maybe<IntegrationProviderEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User associated with the Integration. */
	user?: Maybe<User>;
	/** The list of associated Webhook Subscriptions. */
	webhookSubscriptions?: Maybe<IntegrationWebhookSubscriptionConnection>;
};


/** Represents an integration with a 3rd party provider. */
export type IntegrationWebhookSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

export enum IntegrationAuthModeEnum {
	/** Authorization mode using the Oauth2 protocol. */
	Oauth2 = 'OAUTH2',
	/** Authorization mode using a shared secret key. */
	SharedSecret = 'SHARED_SECRET'
}

/** Represents the configuration attributes of an Integration. */
export type IntegrationConfiguration = {
	__typename?: 'IntegrationConfiguration';
	/** The email of an administrator in the Provider. */
	adminEmail?: Maybe<Scalars['String']>;
	/** Type of API authorization protocol. */
	authMode?: Maybe<IntegrationAuthModeEnum>;
	/** Base API URL of the provider. */
	baseUrl?: Maybe<Scalars['String']>;
	/** Authorization configuration attributes when the selected authorization mode is Oauth2. */
	oauth2?: Maybe<Scalars['JSON']>;
	/** Secret key used when the selected authorization mode is Shared Secret. */
	sharedSecret?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type IntegrationPermissions = {
	__typename?: 'IntegrationPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum IntegrationProviderEnum {
	/** Custom integration. */
	Custom = 'CUSTOM',
	/** Integration with Docebo. */
	Docebo = 'DOCEBO'
}

/** Autogenerated nested input type of IntegrationUpsertInputObject */
export type IntegrationUpsertInputObjectConfigInput = {
	/** The email of an administrator in the Provider. */
	adminEmail?: InputMaybe<Scalars['String']>;
	/** Type of API authorization protocol. */
	authMode?: InputMaybe<IntegrationAuthModeEnum>;
	/** Base API URL of the provider.. */
	baseUrl?: InputMaybe<Scalars['String']>;
	oauth2?: InputMaybe<IntegrationUpsertInputObjectConfigInputOauth2Input>;
	/** Secret key used when the selected authorization mode is Shared Secret. */
	sharedSecret?: InputMaybe<Scalars['String']>;
};

/** Autogenerated nested input type of IntegrationUpsertInputObjectConfigInput */
export type IntegrationUpsertInputObjectConfigInputOauth2Input = {
	/** Enconding algorithm for JWT bearer grant type. */
	assertionAlgorithm?: InputMaybe<Oauth2AssertionAlgorithmEnum>;
	/** Private key for JWT bearer grant type. */
	assertionPrivateKey?: InputMaybe<Scalars['String']>;
	/** Liquid template used to generate a profile JSON for JWT bearer grant type. */
	assertionTemplate?: InputMaybe<Scalars['String']>;
	/** Oauth2 client ID. */
	clientId: Scalars['String'];
	/** Oauth2 client secret. */
	clientSecret: Scalars['String'];
	/** Oauth2 grant type. */
	grantType: Oauth2GrantTypeEnum;
	/** JSON object for extra Oauth2 configuration options. */
	options?: InputMaybe<Scalars['JSON']>;
	/** Authentication password used for Password grant type. */
	password?: InputMaybe<Scalars['String']>;
	/** The internal API path to obtain an access token. */
	tokenUrl?: InputMaybe<Scalars['String']>;
	/** Authentication username used for Password grant type. */
	username?: InputMaybe<Scalars['String']>;
};

/** A connection from a Node. */
export type IntegrationWebhookSubscriptionConnection = {
	__typename?: 'IntegrationWebhookSubscriptionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<IntegrationWebhookSubscriptionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookSubscription>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the IntegrationWebhookSubscriptionConnection. */
	permissions: IntegrationWebhookSubscriptionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type IntegrationWebhookSubscriptionConnectionPermissions = {
	__typename?: 'IntegrationWebhookSubscriptionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type IntegrationWebhookSubscriptionEdge = {
	__typename?: 'IntegrationWebhookSubscriptionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookSubscription>;
};

/** Represents an Invitation for someone to become a User. */
export type Invitation = NodeInterface & {
	__typename?: 'Invitation';
	/** When the invitation was created and sent. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The destination that the Invitation was sent to (e.g. an email address, phone number, etc.). */
	destination?: Maybe<Scalars['String']>;
	/** The email of the user that will receive the invitation. */
	email?: Maybe<Scalars['String']>;
	/** The date and time when the Invitation expires. */
	expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Metadata associated with the invitation. Includes the job title, groups and origin group. */
	extraData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Licenses associated with the invited user. */
	licenses?: Maybe<InvitationLicenseConnection>;
	/** Location of the user that will receive the invitation. */
	location?: Maybe<Scalars['String']>;
	/** The full name of the user that will receive the invitation. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the Invitation. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Invitation. */
	permissions: InvitationPermissions;
	/** The phone number of the user that will receive the invitation. */
	phone?: Maybe<Scalars['String']>;
	/** The pin code of the Invitation (only published for PIN type). */
	pin?: Maybe<Scalars['String']>;
	/** The User that received the Invitation. */
	receiver?: Maybe<User>;
	/** The User that sent the Invitation. */
	sender?: Maybe<User>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/**
   * The state of the Invitation.
   * 
   * The default value is "PENDING".
   */
	state?: Maybe<InvitationStateEnum>;
	/**
   * The type of the Invitation.
   * 
   * The default value is "EMAIL".
   */
	type?: Maybe<InvitationTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** User record that has been created from this invitation. */
	user?: Maybe<User>;
};


/** Represents an Invitation for someone to become a User. */
export type InvitationLicensesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type InvitationLicenseConnection = {
	__typename?: 'InvitationLicenseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<InvitationLicenseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<License>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the InvitationLicenseConnection. */
	permissions: InvitationLicenseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type InvitationLicenseConnectionPermissions = {
	__typename?: 'InvitationLicenseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type InvitationLicenseEdge = {
	__typename?: 'InvitationLicenseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<License>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type InvitationPermissions = {
	__typename?: 'InvitationPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum InvitationStateEnum {
	/** An Invitation accepted by receiver. */
	Accepted = 'ACCEPTED',
	/** An Invitation canceled by administrator. */
	Cancelled = 'CANCELLED',
	/** An invitiation that expired (before being accepted). */
	Expired = 'EXPIRED',
	/** An Invitation that failed to send. */
	Failed = 'FAILED',
	/** An Invitation that is pending acceptance by receiver. */
	Pending = 'PENDING'
}

export enum InvitationTypeEnum {
	/** An Invitation sent via email. */
	Email = 'EMAIL',
	/** An Invitation sent via 3rd party. */
	Pin = 'PIN',
	/** An Invitation sent via text message. */
	Sms = 'SMS'
}

/** Invite update arguments. */
export type InviteUpdateInputObject = {
	/** Id of the invitation. */
	id: Scalars['ID'];
	/** Boolean on whether to resend the invitation. */
	resend?: InputMaybe<Scalars['Boolean']>;
};

/** Represents the conditions, permissions, and limitations granted to a User. */
export type License = NodeInterface & {
	__typename?: 'License';
	/** Indicates whether the License applies company-wide. */
	companyWide?: Maybe<Scalars['Boolean']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the License expires. */
	expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Additional groups associated with the License. */
	groups?: Maybe<LicenseGroupConnection>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the License. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the License. */
	permissions: LicensePermissions;
	/** The product the License applies to. */
	product?: Maybe<LicenseProductEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The state of the License. */
	state?: Maybe<LicenseStateEnum>;
	/** The type of the License. */
	type?: Maybe<LicenseTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User associated with the License. */
	user?: Maybe<User>;
};


/** Represents the conditions, permissions, and limitations granted to a User. */
export type LicenseGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** Input object for specifying extra License configuration data. */
export type LicenseExtraDataInputObject = {
	/** Whether the License should apply to the entire company. */
	companyWide?: InputMaybe<Scalars['Boolean']>;
	/** Additional group IDs the License should apply to. */
	groupsIds?: InputMaybe<Array<Scalars['ID']>>;
	/** The type of License being requested. */
	type: LicenseTypeEnum;
};

/** A connection from a Node. */
export type LicenseGroupConnection = {
	__typename?: 'LicenseGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<LicenseGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the LicenseGroupConnection. */
	permissions: LicenseGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type LicenseGroupConnectionPermissions = {
	__typename?: 'LicenseGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type LicenseGroupEdge = {
	__typename?: 'LicenseGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type LicensePermissions = {
	__typename?: 'LicensePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum LicenseProductEnum {
	/** A license that applies to the Calls portal. */
	RemoteAr = 'REMOTE_AR',
	/** A license that grants reporting access. */
	Reports = 'REPORTS',
	/** A license that applies to WorkLink Create portal. */
	Worklink = 'WORKLINK'
}

export enum LicenseStateEnum {
	/** A License that is active. */
	Active = 'ACTIVE',
	/** A License that is expired. */
	Expired = 'EXPIRED',
	/** A License that is revoked. */
	Revoked = 'REVOKED'
}

export enum LicenseTypeEnum {
	/** A License for a User with admin permissions. */
	Admin = 'ADMIN',
	/** A License for a User with author permissions. */
	Author = 'AUTHOR',
	/** A License for a User with call analyst permissions. */
	CallAnalyst = 'CALL_ANALYST',
	/** A License for a User with expert permissions. */
	Expert = 'EXPERT',
	/** A License for a User with guest permissions. */
	Guest = 'GUEST',
	/** The absence of an existing license type. */
	None = 'NONE',
	/** A License for a User with public permissions. */
	Public = 'PUBLIC',
	/** A License for a User with reviewer permissions. */
	Reviewer = 'REVIEWER',
	/** A License for a User with Scenario analyst permissions. */
	ScenarioAnalyst = 'SCENARIO_ANALYST',
	/** A License for a User with tech permissions. */
	Tech = 'TECH',
	/** A License for a User with tech plus permissions. */
	TechPlus = 'TECH_PLUS',
	/** A License for a User with viewer permissions. */
	Viewer = 'VIEWER'
}

export enum MemberTypeEnum {
	/** An employee. */
	Employee = 'EMPLOYEE',
	/** A guest. */
	Guest = 'GUEST'
}

/** A Node in the graph. */
export type ModelProcessJob = NodeInterface & {
	__typename?: 'ModelProcessJob';
	/** Asset associated with the model processing job. */
	asset?: Maybe<Asset>;
	/** Base revision used in the model processing job. */
	baseRevision?: Maybe<AssetRevision>;
	/** Options used for the model converter during processing. */
	converterOptions?: Maybe<ModelProcessJobConverterOptionsEnum>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** User who created the model processing job. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Default operations applied to the model during processing. */
	defaultOperations?: Maybe<Array<Scalars['String']>>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Error details, if any, from the model processing job. */
	error?: Maybe<Scalars['String']>;
	/** Log containing details about the exported model processing job. */
	exportLog?: Maybe<Attachment>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** Operations performed during the model processing job. */
	operations?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ModelProcessJob. */
	permissions: ModelProcessJobPermissions;
	/** Timestamp when the processing job ended. */
	processEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Timestamp when the processing job started. */
	processStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Current status of the model processing job. */
	processStatus?: Maybe<ModelProcessJobStatusEnum>;
	/** Total time taken to complete the model processing job. */
	processTime?: Maybe<Scalars['Int']>;
	/** Timestamp indicating when the model processing job was queued. */
	queuedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Timestamp indicating when reprocessing ended. */
	reprocessEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Number of times the processing job retried. */
	retryCount?: Maybe<Scalars['Int']>;
	/** Name of the revision associated with the processing job. */
	revisionName?: Maybe<Scalars['String']>;
	/** Root file name used in the model processing job. */
	rootFileName?: Maybe<Scalars['String']>;
	/** Schema version of the model processing job. */
	schemaVersion?: Maybe<Scalars['Int']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Total parts in the model after processing. */
	totalPartsAfter?: Maybe<Scalars['Int']>;
	/** Total parts in the model before processing. */
	totalPartsBefore?: Maybe<Scalars['Int']>;
	/** Total polygon count of the model after processing. */
	totalPolycountAfter?: Maybe<Scalars['Int']>;
	/** Total polygon count of the model before processing. */
	totalPolycountBefore?: Maybe<Scalars['Int']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

export enum ModelProcessJobConverterOptionsEnum {
	/** Converter option for reducing back-off polygons. */
	Rbop = 'RBOP',
	/** Standard converter option for the model processing job. */
	Standard = 'STANDARD'
}

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ModelProcessJobPermissions = {
	__typename?: 'ModelProcessJobPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ModelProcessJobStatusEnum {
	/** The model processing job encountered an error. */
	Error = 'ERROR',
	/** The job is performing rendering locally. */
	LocalRender = 'LOCAL_RENDER',
	/** The job is pending local rendering operations. */
	PendingLocalRender = 'PENDING_LOCAL_RENDER',
	/** The model processing job is pending rendering. */
	PendingRender = 'PENDING_RENDER',
	/** The model processing job is currently being processed. */
	Processing = 'PROCESSING',
	/** The CAD files are being processed in the model processing job. */
	ProcessingCad = 'PROCESSING_CAD',
	/** The model processing job is queued and awaiting processing. */
	Queued = 'QUEUED',
	/** The model processing job is rendering. */
	Rendering = 'RENDERING',
	/** The model processing job completed successfully. */
	Success = 'SUCCESS',
	/** The model processing job timed out before completion. */
	Timeout = 'TIMEOUT'
}

/** This type is a root entrypoint for all mutations. */
export type Mutation = {
	__typename?: 'Mutation';
	/** Accepts a user invitation. */
	acceptInvitation?: Maybe<AcceptInvitationMutationPayload>;
	/** Close Organizations. */
	closeOrganizations?: Maybe<CloseOrganizationsMutationPayload>;
	/** Creates an API Token. */
	createApiToken?: Maybe<CreateApiTokenMutationPayload>;
	/** Mutation for creating a new asset. */
	createAsset?: Maybe<CreateAssetMutationPayload>;
	/** Bulk Data Upload. */
	createBulkOperation?: Maybe<CreateBulkOperationMutationPayload>;
	/** Create a Call. */
	createCall?: Maybe<CreateCallMutationPayload>;
	/** Create a Call Log. */
	createCallLog?: Maybe<CreateCallLogMutationPayload>;
	/** Creates a client certificate for an organization. */
	createClientCertificate?: Maybe<CreateClientCertificateMutationPayload>;
	/** Created a EULA. */
	createEula?: Maybe<CreateEulaMutationPayload>;
	/** Creates a Group. */
	createGroup?: Maybe<CreateGroupMutationPayload>;
	/** Creates an Integration. */
	createIntegration?: Maybe<CreateIntegrationMutationPayload>;
	/** Creates and sends an Invitation. */
	createInvitation?: Maybe<CreateInvitationMutationPayload>;
	/** Mutation for creating a new model processing job. */
	createModelProcessJob?: Maybe<CreateModelProcessJobMutationPayload>;
	/** Create an Organization. */
	createOrganization?: Maybe<CreateOrganizationMutationPayload>;
	/** Creates an OrganizationServer. */
	createOrganizationServer?: Maybe<CreateOrganizationServerMutationPayload>;
	/** Creates an OrganizationServerLicense. */
	createOrganizationServerLicense?: Maybe<CreateOrganizationServerLicenseMutationPayload>;
	/** Create an SSO provider associated with the Organization. */
	createOrganizationSsoDetail?: Maybe<CreateOrganizationSsoDetailMutationPayload>;
	/** Creates a Photo. */
	createPhoto?: Maybe<CreatePhotoMutationPayload>;
	/** Create a ProductRelease. */
	createProductRelease?: Maybe<CreateProductReleaseMutationPayload>;
	/** Creates a single project for an organization. */
	createProject?: Maybe<CreateProjectMutationPayload>;
	/** Creates a new Project Export Job. */
	createProjectExportJob?: Maybe<CreateProjectExportJobMutationPayload>;
	/** Mutation for creating a new project import job. */
	createProjectImportJob?: Maybe<CreateProjectImportJobMutationPayload>;
	/** Mutation for creating a new project merge job. */
	createProjectMergeJob?: Maybe<CreateProjectMergeJobMutationPayload>;
	/** Creates a single project save file for an organization. */
	createProjectSaveFile?: Maybe<CreateProjectSaveFileMutationPayload>;
	/** Creates a public User. */
	createPublicUser?: Maybe<CreatePublicUserMutationPayload>;
	/** Mutation for creating a new render preview job. */
	createRenderPreviewJob?: Maybe<CreateRenderPreviewJobMutationPayload>;
	/** Create a Scenario. */
	createScenario?: Maybe<CreateScenarioMutationPayload>;
	/** Create a Scenario catalog. */
	createScenarioCatalog?: Maybe<CreateScenarioCatalogMutationPayload>;
	/** Creates events for a scenario session part or possibly create scenario session part. */
	createScenarioSessionEvents?: Maybe<CreateScenarioSessionEventMutationPayload>;
	/** Creates a new scenario session part and possibly a new scenario session. */
	createScenarioSessionPart?: Maybe<CreateScenarioSessionPartMutationPayload>;
	/** Creates a User. */
	createUser?: Maybe<CreateUserMutationPayload>;
	/** Create a WebhookSubscription. */
	createWebhookSubscription?: Maybe<CreateWebhookSubscriptionMutationPayload>;
	/** Deletes an API Token. */
	deleteApiToken?: Maybe<DeleteApiTokenMutationPayload>;
	/** Deletes multiple API Tokens. */
	deleteApiTokens?: Maybe<DeleteApiTokensMutationPayload>;
	/** Mutation to delete an asset. */
	deleteAsset?: Maybe<DeleteAssetMutationPayload>;
	/** Mutation to delete multiple assets. */
	deleteAssets?: Maybe<DeleteAssetsMutationPayload>;
	/** Deletes a Call. */
	deleteCall?: Maybe<DeleteCallMutationPayload>;
	/** Deletes multiple CallPhotos. */
	deleteCallPhotos?: Maybe<DeleteCallPhotosMutationPayload>;
	/** Deletes multiple CallRecordings. */
	deleteCallRecordings?: Maybe<DeleteCallRecordingsMutationPayload>;
	/** Deletes a batch of Calls. */
	deleteCalls?: Maybe<DeleteCallsMutationPayload>;
	/** Deletes a client certificate for an organization. */
	deleteClientCertificate?: Maybe<DeleteClientCertificateMutationPayload>;
	/** Deletes a EULA. */
	deleteEula?: Maybe<DeleteEulaMutationPayload>;
	/** Deletes a Group. */
	deleteGroup?: Maybe<DeleteGroupMutationPayload>;
	/** Deletes a batch of Groups. */
	deleteGroups?: Maybe<DeleteGroupsMutationPayload>;
	/** Deletes an Integration. */
	deleteIntegration?: Maybe<DeleteIntegrationMutationPayload>;
	/** Deletes multiple Integrations. */
	deleteIntegrations?: Maybe<DeleteIntegrationsMutationPayload>;
	/** Deletes an Invitation. */
	deleteInvitations?: Maybe<DeleteInvitationsMutationPayload>;
	/** Close Organization. */
	deleteOrganization?: Maybe<CloseOrganizationMutationPayload>;
	/** Deletes an OrganizationServer. */
	deleteOrganizationServer?: Maybe<DeleteOrganizationServerMutationPayload>;
	/** Deletes an OrganizationServerLicense. */
	deleteOrganizationServerLicense?: Maybe<DeleteOrganizationServerLicenseMutationPayload>;
	/** Deletes multiple OrganizationServerLicenses. */
	deleteOrganizationServerLicenses?: Maybe<DeleteOrganizationServerLicensesMutationPayload>;
	/** Deletes multiple OrganizationServers. */
	deleteOrganizationServers?: Maybe<DeleteOrganizationServersMutationPayload>;
	/** Delete an SSO provider associated with the Organization. */
	deleteOrganizationSsoDetail?: Maybe<DeleteOrganizationSsoDetailMutationPayload>;
	/** Delete multiple SSO providers associated with the Organization. */
	deleteOrganizationSsoDetails?: Maybe<DeleteOrganizationSsoDetailsMutationPayload>;
	/** Deletes multiple Photos. */
	deletePhotos?: Maybe<DeletePhotosMutationPayload>;
	/** Deletes a ProductRelease. */
	deleteProductRelease?: Maybe<DeleteProductReleaseMutationPayload>;
	/** Deletes a list of ProductReleases. */
	deleteProductReleases?: Maybe<DeleteProductReleasesMutationPayload>;
	/** Deletes a Project. */
	deleteProject?: Maybe<DeleteProjectMutationPayload>;
	/** Deletes a list of Project. */
	deleteProjects?: Maybe<DeleteProjectsMutationPayload>;
	/** Deletes a Scenario. */
	deleteScenario?: Maybe<DeleteScenarioMutationPayload>;
	/** Delete a Scenario catalog. */
	deleteScenarioCatalog?: Maybe<DeleteScenarioCatalogMutationPayload>;
	/** Deletes a Scenario Release. */
	deleteScenarioRelease?: Maybe<DeleteScenarioReleaseMutationPayload>;
	/** Deletes a Scenario Session. */
	deleteScenarioSession?: Maybe<DeleteScenarioSessionMutationPayload>;
	/** Deletes a batch of Scenario Sessions. */
	deleteScenarioSessions?: Maybe<DeleteScenarioSessionsMutationPayload>;
	/** Deletes a list of Scenarios. */
	deleteScenarios?: Maybe<DeleteScenariosMutationPayload>;
	/** Deletes a batch of Users. */
	deleteUsers?: Maybe<DeleteUsersMutationPayload>;
	/** Deletes a WebhookError. */
	deleteWebhookError?: Maybe<DeleteWebhookErrorMutationPayload>;
	/** Deletes a list of WebhookErrors. */
	deleteWebhookErrors?: Maybe<DeleteWebhookErrorsMutationPayload>;
	/** Deletes a WebhookSubscriptions. */
	deleteWebhookSubscription?: Maybe<DeleteWebhookSubscriptionMutationPayload>;
	/** Deletes a list of webhook_subscriptions. */
	deleteWebhookSubscriptions?: Maybe<DeleteWebhookSubscriptionsMutationPayload>;
	/** Finds or creates a new review of a reviewable object. */
	findOrCreateReview?: Maybe<FindOrCreateReviewMutationPayload>;
	/** Mutation to recover a deleted asset. */
	recoverAsset?: Maybe<RecoverAssetMutationPayload>;
	/** Mutation to recover multiple deleted assets. */
	recoverAssets?: Maybe<RecoverAssetsMutationPayload>;
	/** Recovers a deleted Project. */
	recoverProject?: Maybe<RecoverProjectMutationPayload>;
	/** Updates an API Token. */
	updateApiToken?: Maybe<UpdateApiTokenMutationPayload>;
	/** Mutation to update an existing asset. */
	updateAsset?: Maybe<UpdateAssetMutationPayload>;
	/** Mutation for updating an asset revision. */
	updateAssetRevision?: Maybe<UpdateAssetRevisionMutationPayload>;
	/** Updates a Call. */
	updateCall?: Maybe<UpdateCallMutationPayload>;
	/** Updates multiple CallRecordings. */
	updateCallRecordings?: Maybe<UpdateCallRecordingsMutationPayload>;
	/** Updates a EULA. */
	updateEula?: Maybe<UpdateEulaMutationPayload>;
	/** Updates Multiple EULAs. */
	updateEulas?: Maybe<UpdateEulasMutationPayload>;
	/** Updates a Group. */
	updateGroup?: Maybe<UpdateGroupMutationPayload>;
	/** Updates an Integration. */
	updateIntegration?: Maybe<UpdateIntegrationMutationPayload>;
	/** Updates an existing user invitation. */
	updateInvitations?: Maybe<UpdateInvitationsMutationPayload>;
	/** Updates an Organization. */
	updateOrganization?: Maybe<UpdateOrganizationMutationPayload>;
	/** Updates an Organization. */
	updateOrganizationAdminFields?: Maybe<UpdateOrganizationMutationPayload>;
	/** Updates an OrganizationServer. */
	updateOrganizationServer?: Maybe<UpdateOrganizationServerMutationPayload>;
	/** Updates an OrganizationServerLicense. */
	updateOrganizationServerLicense?: Maybe<UpdateOrganizationServerLicenseMutationPayload>;
	/** Update an SSO provider associated with the Organization. */
	updateOrganizationSsoDetail?: Maybe<UpdateOrganizationSsoDetailMutationPayload>;
	/** Updates a single project for an organization. */
	updateProject?: Maybe<UpdateProjectMutationPayload>;
	/** Updates a list of Projects. */
	updateProjects?: Maybe<UpdateProjectsMutationPayload>;
	/** Update a Scenario. */
	updateScenario?: Maybe<UpdateScenarioMutationPayload>;
	/** Update a Scenario Catalog. */
	updateScenarioCatalog?: Maybe<UpdateScenarioCatalogMutationPayload>;
	/** Update a list of Scenarios. */
	updateScenarios?: Maybe<UpdateScenariosMutationPayload>;
	/** Updates a User. */
	updateUser?: Maybe<UpdateUserMutationPayload>;
	/** Updates a batch of Users. */
	updateUsers?: Maybe<UpdateUsersMutationPayload>;
	/** Updates a WebhookSubscription. */
	updateWebhookSubscription?: Maybe<UpdateWebhookSubscriptionMutationPayload>;
	/** Adds a user selection(s) to a review of a reviewable object. */
	upsertReviewUserSelection?: Maybe<UpsertReviewUserSelectionMutationPayload>;
};


/** This type is a root entrypoint for all mutations. */
export type MutationAcceptInvitationArgs = {
	input: AcceptInvitationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCloseOrganizationsArgs = {
	input: CloseOrganizationsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateApiTokenArgs = {
	input: CreateApiTokenMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateAssetArgs = {
	input: CreateAssetMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateBulkOperationArgs = {
	input: CreateBulkOperationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateCallArgs = {
	input: CreateCallMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateCallLogArgs = {
	input: CreateCallLogMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateClientCertificateArgs = {
	input: CreateClientCertificateMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateEulaArgs = {
	input: CreateEulaMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateGroupArgs = {
	input: CreateGroupMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateIntegrationArgs = {
	input: CreateIntegrationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateInvitationArgs = {
	input: CreateInvitationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateModelProcessJobArgs = {
	input: CreateModelProcessJobMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateOrganizationArgs = {
	input: CreateOrganizationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateOrganizationServerArgs = {
	input: CreateOrganizationServerMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateOrganizationServerLicenseArgs = {
	input: CreateOrganizationServerLicenseMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateOrganizationSsoDetailArgs = {
	input: CreateOrganizationSsoDetailMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreatePhotoArgs = {
	input: CreatePhotoMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateProductReleaseArgs = {
	input: CreateProductReleaseMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateProjectArgs = {
	input: CreateProjectMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateProjectExportJobArgs = {
	input: CreateProjectExportJobMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateProjectImportJobArgs = {
	input: CreateProjectImportJobMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateProjectMergeJobArgs = {
	input: CreateProjectMergeJobMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateProjectSaveFileArgs = {
	input: CreateProjectSaveFileMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreatePublicUserArgs = {
	input: CreatePublicUserMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateRenderPreviewJobArgs = {
	input: CreateRenderPreviewJobMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateScenarioArgs = {
	input: CreateScenarioMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateScenarioCatalogArgs = {
	input: CreateScenarioCatalogMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateScenarioSessionEventsArgs = {
	input: CreateScenarioSessionEventMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateScenarioSessionPartArgs = {
	input: CreateScenarioSessionPartMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateUserArgs = {
	input: CreateUserMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationCreateWebhookSubscriptionArgs = {
	input: CreateWebhookSubscriptionMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteApiTokenArgs = {
	input: DeleteApiTokenMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteApiTokensArgs = {
	input: DeleteApiTokensMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteAssetArgs = {
	input: DeleteAssetMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteAssetsArgs = {
	input: DeleteAssetsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteCallArgs = {
	input: DeleteCallMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteCallPhotosArgs = {
	input: DeleteCallPhotosMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteCallRecordingsArgs = {
	input: DeleteCallRecordingsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteCallsArgs = {
	input: DeleteCallsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteClientCertificateArgs = {
	input: DeleteClientCertificateMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteEulaArgs = {
	input: DeleteEulaMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteGroupArgs = {
	input: DeleteGroupMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteGroupsArgs = {
	input: DeleteGroupsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteIntegrationArgs = {
	input: DeleteIntegrationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteIntegrationsArgs = {
	input: DeleteIntegrationsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteInvitationsArgs = {
	input: DeleteInvitationsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationArgs = {
	input: CloseOrganizationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationServerArgs = {
	input: DeleteOrganizationServerMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationServerLicenseArgs = {
	input: DeleteOrganizationServerLicenseMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationServerLicensesArgs = {
	input: DeleteOrganizationServerLicensesMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationServersArgs = {
	input: DeleteOrganizationServersMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationSsoDetailArgs = {
	input: DeleteOrganizationSsoDetailMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteOrganizationSsoDetailsArgs = {
	input: DeleteOrganizationSsoDetailsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeletePhotosArgs = {
	input: DeletePhotosMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteProductReleaseArgs = {
	input: DeleteProductReleaseMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteProductReleasesArgs = {
	input: DeleteProductReleasesMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteProjectArgs = {
	input: DeleteProjectMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteProjectsArgs = {
	input: DeleteProjectsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteScenarioArgs = {
	input: DeleteScenarioMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteScenarioCatalogArgs = {
	input: DeleteScenarioCatalogMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteScenarioReleaseArgs = {
	input: DeleteScenarioReleaseMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteScenarioSessionArgs = {
	input: DeleteScenarioSessionMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteScenarioSessionsArgs = {
	input: DeleteScenarioSessionsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteScenariosArgs = {
	input: DeleteScenariosMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteUsersArgs = {
	input: DeleteUsersMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteWebhookErrorArgs = {
	input: DeleteWebhookErrorMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteWebhookErrorsArgs = {
	input: DeleteWebhookErrorsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteWebhookSubscriptionArgs = {
	input: DeleteWebhookSubscriptionMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationDeleteWebhookSubscriptionsArgs = {
	input: DeleteWebhookSubscriptionsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationFindOrCreateReviewArgs = {
	input: FindOrCreateReviewMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationRecoverAssetArgs = {
	input: RecoverAssetMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationRecoverAssetsArgs = {
	input: RecoverAssetsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationRecoverProjectArgs = {
	input: RecoverProjectMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateApiTokenArgs = {
	input: UpdateApiTokenMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateAssetArgs = {
	input: UpdateAssetMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateAssetRevisionArgs = {
	input: UpdateAssetRevisionMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateCallArgs = {
	input: UpdateCallMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateCallRecordingsArgs = {
	input: UpdateCallRecordingsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateEulaArgs = {
	input: UpdateEulaMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateEulasArgs = {
	input: UpdateEulasMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateGroupArgs = {
	input: UpdateGroupMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateIntegrationArgs = {
	input: UpdateIntegrationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateInvitationsArgs = {
	input: UpdateInvitationsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateOrganizationArgs = {
	input: UpdateOrganizationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateOrganizationAdminFieldsArgs = {
	input: UpdateOrganizationMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateOrganizationServerArgs = {
	input: UpdateOrganizationServerMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateOrganizationServerLicenseArgs = {
	input: UpdateOrganizationServerLicenseMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateOrganizationSsoDetailArgs = {
	input: UpdateOrganizationSsoDetailMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateProjectArgs = {
	input: UpdateProjectMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateProjectsArgs = {
	input: UpdateProjectsMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateScenarioArgs = {
	input: UpdateScenarioMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateScenarioCatalogArgs = {
	input: UpdateScenarioCatalogMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateScenariosArgs = {
	input: UpdateScenariosMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateUserArgs = {
	input: UpdateUserMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateUsersArgs = {
	input: UpdateUsersMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpdateWebhookSubscriptionArgs = {
	input: UpdateWebhookSubscriptionMutationInput;
};


/** This type is a root entrypoint for all mutations. */
export type MutationUpsertReviewUserSelectionArgs = {
	input: UpsertReviewUserSelectionMutationInput;
};

/** An object with an ID. */
export type NodeInterface = {
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** The resource permission arguments for a node. */
export type NodeResourcePermissionInputObject = {
	/** the database id of the permissable object. */
	permissableDatabaseId?: InputMaybe<Scalars['String']>;
	/** the GQL id of the permissable object. */
	permissableId?: InputMaybe<Scalars['String']>;
	/** the type of permissable object. */
	permissableType?: InputMaybe<PermissionPermissableTypeEnum>;
	/** the permission to grant. */
	permission: PermissionEnum;
};

export enum Oauth2AssertionAlgorithmEnum {
	/** HS256 enconding algorithm. */
	Hs256 = 'HS256',
	/** RS256 enconding algorithm. */
	Rs256 = 'RS256'
}

export enum Oauth2GrantTypeEnum {
	/** Oauth2 Client Credentials gran type. */
	ClientCredentials = 'CLIENT_CREDENTIALS',
	/** Oauth2 JWT bearer gran type. */
	JwtBearer = 'JWT_BEARER',
	/** Oauth2 Password gran type. */
	Password = 'PASSWORD'
}

/** Represents a Scope AR customer. */
export type Organization = NodeInterface & {
	__typename?: 'Organization';
	/** List of Admin Users associated with the Organization. */
	admins?: Maybe<Array<Admin>>;
	/** The app logo associated with the Organization when grey label support is enabled. */
	appLogo?: Maybe<ImageAttachment>;
	/** The list of assets in the Organization's library. */
	assets?: Maybe<OrganizationAssetConnection>;
	/** Number of days Organization Audit Logs will be retained for. */
	auditLogsRetentionPeriod?: Maybe<Scalars['Days']>;
	/** A list of CallPhotos associated with the Organization. */
	callPhotos?: Maybe<OrganizationCallPhotoConnection>;
	/** A list of CallRecordingParts associated with the Organization. */
	callRecordingParts?: Maybe<OrganizationCallRecordingPartConnection>;
	/** A list of CallRecordings associated with the Organization. */
	callRecordings?: Maybe<OrganizationCallRecordingConnection>;
	/** A list of Calls associated with the Organization. */
	calls?: Maybe<OrganizationCallConnection>;
	/** The client certificates created for the organization. */
	clientCertificates?: Maybe<OrganizationClientCertificateConnection>;
	/** The date and time when the Organization was closed. */
	closedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Link to the QR code for the organization's contact list. */
	contactListQrCodeImageLink?: Maybe<Scalars['String']>;
	/** A list of callable Users associated with the Organization. */
	contacts?: Maybe<OrganizationUserConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of Scenarios Daily Usages. */
	dailyUsages?: Maybe<DailyUsageConnection>;
	/** Region where company data is stored. */
	dataStorageRegion?: Maybe<OrganizationDataStorageRegionEnum>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Link to organization contact list. */
	deferredContactListLink?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of Devices associated with the Organization. */
	devices?: Maybe<OrganizationDeviceConnection>;
	/** A boolen value to disable APP upgrade prompts. */
	disableAppUpgradePrompts: Scalars['Boolean'];
	/** Downloadable license configuration. */
	downloadableLicense?: Maybe<Scalars['String']>;
	/** Access to embedded analytics (metabase). */
	embeddedAnalytics?: Maybe<EmbeddedAnalytics>;
	/** Total number of company users of the type Employee. */
	employeesCount?: Maybe<Scalars['Int']>;
	/** Encrypted license configuration. */
	encryptedLicense?: Maybe<Scalars['String']>;
	/** key used to encrypt files for the organization. */
	encryptionKey?: Maybe<Scalars['String']>;
	/** A list of EulaPrompts associated with the Organization. */
	eulaPrompts?: Maybe<OrganizationEulaPromptConnection>;
	/** A list of Eulas associated with the Organization. */
	eulas?: Maybe<OrganizationEulaConnection>;
	/** A list of Feedbacks associated with the Organization. */
	feedbacks?: Maybe<OrganizationFeedbackConnection>;
	/** A list of Group policies associated with the Organization. */
	groupPolicies?: Maybe<OrganizationGroupPolicyConnection>;
	/** A list of Groups associated with the Organization. */
	groups?: Maybe<OrganizationGroupConnection>;
	/** Global ID of the Organization record. This should be persistent if data is migrated and is recommended to use. */
	guid?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** A list of Integrations associated with the Organization. */
	integrations?: Maybe<OrganizationIntegrationConnection>;
	/** A list of Invitations associated with the Organization. */
	invitations?: Maybe<OrganizationInvitationConnection>;
	/** A list of unique User job titles associated with the Organization. */
	jobTitles?: Maybe<Array<Scalars['String']>>;
	/** A list of Licenses associated with the Organization. */
	licenses?: Maybe<OrganizationLicenseConnection>;
	/** A list of Users associated with the Organization. */
	members?: Maybe<OrganizationUserConnection>;
	/** The name of the Organization. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** Boolean value if the organization uses an on-prem installation on a remote server. */
	onPrem?: Maybe<Scalars['Boolean']>;
	/** The current license for the organization. */
	organizationLicense?: Maybe<OrganizationServerLicense>;
	/** A list of licenses associated with Organization Servers. */
	organizationServerLicenses?: Maybe<OrganizationOrganizationServerLicenseConnection>;
	/** A list of Servers associated with the Organization. */
	organizationServers?: Maybe<OrganizationOrganizationServerConnection>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Organization. */
	permissions: OrganizationPermissions;
	/** A list of Projects associated with the Organization. */
	projects?: Maybe<ProjectConnection>;
	/** A unique list of Scenario Authors. */
	scenarioAuthors?: Maybe<Array<User>>;
	/** A list of ScenarioCatalogs associated with the Organization. */
	scenarioCatalogs?: Maybe<OrganizationScenarioCatalogConnection>;
	/** A list of groups that can be assoicated with a scenario. */
	scenarioRecipientGroups?: Maybe<OrganizationGroupConnection>;
	/** A list of ScenarioReleases associated with the Organization. */
	scenarioReleases?: Maybe<OrganizationScenarioReleaseConnection>;
	/** A list of ScenarioSessions associated with the Organization. */
	scenarioSessions?: Maybe<OrganizationScenarioSessionConnection>;
	/** A list of Scenarios associated with the Organization. */
	scenarios?: Maybe<OrganizationScenarioConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The slug of the Organization (used to identify company in urls). */
	slug?: Maybe<Scalars['String']>;
	/** The SSO parameters associated with the Organization. */
	ssoDetails?: Maybe<Array<OrganizationSsoDetail>>;
	/** Status of the Organization. */
	status?: Maybe<OrganizationStatusEnum>;
	/** Type of the Organization. */
	type?: Maybe<OrganizationTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** A list of Users and Groups associated with the Organization. */
	usersAndGroups?: Maybe<Array<NodeInterface>>;
	/** A boolen value checks for viewer has access to cms. */
	viewerCmsAccess: Scalars['Boolean'];
	/** The web logo associated with the Organization when grey label support is enabled. */
	webLogo?: Maybe<ImageAttachment>;
	/** A list of WebhookSubscriptions associated with the User. */
	webhookSubscriptions?: Maybe<OrganizationWebhookSubscriptionConnection>;
};


/** Represents a Scope AR customer. */
export type OrganizationAssetsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	folderDatabaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	folderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	inRootFolder?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	notInLatestVersions?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	ownerId?: InputMaybe<Scalars['ID']>;
	types?: InputMaybe<Array<AssetTypeEnum>>;
};


/** Represents a Scope AR customer. */
export type OrganizationCallPhotosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** Represents a Scope AR customer. */
export type OrganizationCallRecordingPartsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationCallRecordingsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assembled?: InputMaybe<Scalars['Boolean']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	userId?: InputMaybe<Scalars['ID']>;
};


/** Represents a Scope AR customer. */
export type OrganizationCallsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	callQueryArguments?: InputMaybe<CallsQueryInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationClientCertificatesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** Represents a Scope AR customer. */
export type OrganizationContactsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationDailyUsagesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dailyUsageQueryArguments?: InputMaybe<DailyUsageQueryInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationDevicesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationEulaPromptsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationEulasArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationFeedbacksArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationGroupPoliciesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationIntegrationsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationInvitationsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationLicensesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationMembersArgs = {
	active?: InputMaybe<Scalars['Boolean']>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	emails?: InputMaybe<Array<Scalars['String']>>;
	excludeGroups?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	groupNames?: InputMaybe<Array<Scalars['String']>>;
	groups?: InputMaybe<Array<Scalars['String']>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	jobTitles?: InputMaybe<Array<Scalars['String']>>;
	last?: InputMaybe<Scalars['Int']>;
	licenseTypes?: InputMaybe<Array<LicenseTypeEnum>>;
	memberType?: InputMaybe<MemberTypeEnum>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	originGroupIds?: InputMaybe<Array<Scalars['ID']>>;
	usernames?: InputMaybe<Array<Scalars['String']>>;
};


/** Represents a Scope AR customer. */
export type OrganizationOrganizationServerLicensesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	organizationServerId?: InputMaybe<Scalars['String']>;
};


/** Represents a Scope AR customer. */
export type OrganizationOrganizationServersArgs = {
	active?: InputMaybe<Scalars['Boolean']>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	installationTypes?: InputMaybe<Array<OrganizationServerInstallationTypeEnum>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** Represents a Scope AR customer. */
export type OrganizationProjectsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	latestRevisionOnly?: InputMaybe<Scalars['Boolean']>;
	name?: InputMaybe<Scalars['String']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
	sharedList?: InputMaybe<Scalars['Boolean']>;
	sharedWithDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	sharedWithIds?: InputMaybe<Array<Scalars['ID']>>;
	states?: InputMaybe<Array<ProjectStateEnum>>;
	updatedAt?: InputMaybe<DateRangeInputObject>;
	updatedByIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Represents a Scope AR customer. */
export type OrganizationScenarioCatalogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Scope AR customer. */
export type OrganizationScenarioRecipientGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Scope AR customer. */
export type OrganizationScenarioReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents a Scope AR customer. */
export type OrganizationScenarioSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	externalData?: InputMaybe<ScenarioSessionsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionsUserInput>;
	versions?: InputMaybe<Array<Scalars['Int']>>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents a Scope AR customer. */
export type OrganizationScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** Represents a Scope AR customer. */
export type OrganizationUsersAndGroupsArgs = {
	afterIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	licenseTypes?: InputMaybe<Array<LicenseTypeEnum>>;
	memberType?: InputMaybe<MemberTypeEnum>;
	onlyGroups?: InputMaybe<Scalars['Boolean']>;
	onlyUsers?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** Represents a Scope AR customer. */
export type OrganizationWebhookSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

export enum OrganizationAccessTypeEnum {
	/** Organization access to calling features. */
	CallingAccess = 'CALLING_ACCESS',
	/** Organization access to scenario features. */
	ScenarioAccess = 'SCENARIO_ACCESS'
}

/** A connection from a Node. */
export type OrganizationAssetConnection = {
	__typename?: 'OrganizationAssetConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationAssetEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Asset>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationAssetConnection. */
	permissions: OrganizationAssetConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationAssetConnectionPermissions = {
	__typename?: 'OrganizationAssetConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationAssetEdge = {
	__typename?: 'OrganizationAssetEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Asset>;
};

/** A connection from a Node. */
export type OrganizationCallConnection = {
	__typename?: 'OrganizationCallConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationCallEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Call>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationCallConnection. */
	permissions: OrganizationCallConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationCallConnectionPermissions = {
	__typename?: 'OrganizationCallConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationCallEdge = {
	__typename?: 'OrganizationCallEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Call>;
};

/** A connection from a Node. */
export type OrganizationCallPhotoConnection = {
	__typename?: 'OrganizationCallPhotoConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationCallPhotoEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallPhoto>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationCallPhotoConnection. */
	permissions: OrganizationCallPhotoConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationCallPhotoConnectionPermissions = {
	__typename?: 'OrganizationCallPhotoConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationCallPhotoEdge = {
	__typename?: 'OrganizationCallPhotoEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallPhoto>;
};

/** A connection from a Node. */
export type OrganizationCallRecordingConnection = {
	__typename?: 'OrganizationCallRecordingConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationCallRecordingEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallRecording>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationCallRecordingConnection. */
	permissions: OrganizationCallRecordingConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationCallRecordingConnectionPermissions = {
	__typename?: 'OrganizationCallRecordingConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationCallRecordingEdge = {
	__typename?: 'OrganizationCallRecordingEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallRecording>;
};

/** A connection from a Node. */
export type OrganizationCallRecordingPartConnection = {
	__typename?: 'OrganizationCallRecordingPartConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationCallRecordingPartEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallRecordingPart>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationCallRecordingPartConnection. */
	permissions: OrganizationCallRecordingPartConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationCallRecordingPartConnectionPermissions = {
	__typename?: 'OrganizationCallRecordingPartConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationCallRecordingPartEdge = {
	__typename?: 'OrganizationCallRecordingPartEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallRecordingPart>;
};

/** A connection from a Node. */
export type OrganizationClientCertificateConnection = {
	__typename?: 'OrganizationClientCertificateConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationClientCertificateEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ClientCertificate>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationClientCertificateConnection. */
	permissions: OrganizationClientCertificateConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationClientCertificateConnectionPermissions = {
	__typename?: 'OrganizationClientCertificateConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationClientCertificateEdge = {
	__typename?: 'OrganizationClientCertificateEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ClientCertificate>;
};

/** An edge in a connection. */
export type OrganizationDailyUsageEdge = {
	__typename?: 'OrganizationDailyUsageEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<DailyUsage>;
};

export enum OrganizationDataStorageRegionEnum {
	/** Asia Pacific (Tokyo). */
	ApNortheast_1 = 'AP_NORTHEAST_1',
	/** Canada. */
	CaCentral_1 = 'CA_CENTRAL_1',
	/** EU (Frankfurt). */
	EuCentral_1 = 'EU_CENTRAL_1',
	/** EU (Ireland). */
	EuWest_1 = 'EU_WEST_1',
	/** EU (London). */
	EuWest_2 = 'EU_WEST_2',
	/** US West (Oregon). */
	UsWest_2 = 'US_WEST_2'
}

/** A connection from a Node. */
export type OrganizationDeviceConnection = {
	__typename?: 'OrganizationDeviceConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationDeviceEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Device>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationDeviceConnection. */
	permissions: OrganizationDeviceConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationDeviceConnectionPermissions = {
	__typename?: 'OrganizationDeviceConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationDeviceEdge = {
	__typename?: 'OrganizationDeviceEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Device>;
};

/** A connection from a Node. */
export type OrganizationEulaConnection = {
	__typename?: 'OrganizationEulaConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationEulaEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Eula>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationEulaConnection. */
	permissions: OrganizationEulaConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationEulaConnectionPermissions = {
	__typename?: 'OrganizationEulaConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationEulaEdge = {
	__typename?: 'OrganizationEulaEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Eula>;
};

/** A connection from a Node. */
export type OrganizationEulaPromptConnection = {
	__typename?: 'OrganizationEulaPromptConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationEulaPromptEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<EulaPrompt>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationEulaPromptConnection. */
	permissions: OrganizationEulaPromptConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationEulaPromptConnectionPermissions = {
	__typename?: 'OrganizationEulaPromptConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationEulaPromptEdge = {
	__typename?: 'OrganizationEulaPromptEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<EulaPrompt>;
};

/** A connection from a Node. */
export type OrganizationFeedbackConnection = {
	__typename?: 'OrganizationFeedbackConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationFeedbackEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Feedback>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationFeedbackConnection. */
	permissions: OrganizationFeedbackConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationFeedbackConnectionPermissions = {
	__typename?: 'OrganizationFeedbackConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationFeedbackEdge = {
	__typename?: 'OrganizationFeedbackEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Feedback>;
};

/** A connection from a Node. */
export type OrganizationGroupConnection = {
	__typename?: 'OrganizationGroupConnection';
	/** A list of Groups associated with the organization having Members. */
	activeGroupNames: Array<Scalars['String']>;
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationGroupConnection. */
	permissions: OrganizationGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationGroupConnectionPermissions = {
	__typename?: 'OrganizationGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Connection. */
	canManage: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationGroupEdge = {
	__typename?: 'OrganizationGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A connection from a Node. */
export type OrganizationGroupPolicyConnection = {
	__typename?: 'OrganizationGroupPolicyConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationGroupPolicyEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<GroupPolicy>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationGroupPolicyConnection. */
	permissions: OrganizationGroupPolicyConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationGroupPolicyConnectionPermissions = {
	__typename?: 'OrganizationGroupPolicyConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationGroupPolicyEdge = {
	__typename?: 'OrganizationGroupPolicyEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<GroupPolicy>;
};

/** A connection from a Node. */
export type OrganizationIntegrationConnection = {
	__typename?: 'OrganizationIntegrationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationIntegrationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Integration>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationIntegrationConnection. */
	permissions: OrganizationIntegrationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationIntegrationConnectionPermissions = {
	__typename?: 'OrganizationIntegrationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationIntegrationEdge = {
	__typename?: 'OrganizationIntegrationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Integration>;
};

/** A connection from a Node. */
export type OrganizationInvitationConnection = {
	__typename?: 'OrganizationInvitationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationInvitationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Invitation>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationInvitationConnection. */
	permissions: OrganizationInvitationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationInvitationConnectionPermissions = {
	__typename?: 'OrganizationInvitationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationInvitationEdge = {
	__typename?: 'OrganizationInvitationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Invitation>;
};

/** A connection from an Organization to Licenses. */
export type OrganizationLicenseConnection = {
	__typename?: 'OrganizationLicenseConnection';
	/** A list of active Licenses associated with the organization. */
	activeLicenseTypes: Scalars['JSON'];
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationLicenseEdge>>>;
	/** A list of all Licenses. */
	licenseTypes: Scalars['JSON'];
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<License>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationLicenseConnection. */
	permissions: OrganizationLicenseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
	/** JSON dictionary LicenseType => {unlimited:, allotted:, allocated:, invited:, available:}. */
	totalsByLicense: Scalars['JSON'];
	/** A list of available call licenses. */
	totalsCallLicenses: Scalars['JSON'];
	/** A list of available scenario licenses. */
	totalsScenarioLicenses: Scalars['JSON'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationLicenseConnectionPermissions = {
	__typename?: 'OrganizationLicenseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationLicenseEdge = {
	__typename?: 'OrganizationLicenseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<License>;
};

/** A connection from a Node. */
export type OrganizationOrganizationServerConnection = {
	__typename?: 'OrganizationOrganizationServerConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationOrganizationServerEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<OrganizationServer>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationOrganizationServerConnection. */
	permissions: OrganizationOrganizationServerConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationOrganizationServerConnectionPermissions = {
	__typename?: 'OrganizationOrganizationServerConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationOrganizationServerEdge = {
	__typename?: 'OrganizationOrganizationServerEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<OrganizationServer>;
};

/** A connection from a Node. */
export type OrganizationOrganizationServerLicenseConnection = {
	__typename?: 'OrganizationOrganizationServerLicenseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationOrganizationServerLicenseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<OrganizationServerLicense>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationOrganizationServerLicenseConnection. */
	permissions: OrganizationOrganizationServerLicenseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationOrganizationServerLicenseConnectionPermissions = {
	__typename?: 'OrganizationOrganizationServerLicenseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationOrganizationServerLicenseEdge = {
	__typename?: 'OrganizationOrganizationServerLicenseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<OrganizationServerLicense>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type OrganizationPermissions = {
	__typename?: 'OrganizationPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationProjectEdge = {
	__typename?: 'OrganizationProjectEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Project>;
};

/** A connection from a Node. */
export type OrganizationScenarioCatalogConnection = {
	__typename?: 'OrganizationScenarioCatalogConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationScenarioCatalogEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioCatalog>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationScenarioCatalogConnection. */
	permissions: OrganizationScenarioCatalogConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationScenarioCatalogConnectionPermissions = {
	__typename?: 'OrganizationScenarioCatalogConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationScenarioCatalogEdge = {
	__typename?: 'OrganizationScenarioCatalogEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioCatalog>;
};

/** A connection from an Organization to Scenarios. */
export type OrganizationScenarioConnection = {
	__typename?: 'OrganizationScenarioConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationScenarioEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Scenario>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationScenarioConnection. */
	permissions: OrganizationScenarioConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
	/** Url for Company access to Worklink Create. */
	worklinkCreateUrl?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationScenarioConnectionPermissions = {
	__typename?: 'OrganizationScenarioConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationScenarioEdge = {
	__typename?: 'OrganizationScenarioEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Scenario>;
};

/** A connection from a Node. */
export type OrganizationScenarioReleaseConnection = {
	__typename?: 'OrganizationScenarioReleaseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationScenarioReleaseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioRelease>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationScenarioReleaseConnection. */
	permissions: OrganizationScenarioReleaseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationScenarioReleaseConnectionPermissions = {
	__typename?: 'OrganizationScenarioReleaseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationScenarioReleaseEdge = {
	__typename?: 'OrganizationScenarioReleaseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioRelease>;
};

/** A connection from a Node. */
export type OrganizationScenarioSessionConnection = {
	__typename?: 'OrganizationScenarioSessionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationScenarioSessionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSession>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationScenarioSessionConnection. */
	permissions: OrganizationScenarioSessionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationScenarioSessionConnectionPermissions = {
	__typename?: 'OrganizationScenarioSessionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationScenarioSessionEdge = {
	__typename?: 'OrganizationScenarioSessionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSession>;
};

/** A Node in the graph. */
export type OrganizationServer = NodeInterface & {
	__typename?: 'OrganizationServer';
	/** whether the server is active, inactive. */
	active?: Maybe<Scalars['Boolean']>;
	/** server address. */
	address?: Maybe<Scalars['String']>;
	/** when the server was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** the actual id within the database. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** the type of server. */
	installationType?: Maybe<OrganizationServerInstallationTypeEnum>;
	/** the name of the server. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** the associated organization. */
	organization?: Maybe<Organization>;
	/** the licenses associated to this server. */
	organizationServerLicenses?: Maybe<Array<OrganizationServerLicense>>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the OrganizationServer. */
	permissions: OrganizationServerPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** when the server was updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

export enum OrganizationServerInstallationTypeEnum {
	/** Docker Swarm. */
	DockerSwarm = 'DOCKER_SWARM',
	/** EKS. */
	Eks = 'EKS',
	/** Openshift. */
	Openshift = 'OPENSHIFT',
	/** Other. */
	Other = 'OTHER',
	/** Single Node. */
	SingleNode = 'SINGLE_NODE'
}

/** Represents an Organization Server License. */
export type OrganizationServerLicense = NodeInterface & {
	__typename?: 'OrganizationServerLicense';
	/** calling license. */
	callingAccess?: Maybe<Scalars['Boolean']>;
	/** calling license expiration. */
	callingAccessExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** When the license was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Downloadable license configuration. */
	downloadableLicense?: Maybe<Scalars['String']>;
	/** encrypted license. */
	encryptedLicense?: Maybe<Scalars['String']>;
	/** encryption key of the associated on-prem organization. */
	encryptionKey?: Maybe<Scalars['String']>;
	/** When the license expires. */
	expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** author licenses. */
	licensesAllottedToAuthors?: Maybe<Scalars['String']>;
	/** expert licenses. */
	licensesAllottedToExperts?: Maybe<Scalars['String']>;
	/** tech+ licenses. */
	licensesAllottedToTechPluses?: Maybe<Scalars['String']>;
	/** tech licenses. */
	licensesAllottedToTechs?: Maybe<Scalars['String']>;
	/** viewer licenses. */
	licensesAllottedToViewers?: Maybe<Scalars['String']>;
	/** The name of the Organization Server License. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** organization. */
	organization?: Maybe<Organization>;
	/** the server that the license is associated with. */
	organizationServer?: Maybe<OrganizationServer>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** permalink of the associated on-prem organization. */
	permalink?: Maybe<Scalars['String']>;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationServerLicense. */
	permissions: OrganizationServerLicensePermissions;
	/** scenario access. */
	scenarioAccess?: Maybe<Scalars['Boolean']>;
	/** scenario access expiration. */
	scenarioAccessExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Denormalized server address. */
	serverAddress?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** whether the license is active or expired. */
	status?: Maybe<OrganizationServerLicenseStatusEnum>;
	/** The last time the license was modified. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type OrganizationServerLicensePermissions = {
	__typename?: 'OrganizationServerLicensePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum OrganizationServerLicenseStatusEnum {
	/** License is active. */
	Active = 'ACTIVE',
	/** License is expired. */
	Expired = 'EXPIRED',
	/** License is inactive. */
	Inactive = 'INACTIVE'
}

/** Autogenerated nested input type of OrganizationServerLicenseUpsertInputObject */
export type OrganizationServerLicenseUpsertInputObjectOrganizationServerInput = {
	/** the id of the server that the license is associated with. */
	id: Scalars['ID'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type OrganizationServerPermissions = {
	__typename?: 'OrganizationServerPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Represents an Organization's SSO parameters. */
export type OrganizationSsoDetail = NodeInterface & {
	__typename?: 'OrganizationSsoDetail';
	/** The full URL for the SSO provider. */
	baseUrl?: Maybe<Scalars['String']>;
	/** The SSO provider's callback URL. */
	callbackUrl?: Maybe<Scalars['String']>;
	/** The Client ID generated by the SSO provider for authentication. */
	clientId?: Maybe<Scalars['String']>;
	/** The Client Secret generated by the SSO provider for authentication. */
	clientSecret?: Maybe<Scalars['String']>;
	/** Set of configuration attributes. */
	config?: Maybe<OrganizationSsoDetailConfiguration>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of Organization SSO domains used for authentication. */
	domains?: Maybe<Array<OrganizationSsoDomain>>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name for the SSO provider. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/**
   * The Organization the SSO details belong to.
   * @deprecated Not yet implemented.
   */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the OrganizationSsoDetail. */
	permissions: OrganizationSsoDetailPermissions;
	/** The SSO provider used by the Organization. */
	providerName?: Maybe<SsoProviderEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The Tenant ID of the Azure AD. */
	tenantId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** An Object. */
export type OrganizationSsoDetailConfiguration = {
	__typename?: 'OrganizationSsoDetailConfiguration';
	/** IDP token auth configuration attributes. */
	idpTokenAuth?: Maybe<Scalars['JSON']>;
	/** User attribute to include in the SSO route as login_hint parameter. */
	loginHint?: Maybe<SsoLoginHintEnum>;
	/** SAML configuration attributes. */
	saml?: Maybe<Scalars['JSON']>;
};

/** Autogenerated nested input type of OrganizationSsoDetailInputObject */
export type OrganizationSsoDetailInputObjectConfigInput = {
	idpTokenAuth?: InputMaybe<OrganizationSsoDetailInputObjectConfigInputIdpTokenAuthInput>;
	/** User attribute to include in the SSO route as login_hint parameter. */
	loginHint?: InputMaybe<SsoLoginHintEnum>;
	saml?: InputMaybe<OrganizationSsoDetailInputObjectConfigInputSamlInput>;
};

/** Autogenerated nested input type of OrganizationSsoDetailInputObjectConfigInput */
export type OrganizationSsoDetailInputObjectConfigInputIdpTokenAuthInput = {
	/** Algorithm for IDP token authentication. */
	alg?: InputMaybe<Scalars['String']>;
	/** Audience for IDP token authentication. */
	aud?: InputMaybe<Scalars['String']>;
	/** Boolean value to enable IDP token authentication. */
	enabled?: InputMaybe<Scalars['Boolean']>;
	/** JWKS endpoint for IDP token authentication. */
	jwksEndpoint?: InputMaybe<Scalars['String']>;
	/** Validation interval in seconds for IDP token authentication. */
	validationInterval?: InputMaybe<Scalars['Int']>;
	/** Validation key for IDP token authentication. */
	validationKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated nested input type of OrganizationSsoDetailInputObjectConfigInput */
export type OrganizationSsoDetailInputObjectConfigInputSamlInput = {
	/** SAML IDP Metadadata URL. */
	metadataUrl?: InputMaybe<Scalars['String']>;
	/** SAML IDP Metadadata XML. */
	metadataXml?: InputMaybe<Scalars['String']>;
	options?: InputMaybe<OrganizationSsoDetailInputObjectConfigInputSamlInputOptionsInput>;
};

/** Autogenerated nested input type of OrganizationSsoDetailInputObjectConfigInputSamlInput */
export type OrganizationSsoDetailInputObjectConfigInputSamlInputOptionsInput = {
	requestOptions?: InputMaybe<OrganizationSsoDetailInputObjectConfigInputSamlInputOptionsInputRequestOptionsInput>;
	/** Boolean value to skip audience assertion. */
	skipAudience?: InputMaybe<Scalars['Boolean']>;
	/** Boolean value to skip authnstatement assertion. */
	skipAuthnstatement?: InputMaybe<Scalars['Boolean']>;
	/** Boolean value to skip conditions assertion. */
	skipConditions?: InputMaybe<Scalars['Boolean']>;
	/** Boolean value to skip recipient assertion. */
	skipRecipientCheck?: InputMaybe<Scalars['Boolean']>;
	/** Boolean value to skip subject assertion. */
	skipSubjectConfirmation?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated nested input type of OrganizationSsoDetailInputObjectConfigInputSamlInputOptionsInput */
export type OrganizationSsoDetailInputObjectConfigInputSamlInputOptionsInputRequestOptionsInput = {
	/** Boolean value to skip adding the subject tag to the auth request. */
	skipSubject?: InputMaybe<Scalars['Boolean']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type OrganizationSsoDetailPermissions = {
	__typename?: 'OrganizationSsoDetailPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Represents an Organization's SSO doamin. */
export type OrganizationSsoDomain = NodeInterface & {
	__typename?: 'OrganizationSsoDomain';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** An SSO URL. */
	domain?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the OrganizationSsoDomain. */
	permissions: OrganizationSsoDomainPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** Organization SSO Domain Create Arguments. */
export type OrganizationSsoDomainInputObject = {
	/** An Organization SSO URL. */
	domain: Scalars['String'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type OrganizationSsoDomainPermissions = {
	__typename?: 'OrganizationSsoDomainPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum OrganizationStatusEnum {
	/** Organization is active. */
	Active = 'ACTIVE',
	/** Organization is closed. */
	Closed = 'CLOSED',
	/** Organization is pending closing. */
	PendingClose = 'PENDING_CLOSE'
}

export enum OrganizationTypeEnum {
	/** Organization for intenral use. */
	Internal = 'INTERNAL',
	/** Organization for partner. */
	Partner = 'PARTNER',
	/** Organization for pilot. */
	Pilot = 'PILOT',
	/** Organization for production. */
	Production = 'PRODUCTION',
	/** Organization for trial. */
	Trial = 'TRIAL'
}

/** Autogenerated nested input type of OrganizationUpsertInputObject */
export type OrganizationUpsertInputObjectCallingAccessInput = {
	/** Expiration date for calling access for organization. */
	expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
	/** Max amount of expert licenses, that can be alloted. */
	licensesAllottedToExperts: Scalars['Int'];
	/** Max amount of tech pluses licenses, that can be alloted. */
	licensesAllottedToTechPluses: Scalars['Int'];
	/** Max amount of tech licenses, that can be alloted. */
	licensesAllottedToTechs: Scalars['Int'];
};

/** Autogenerated nested input type of OrganizationUpsertInputObject */
export type OrganizationUpsertInputObjectGuestAccountPolicyInput = {
	/** Integer value for guest account invitation expiration. */
	defaultInvitationExpirationValue: Scalars['Int'];
	/** String value for identify type of the invitation expiration value. */
	defaultInvitationExpirationValueType: Scalars['String'];
	/** Policy type for guest account. */
	defaultLicenseExpirationPolicy: Scalars['String'];
	/** Integer value for guest account license expiration. */
	defaultLicenseExpirationValue?: InputMaybe<Scalars['Int']>;
	/** String value for identify type of the license expiration value. */
	defaultLicenseExpirationValueType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated nested input type of OrganizationUpsertInputObject */
export type OrganizationUpsertInputObjectScenarioAccessInput = {
	/** Expiration date for scenario access for organization. */
	expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
	/** Max amount of author licenses, that can be alloted. */
	licensesAllottedToAuthors: Scalars['Int'];
	/** Max amount of viewer licenses, that can be alloted. */
	licensesAllottedToViewers: Scalars['Int'];
};

/** A connection from a Node. */
export type OrganizationUserConnection = {
	__typename?: 'OrganizationUserConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationUserEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<User>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationUserConnection. */
	permissions: OrganizationUserConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationUserConnectionPermissions = {
	__typename?: 'OrganizationUserConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationUserEdge = {
	__typename?: 'OrganizationUserEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<User>;
};

/** A connection from a Node. */
export type OrganizationWebhookSubscriptionConnection = {
	__typename?: 'OrganizationWebhookSubscriptionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationWebhookSubscriptionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookSubscription>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the OrganizationWebhookSubscriptionConnection. */
	permissions: OrganizationWebhookSubscriptionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type OrganizationWebhookSubscriptionConnectionPermissions = {
	__typename?: 'OrganizationWebhookSubscriptionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type OrganizationWebhookSubscriptionEdge = {
	__typename?: 'OrganizationWebhookSubscriptionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookSubscription>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
	__typename?: 'PageInfo';
	/** When paginating forwards, the cursor to continue. */
	endCursor?: Maybe<Scalars['String']>;
	/** When paginating forwards, the index to continue. */
	endIndex?: Maybe<Scalars['Int']>;
	/** When paginating forwards, are there more items? */
	hasNextPage: Scalars['Boolean'];
	/** When paginating backwards, are there more items? */
	hasPreviousPage: Scalars['Boolean'];
	/** When paginating backwards, the cursor to continue. */
	startCursor?: Maybe<Scalars['String']>;
	/** When paginating backwards, the index to continue. */
	startIndex?: Maybe<Scalars['Int']>;
};

export enum PermissionEnum {
	/** Manage. */
	Manage = 'MANAGE',
	/** Read. */
	Read = 'READ',
	/** Review. */
	Review = 'REVIEW',
	/** Update. */
	Update = 'UPDATE'
}

export enum PermissionPermissableTypeEnum {
	/** Group. */
	Group = 'GROUP',
	/** User. */
	User = 'USER'
}

export enum PermissionResourceTypeEnum {
	/** Project. */
	Project = 'PROJECT',
	/** Scenario. */
	Scenario = 'SCENARIO'
}

/** A Node in the graph. */
export type Photo = NodeInterface & {
	__typename?: 'Photo';
	/** contains call session photo details. */
	callPhoto?: Maybe<CallPhoto>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The file contents of the photo. */
	image?: Maybe<Attachment>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Photo. */
	permissions: PhotoPermissions;
	/** contains the scenarioSession details of photo. */
	scenarioSessionV3?: Maybe<ScenarioSession>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The user associated with the photo. */
	user?: Maybe<User>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type PhotoPermissions = {
	__typename?: 'PhotoPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum PlanUsageStatusEnum {
	/** A Scenario has been released. */
	Active = 'ACTIVE',
	/** A Scenario has been deleted. */
	Deleted = 'DELETED',
	/** A Scenario has been released. */
	Inactive = 'INACTIVE'
}

export enum PlatformTypeEnum {
	/** Android device. */
	Android = 'ANDROID',
	/** hololens device. */
	Hololens = 'HOLOLENS',
	/** ios device. */
	Ios = 'IOS',
	/** Ipad device. */
	Ipad = 'IPAD',
	/** Windows device. */
	Wsa = 'WSA'
}

/** Represents a published file pertaining to a Scope AR product. */
export type ProductRelease = NodeInterface & {
	__typename?: 'ProductRelease';
	/** The content associated with the ProductRelease. */
	content?: Maybe<Attachment>;
	/** The date the ProductRelease was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Default APP store url for the given type where the ProductRelease can be found. */
	defaultAppStoreUrl?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** 3rd party data associated with the ProductRelease. */
	externalData?: Maybe<Scalars['JSON']>;
	/** External url where the ProductRelease content can be found. */
	externalUrl?: Maybe<Scalars['String']>;
	/** A list of states associated with the ProductRelease. */
	flags: Scalars['JSON'];
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the ProductRelease. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ProductRelease. */
	permissions: ProductReleasePermissions;
	/** Either a public link to the release file or the external url. */
	publicUrl?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The unique url slug of the ProductRelease. */
	slug?: Maybe<Scalars['String']>;
	/** The product type of the ProductRelease. */
	type?: Maybe<ProductReleaseTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The fully qualified version of the ProductRelease. */
	version?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ProductReleasePermissions = {
	__typename?: 'ProductReleasePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ProductReleaseTypeEnum {
	/** A ProductRelease for marker package. */
	MarkerPackage = 'MARKER_PACKAGE',
	/** A ProductRelease for numbered markers. */
	NumberedMarkers = 'NUMBERED_MARKERS',
	/** A ProductRelease for rar android. */
	RarAndroid = 'RAR_ANDROID',
	/** A ProductRelease for rar android apk. */
	RarAndroidApk = 'RAR_ANDROID_APK',
	/** A ProductRelease for rar ios. */
	RarIos = 'RAR_IOS',
	/** A ProductRelease for rar ios ipa. */
	RarIosIpa = 'RAR_IOS_IPA',
	/** A ProductRelease for rar odg. */
	RarOdg = 'RAR_ODG',
	/** A ProductRelease for rar osx. */
	RarOsx = 'RAR_OSX',
	/** A ProductRelease for rar tutorial. */
	RarTutorial = 'RAR_TUTORIAL',
	/** A ProductRelease for rar web recording player. */
	RarWebRecordingPlayer = 'RAR_WEB_RECORDING_PLAYER',
	/** A ProductRelease for rar windows. */
	RarWindows = 'RAR_WINDOWS',
	/** A ProductRelease for rar windows 7. */
	RarWindows_7 = 'RAR_WINDOWS_7',
	/** A ProductRelease for rar wsa. */
	RarWsa = 'RAR_WSA',
	/** A ProductRelease for rar wsa appxbundle. */
	RarWsaAppxbundle = 'RAR_WSA_APPXBUNDLE',
	/** A ProductRelease for rar wsa hl. */
	RarWsaHl = 'RAR_WSA_HL',
	/** A ProductRelease for rar wsa hl appxbundle. */
	RarWsaHlAppxbundle = 'RAR_WSA_HL_APPXBUNDLE',
	/** A ProductRelease for sample project. */
	SampleProject = 'SAMPLE_PROJECT',
	/** A ProductRelease for sample project marker. */
	SampleProjectMarker = 'SAMPLE_PROJECT_MARKER',
	/** A ProductRelease for sample project summary. */
	SampleProjectSummary = 'SAMPLE_PROJECT_SUMMARY',
	/** A ProductRelease for standard marker. */
	StandardMarker = 'STANDARD_MARKER',
	/** A ProductRelease for worklink android. */
	WorklinkAndroid = 'WORKLINK_ANDROID',
	/** A ProductRelease for worklink android apk. */
	WorklinkAndroidApk = 'WORKLINK_ANDROID_APK',
	/** A ProductRelease for worklink authoring assistant wsa. */
	WorklinkAuthoringAssistantWsa = 'WORKLINK_AUTHORING_ASSISTANT_WSA',
	/** A ProductRelease for worklink authoring assistant wsa appxbundle. */
	WorklinkAuthoringAssistantWsaAppxbundle = 'WORKLINK_AUTHORING_ASSISTANT_WSA_APPXBUNDLE',
	/** A ProductRelease for worklink authoring platform. */
	WorklinkAuthoringPlatform = 'WORKLINK_AUTHORING_PLATFORM',
	/** A ProductRelease for worklink authoring platform manual. */
	WorklinkAuthoringPlatformManual = 'WORKLINK_AUTHORING_PLATFORM_MANUAL',
	/** A ProductRelease for worklink installer mac. */
	WorklinkInstallerMac = 'WORKLINK_INSTALLER_MAC',
	/** A ProductRelease for worklink installer win. */
	WorklinkInstallerWin = 'WORKLINK_INSTALLER_WIN',
	/** A ProductRelease for worklink ios. */
	WorklinkIos = 'WORKLINK_IOS',
	/** A ProductRelease for worklink ios ipa. */
	WorklinkIosIpa = 'WORKLINK_IOS_IPA',
	/** A ProductRelease for worklink release notes. */
	WorklinkReleaseNotes = 'WORKLINK_RELEASE_NOTES',
	/** A ProductRelease for worklink tutorial. */
	WorklinkTutorial = 'WORKLINK_TUTORIAL',
	/** A ProductRelease for worklink tutorial intermediate. */
	WorklinkTutorialIntermediate = 'WORKLINK_TUTORIAL_INTERMEDIATE',
	/** A ProductRelease for worklink wsa. */
	WorklinkWsa = 'WORKLINK_WSA',
	/** A ProductRelease for worklink wsa appxbundle. */
	WorklinkWsaAppxbundle = 'WORKLINK_WSA_APPXBUNDLE',
	/** A ProductRelease for worklink wsa hl appxbundle. */
	WorklinkWsaHlAppxbundle = 'WORKLINK_WSA_HL_APPXBUNDLE'
}

/** Represent a Scope Create project. */
export type Project = NodeInterface & {
	__typename?: 'Project';
	/** A list of AuditLogs associated with the Project. */
	auditLogs?: Maybe<AuditLogConnection>;
	/** The date the Project was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The User that created the Project. */
	createdBy?: Maybe<User>;
	/** The latest Project Save File associated with the Project. */
	currentSaveFile?: Maybe<ProjectSaveFile>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The list of users that have updated the Project. */
	editors?: Maybe<Array<User>>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the Project. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Project. */
	permissions: ProjectPermissions;
	/** List of Project Export Jobs associated with the Project. */
	projectExportJobs?: Maybe<ProjectProjectExportJobConnection>;
	/** List of project import jobs associated with the project. */
	projectImportJobs?: Maybe<ProjectProjectImportJobConnection>;
	/** List of project merge jobs associated with the project. */
	projectMergeJobs?: Maybe<ProjectProjectMergeJobConnection>;
	/** The resource permissions for the Project. */
	resourcePermissions?: Maybe<Array<ResourcePermission>>;
	/** Name of the revision group associated with the project. */
	revisionGroupName?: Maybe<Scalars['String']>;
	/** Name of the current project revision. */
	revisionName?: Maybe<Scalars['String']>;
	/** Notes or comments associated with the current project revision. */
	revisionNotes?: Maybe<Scalars['String']>;
	/** Number of the current project revision. */
	revisionNumber?: Maybe<Scalars['Int']>;
	/** Project used as the source for this revision. */
	revisionSourceProject?: Maybe<Project>;
	/** Save file from which this project revision was created. */
	revisionSourceSaveFile?: Maybe<ProjectSaveFile>;
	/** List of revisions associated with this project. */
	revisions?: Maybe<Array<Project>>;
	/** A list of Project Save Files associated with the Project. */
	saveFiles?: Maybe<ProjectProjectSaveFileConnection>;
	/** A list of Scenarios associated with the Project. */
	scenarios?: Maybe<Array<Scenario>>;
	/** The version of the Create build the Project was created with. */
	scopeCreateVersion?: Maybe<Scalars['String']>;
	/** All the versions of the Create build the Project was updated with. */
	scopeCreateVersions?: Maybe<Array<Scalars['String']>>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The state of the Project. */
	state?: Maybe<ProjectStateEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The User that last updated the Project. */
	updatedBy?: Maybe<User>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The version of the Project. */
	version?: Maybe<Scalars['Int']>;
};


/** Represent a Scope Create project. */
export type ProjectAuditLogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	data?: InputMaybe<AuditLogsDataInput>;
	dataPath?: InputMaybe<Scalars['String']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	subjectId?: InputMaybe<Scalars['ID']>;
	types?: InputMaybe<Array<AuditLogTypeEnum>>;
	userIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Represent a Scope Create project. */
export type ProjectProjectExportJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectExportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};


/** Represent a Scope Create project. */
export type ProjectProjectImportJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectImportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};


/** Represent a Scope Create project. */
export type ProjectProjectMergeJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectImportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};


/** Represent a Scope Create project. */
export type ProjectRevisionsArgs = {
	createdByDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	latestRevisionOnly?: InputMaybe<Scalars['Boolean']>;
	name?: InputMaybe<Scalars['String']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
	sharedList?: InputMaybe<Scalars['Boolean']>;
	sharedWithDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	sharedWithIds?: InputMaybe<Array<Scalars['ID']>>;
	states?: InputMaybe<Array<ProjectStateEnum>>;
	updatedAt?: InputMaybe<DateRangeInputObject>;
	updatedByIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Represent a Scope Create project. */
export type ProjectSaveFilesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	includeDeleted?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
	saveTypes?: InputMaybe<Array<ProjectSaveFileSaveTypeEnum>>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
};

/** An edge in a connection. */
export type ProjectAuditLogEdge = {
	__typename?: 'ProjectAuditLogEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<AuditLog>;
};

/** A connection to Projects. */
export type ProjectConnection = {
	__typename?: 'ProjectConnection';
	/** List of authors for all Projects in the connection. */
	authors?: Maybe<Array<User>>;
	/** List of creators for all Projects in the connection. */
	creators?: Maybe<Array<User>>;
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<OrganizationProjectEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Project>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** List of unique Groups and Users all Projects in the connection have been shared with. */
	permissables?: Maybe<Array<NodeInterface>>;
	/** A list of Permissions associated with the currently authenticated User and the ProjectConnection. */
	permissions: ProjectConnectionPermissions;
	/** List of Scope Create versions for all Projects in the connection. */
	scopeCreateVersions?: Maybe<Array<Scalars['String']>>;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectConnectionPermissions = {
	__typename?: 'ProjectConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
	/** Whether the currently authenticated User can perform Project index operations in Worklink Create app. */
	canIndexInCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform Project review operations in Worklink Create app. */
	canReview: AuthorizationResult;
};

/** A Node in the graph. */
export type ProjectExportJob = NodeInterface & {
	__typename?: 'ProjectExportJob';
	/** The asset packaging method used in the Project Export Job. */
	assetPackaging?: Maybe<ProjectExportJobAssetPackagingEnum>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The user who created the Project Export Job. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Any errors encountered during the Project Export Job. */
	error?: Maybe<Scalars['String']>;
	/** The file associated with the Project Export Job. */
	file?: Maybe<Attachment>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ProjectExportJob. */
	permissions: ProjectExportJobPermissions;
	/** The date and time when the processing of the Project Export Job ended. */
	processEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the processing of the Project Export Job started. */
	processStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The current processing status of the Project Export Job. */
	processStatus?: Maybe<ProjectExportJobStatusEnum>;
	/** The project associated with the Project Export Job. */
	project?: Maybe<Project>;
	/** The save file associated with the Project Export Job. */
	projectSaveFile?: Maybe<ProjectSaveFile>;
	/** The date and time when the Project Export Job was queued. */
	queuedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Indicates whether the export job is for revisions only. */
	revisionOnly?: Maybe<Scalars['Boolean']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

export enum ProjectExportJobAssetPackagingEnum {
	/** Assets are deeply packaged with all associated resources. */
	Deep = 'DEEP',
	/** Only processed assets are included in the packaging. */
	ProcessedOnly = 'PROCESSED_ONLY',
	/** Assets are shallowly packaged, including only essential resources. */
	Shallow = 'SHALLOW'
}

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ProjectExportJobPermissions = {
	__typename?: 'ProjectExportJobPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ProjectExportJobStatusEnum {
	/** The Project Export Job encountered an error during processing. */
	Error = 'ERROR',
	/** The Project Export Job is currently being processed. */
	Processing = 'PROCESSING',
	/** The Project Export Job is queued and awaiting processing. */
	Queued = 'QUEUED',
	/** The Project Export Job was processed successfully. */
	Success = 'SUCCESS'
}

/** A Node in the graph. */
export type ProjectImportJob = NodeInterface & {
	__typename?: 'ProjectImportJob';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** User who created the project import job. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The base name of the imported demo project file. */
	demoProjectFileName?: Maybe<Scalars['String']>;
	/** Details of any error encountered during the import process. */
	error?: Maybe<Scalars['String']>;
	/** File associated with the project import job. */
	file?: Maybe<Attachment>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** List of model processing jobs associated with the project import job. */
	modelProcessJobs?: Maybe<ProjectImportJobModelProcessJobConnection>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ProjectImportJob. */
	permissions: ProjectImportJobPermissions;
	/** Timestamp when the project import process ended. */
	processEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Timestamp when the project import process started. */
	processStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Current status of the project import job. */
	processStatus?: Maybe<ProjectImportJobStatusEnum>;
	/** Project associated with the import job. */
	project?: Maybe<Project>;
	/** Timestamp indicating when the project import job was queued. */
	queuedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Schema version of the project import job. */
	schemaVersion?: Maybe<Scalars['Int']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** A Node in the graph. */
export type ProjectImportJobModelProcessJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type ProjectImportJobModelProcessJobConnection = {
	__typename?: 'ProjectImportJobModelProcessJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectImportJobModelProcessJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ModelProcessJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectImportJobModelProcessJobConnection. */
	permissions: ProjectImportJobModelProcessJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectImportJobModelProcessJobConnectionPermissions = {
	__typename?: 'ProjectImportJobModelProcessJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectImportJobModelProcessJobEdge = {
	__typename?: 'ProjectImportJobModelProcessJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ModelProcessJob>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ProjectImportJobPermissions = {
	__typename?: 'ProjectImportJobPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ProjectImportJobStatusEnum {
	/** The project import job has been created. */
	Created = 'CREATED',
	/** The project import job encountered an error. */
	Error = 'ERROR',
	/** The project import job is currently being processed. */
	Processing = 'PROCESSING',
	/** The project import job is queued for processing. */
	Queued = 'QUEUED',
	/** The project import job completed successfully. */
	Success = 'SUCCESS',
	/** The project import job timed out before completion. */
	Timeout = 'TIMEOUT'
}

/** A Node in the graph. */
export type ProjectMergeJob = NodeInterface & {
	__typename?: 'ProjectMergeJob';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** User who created the project merge job. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Details of any error encountered during the merge process. */
	error?: Maybe<Scalars['String']>;
	/** File associated with the project merge job. */
	file?: Maybe<Attachment>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** List of model processing jobs associated with the project merge job. */
	modelProcessJobs?: Maybe<ProjectMergeJobModelProcessJobConnection>;
	/** The Modified File associated with the project merge job. */
	modifiedFile?: Maybe<Attachment>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ProjectMergeJob. */
	permissions: ProjectMergeJobPermissions;
	/** Timestamp when the project merge process ended. */
	processEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Timestamp when the project merge process started. */
	processStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Current status of the project merge job. */
	processStatus?: Maybe<ProjectMergeJobStatusEnum>;
	/** Project associated with the merge job. */
	project?: Maybe<Project>;
	/** Timestamp indicating when the project merge job was queued. */
	queuedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** A Node in the graph. */
export type ProjectMergeJobModelProcessJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type ProjectMergeJobModelProcessJobConnection = {
	__typename?: 'ProjectMergeJobModelProcessJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectMergeJobModelProcessJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ModelProcessJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectMergeJobModelProcessJobConnection. */
	permissions: ProjectMergeJobModelProcessJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectMergeJobModelProcessJobConnectionPermissions = {
	__typename?: 'ProjectMergeJobModelProcessJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectMergeJobModelProcessJobEdge = {
	__typename?: 'ProjectMergeJobModelProcessJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ModelProcessJob>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ProjectMergeJobPermissions = {
	__typename?: 'ProjectMergeJobPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ProjectMergeJobStatusEnum {
	/** The project merge job has been created. */
	Created = 'CREATED',
	/** The project merge job encountered an error. */
	Error = 'ERROR',
	/** The project merge job is currently being processed. */
	Processing = 'PROCESSING',
	/** The project merge job is queued for processing. */
	Queued = 'QUEUED',
	/** The project merge job completed successfully. */
	Success = 'SUCCESS',
	/** The project merge job timed out before completion. */
	Timeout = 'TIMEOUT'
}

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ProjectPermissions = {
	__typename?: 'ProjectPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ProjectProjectExportJobConnection = {
	__typename?: 'ProjectProjectExportJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectProjectExportJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectExportJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectProjectExportJobConnection. */
	permissions: ProjectProjectExportJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectProjectExportJobConnectionPermissions = {
	__typename?: 'ProjectProjectExportJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectProjectExportJobEdge = {
	__typename?: 'ProjectProjectExportJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectExportJob>;
};

/** A connection from a Node. */
export type ProjectProjectImportJobConnection = {
	__typename?: 'ProjectProjectImportJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectProjectImportJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectImportJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectProjectImportJobConnection. */
	permissions: ProjectProjectImportJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectProjectImportJobConnectionPermissions = {
	__typename?: 'ProjectProjectImportJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectProjectImportJobEdge = {
	__typename?: 'ProjectProjectImportJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectImportJob>;
};

/** A connection from a Node. */
export type ProjectProjectMergeJobConnection = {
	__typename?: 'ProjectProjectMergeJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectProjectMergeJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectMergeJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectProjectMergeJobConnection. */
	permissions: ProjectProjectMergeJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectProjectMergeJobConnectionPermissions = {
	__typename?: 'ProjectProjectMergeJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectProjectMergeJobEdge = {
	__typename?: 'ProjectProjectMergeJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectMergeJob>;
};

/** A connection from a Node. */
export type ProjectProjectSaveFileConnection = {
	__typename?: 'ProjectProjectSaveFileConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectProjectSaveFileEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectSaveFile>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectProjectSaveFileConnection. */
	permissions: ProjectProjectSaveFileConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectProjectSaveFileConnectionPermissions = {
	__typename?: 'ProjectProjectSaveFileConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectProjectSaveFileEdge = {
	__typename?: 'ProjectProjectSaveFileEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectSaveFile>;
};

/** Represent a Scope Create project. */
export type ProjectSaveFile = NodeInterface & {
	__typename?: 'ProjectSaveFile';
	/** A list of Assets associated with the Project Save File. */
	assets?: Maybe<ProjectSaveFileAssetConnection>;
	/** The date the Project Save File was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The User that created the Project Save File. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The extensions version of the Project Save File. */
	extensionsVersion?: Maybe<Scalars['String']>;
	/** The file contents of the Project Save File. */
	file?: Maybe<Attachment>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the Project at the time the Save File was created. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ProjectSaveFile. */
	permissions: ProjectSaveFilePermissions;
	/** The Project associated with the Project Save File. */
	project?: Maybe<Project>;
	/** List of Project Export Jobs associated with the Project Save File. */
	projectExportJobs?: Maybe<ProjectSaveFileProjectExportJobConnection>;
	/** Whether the Save File was created as manually or automatically. */
	saveType?: Maybe<ProjectSaveFileSaveTypeEnum>;
	/** The version of the Create build the Project Save File was created with. */
	scopeCreateVersion?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The size of the Project Save File in bytes. */
	size?: Maybe<Scalars['Int']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The version of the Project Save File. */
	version?: Maybe<Scalars['Int']>;
};


/** Represent a Scope Create project. */
export type ProjectSaveFileAssetsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represent a Scope Create project. */
export type ProjectSaveFileProjectExportJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectExportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};

/** A connection from a Node. */
export type ProjectSaveFileAssetConnection = {
	__typename?: 'ProjectSaveFileAssetConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectSaveFileAssetEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Asset>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectSaveFileAssetConnection. */
	permissions: ProjectSaveFileAssetConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectSaveFileAssetConnectionPermissions = {
	__typename?: 'ProjectSaveFileAssetConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectSaveFileAssetEdge = {
	__typename?: 'ProjectSaveFileAssetEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Asset>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ProjectSaveFilePermissions = {
	__typename?: 'ProjectSaveFilePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ProjectSaveFileProjectExportJobConnection = {
	__typename?: 'ProjectSaveFileProjectExportJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectSaveFileProjectExportJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectExportJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ProjectSaveFileProjectExportJobConnection. */
	permissions: ProjectSaveFileProjectExportJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ProjectSaveFileProjectExportJobConnectionPermissions = {
	__typename?: 'ProjectSaveFileProjectExportJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ProjectSaveFileProjectExportJobEdge = {
	__typename?: 'ProjectSaveFileProjectExportJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectExportJob>;
};

export enum ProjectSaveFileSaveTypeEnum {
	/** An automatically created Project Save File. */
	Auto = 'AUTO',
	/** A manually created Project Save File. */
	Manual = 'MANUAL'
}

export enum ProjectStateEnum {
	/** Approved. */
	Approved = 'APPROVED',
	/** Archived. */
	Archived = 'ARCHIVED',
	/** Major Change Requested. */
	ChangeRequested = 'CHANGE_REQUESTED',
	/** Minor Change Requested. */
	MinorChangeRequested = 'MINOR_CHANGE_REQUESTED',
	/** Under Review. */
	UnderReview = 'UNDER_REVIEW',
	/** Work In Progress. */
	WorkInProgress = 'WORK_IN_PROGRESS'
}

/** A project. */
export type ProjectUpdateInputObject = {
	/** The database id of the project used to find the project (if not using the GQL id). */
	databaseId?: InputMaybe<Scalars['String']>;
	/** the GQL id of the project used to find the project. */
	id?: InputMaybe<Scalars['String']>;
	/** The name of the project. When revision management is enabled, this will set the name of the revision group. */
	name?: InputMaybe<Scalars['String']>;
	/** The name of the revision group. */
	revisionGroupName?: InputMaybe<Scalars['String']>;
	/** The name of the revision to be created. */
	revisionName?: InputMaybe<Scalars['String']>;
	/** Notes or comments associated with the revision. */
	revisionNotes?: InputMaybe<Scalars['String']>;
	/** The new state for the project. */
	state?: InputMaybe<ProjectStateEnum>;
};

export enum PublicResourceTypeEnum {
	/** Represents a Scenario resource type. */
	Scenario = 'SCENARIO',
	/** Represents a ScenarioCatalog resource type. */
	ScenarioCatalog = 'SCENARIO_CATALOG'
}

export enum QualityReviewEnum {
	/** A negative review. */
	Bad = 'bad',
	/** A positive review. */
	Good = 'good',
	/** Not reviewed. */
	None = 'none'
}

/** A Query into the graph. */
export type Query = {
	__typename?: 'Query';
	/** Fetches an API Token given its ID. */
	apiToken?: Maybe<ApiToken>;
	/** A list of API Tokens. */
	apiTokens?: Maybe<QueryApiTokenConnection>;
	/** Retrieve a single asset by its ID. */
	asset?: Maybe<Asset>;
	/** Retrieve a single asset revision by its ID. */
	assetRevision?: Maybe<AssetRevision>;
	/** Retrieve a list of assets based on specified filters. */
	assets?: Maybe<QueryAssetConnection>;
	/** Fetches an AuditLog given its ID. */
	auditLog?: Maybe<AuditLog>;
	/** A list of AuditLogs. */
	auditLogs?: Maybe<AuditLogConnection>;
	/** A Bulk Operation. */
	bulkOperation?: Maybe<BulkOperation>;
	/** Fetches a Call given its ID. */
	call?: Maybe<Call>;
	/** Fetches a CallLog given its ID. */
	callLog?: Maybe<CallLog>;
	/** A list of CallLogs. */
	callLogs?: Maybe<QueryCallLogConnection>;
	/** A list of CallRecordings by given userID. */
	callRecordings?: Maybe<QueryCallRecordingConnection>;
	/** A list of Calls associated with the currently authenticated User. */
	calls?: Maybe<QueryCallConnection>;
	/** Fetches a Client Certificate given its ID. */
	clientCertificate?: Maybe<ClientCertificate>;
	/** A list of Client Certificates. */
	clientCertificates?: Maybe<QueryClientCertificateConnection>;
	/** Query for the daily usage (or views of scenarios) of a company. */
	dailyUsages?: Maybe<DailyUsageConnection>;
	/** Query for retrieving a list of demo projects. */
	demoProjects?: Maybe<QueryDemoProjectConnection>;
	/** Fetches a EULA given its ID. */
	eula?: Maybe<Eula>;
	/** A list of Eulas associated with the currently authenticated User. */
	eulas?: Maybe<QueryEulaConnection>;
	/** Fetches a Group given its ID. */
	group?: Maybe<Group>;
	/** A list of Groups associated with the currently authenticated User. */
	groups?: Maybe<QueryGroupConnection>;
	/** Fetches an Integration given its ID. */
	integration?: Maybe<Integration>;
	/** A list of Integrations. */
	integrations?: Maybe<QueryIntegrationConnection>;
	/** Invitations sent out to users. */
	invitations?: Maybe<QueryInvitationConnection>;
	/** Query for retrieving a specific model processing job. */
	modelProcessJob?: Maybe<ModelProcessJob>;
	/** Query for retrieving model processing jobs. */
	modelProcessJobs?: Maybe<QueryModelProcessJobConnection>;
	/** Fetches an object given its ID. */
	node?: Maybe<NodeInterface>;
	/** Lookup nodes by a list of IDs. */
	nodes?: Maybe<Array<NodeInterface>>;
	/** Fetches a Organization given its ID. */
	organization?: Maybe<Organization>;
	/** A server of an organization. */
	organizationServer?: Maybe<OrganizationServer>;
	/** A license of an organization. */
	organizationServerLicense?: Maybe<OrganizationServerLicense>;
	/** All the licenses of an organization. */
	organizationServerLicenses?: Maybe<QueryOrganizationServerLicenseConnection>;
	/** All the servers of an organization. */
	organizationServers?: Maybe<QueryOrganizationServerConnection>;
	/** An SSO provider detail of an organization. */
	organizationSsoDetail?: Maybe<OrganizationSsoDetail>;
	/** All SSO provider details of an organization. */
	organizationSsoDetails?: Maybe<QueryOrganizationSsoDetailConnection>;
	/** A list of Organizations associated with the currently authenticated User. */
	organizations?: Maybe<QueryOrganizationConnection>;
	/** Fetches a list of photos by given userID. */
	photos?: Maybe<QueryPhotoConnection>;
	/** Fetches a ProductRelease given its ID. */
	productRelease?: Maybe<ProductRelease>;
	/** A list of Product Releases. */
	productReleases: QueryProductReleaseConnection;
	/** Fetches a Project given its ID. */
	project?: Maybe<Project>;
	/** Retrieves a list of Project Export Jobs. */
	projectExportJobs?: Maybe<QueryProjectExportJobConnection>;
	/** Query for retrieving project import jobs. */
	projectImportJobs?: Maybe<QueryProjectImportJobConnection>;
	/** Query for retrieving project merge jobs. */
	projectMergeJobs?: Maybe<QueryProjectMergeJobConnection>;
	/** A list of Project Save Files. */
	projectSaveFiles?: Maybe<QueryProjectSaveFileConnection>;
	/** A list of Projects. */
	projects?: Maybe<ProjectConnection>;
	/** Query for retrieving a specific render preview job. */
	renderPreviewJob?: Maybe<RenderPreviewJob>;
	/** Query for retrieving render preview jobs. */
	renderPreviewJobs?: Maybe<QueryRenderPreviewJobConnection>;
	/** A list of reviews that can be associated with reviewable. */
	reviews?: Maybe<Array<Review>>;
	/** Fetches a Scenario given its ID. */
	scenario?: Maybe<Scenario>;
	/** Fetches a Catalog given its ID. */
	scenarioCatalog?: Maybe<ScenarioCatalog>;
	/** A list of Catalogs associated with the currently authenticated User. */
	scenarioCatalogs?: Maybe<QueryScenarioCatalogConnection>;
	/** A list of Scenario Releases accessible by the currently authenticated User. */
	scenarioReleases?: Maybe<QueryScenarioReleaseConnection>;
	/** A Scenario Session record given its ID. */
	scenarioSession?: Maybe<ScenarioSession>;
	/** A Scenario Session Event. */
	scenarioSessionEvent?: Maybe<ScenarioSessionEvent>;
	/** A list of Scenario Session Events. */
	scenarioSessionEvents?: Maybe<QueryScenarioSessionEventConnection>;
	/** A Scenario Session Part associated with a Scenario, User, and/or ScenarioSession. */
	scenarioSessionPart?: Maybe<ScenarioSessionPart>;
	/** A list of Scenario Session Parts associated with a Scenario, User, and/or ScenarioSession. */
	scenarioSessionParts?: Maybe<QueryScenarioSessionPartConnection>;
	/** A Scenario Session Step. */
	scenarioSessionStep?: Maybe<ScenarioSessionStep>;
	/** A list of Scenario Session Steps accessible by the currently authenticated User. */
	scenarioSessionSteps?: Maybe<QueryScenarioSessionStepConnection>;
	/** A list of Scenario Sessions associated with the currently Scenario. */
	scenarioSessions?: Maybe<QueryScenarioSessionConnection>;
	/** A list of Scenarios associated with the currently authenticated User. */
	scenarios?: Maybe<QueryScenarioConnection>;
	/** Fetches a User given its ID. */
	user?: Maybe<User>;
	/** A list of Users associated with the currently authenticated User. */
	users?: Maybe<QueryUserConnection>;
	/** The currently authenticated User. */
	viewer: Viewer;
	/** Fetches a WebhookError given its ID. */
	webhookError?: Maybe<WebhookError>;
	/** A list of WebhookErrors. */
	webhookErrors?: Maybe<QueryWebhookErrorConnection>;
	/** A list of WebhookRequests. */
	webhookRequests?: Maybe<QueryWebhookRequestConnection>;
	/** Fetches a WebhookSubscription given its ID. */
	webhookSubscription?: Maybe<WebhookSubscription>;
	/** A list of WebhookSubscriptions. */
	webhookSubscriptions?: Maybe<QueryWebhookSubscriptionConnection>;
	/** A list of WebhookTopics. */
	webhookTopics: QueryWebhookTopicConnection;
};


/** A Query into the graph. */
export type QueryApiTokenArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryApiTokensArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** A Query into the graph. */
export type QueryAssetArgs = {
	databaseId?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryAssetRevisionArgs = {
	databaseId?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryAssetsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	folderDatabaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	folderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	inRootFolder?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	notInLatestVersions?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	ownerId?: InputMaybe<Scalars['ID']>;
	types?: InputMaybe<Array<AssetTypeEnum>>;
};


/** A Query into the graph. */
export type QueryAuditLogArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryAuditLogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	data?: InputMaybe<AuditLogsDataInput>;
	dataPath?: InputMaybe<Scalars['String']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	subjectId?: InputMaybe<Scalars['ID']>;
	types?: InputMaybe<Array<AuditLogTypeEnum>>;
	userIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** A Query into the graph. */
export type QueryBulkOperationArgs = {
	id?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryCallArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryCallLogArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryCallLogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	error?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	hideScopeEmployees?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	quality?: InputMaybe<Array<QualityReviewEnum>>;
};


/** A Query into the graph. */
export type QueryCallRecordingsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assembled?: InputMaybe<Scalars['Boolean']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	userId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryCallsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	externalData?: InputMaybe<CallsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	participant?: InputMaybe<CallsParticipantInput>;
	participantType?: InputMaybe<CallParticipantTypeEnum>;
	quality?: InputMaybe<Array<QualityReviewEnum>>;
	startedAt?: InputMaybe<DateRangeInputObject>;
};


/** A Query into the graph. */
export type QueryClientCertificateArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryClientCertificatesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** A Query into the graph. */
export type QueryDailyUsagesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dailyUsageQueryArguments?: InputMaybe<DailyUsageQueryInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** A Query into the graph. */
export type QueryDemoProjectsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** A Query into the graph. */
export type QueryEulaArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryEulasArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	forScope?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** A Query into the graph. */
export type QueryGroupArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	callRecipientGroups?: InputMaybe<Array<Scalars['ID']>>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioOriginGroupId?: InputMaybe<Scalars['ID']>;
	scenarioRecipientGroups?: InputMaybe<Array<Scalars['ID']>>;
};


/** A Query into the graph. */
export type QueryIntegrationArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryIntegrationsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** A Query into the graph. */
export type QueryInvitationsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	excludeStates?: InputMaybe<Array<InvitationStateEnum>>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	groups?: InputMaybe<Array<Scalars['String']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	state?: InputMaybe<Array<InvitationStateEnum>>;
	type?: InputMaybe<InvitationTypeEnum>;
};


/** A Query into the graph. */
export type QueryModelProcessJobArgs = {
	databaseId?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryModelProcessJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assetDatabaseId?: InputMaybe<Scalars['String']>;
	assetId?: InputMaybe<Scalars['ID']>;
	baseRevisionDatabaseId?: InputMaybe<Scalars['String']>;
	baseRevisionId?: InputMaybe<Scalars['ID']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ModelProcessJobStatusEnum>>;
	queuedAt?: InputMaybe<DateRangeInputObject>;
};


/** A Query into the graph. */
export type QueryNodeArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryNodesArgs = {
	ids: Array<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryOrganizationArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryOrganizationServerArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryOrganizationServerLicenseArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryOrganizationServerLicensesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	organizationServerId?: InputMaybe<Scalars['String']>;
};


/** A Query into the graph. */
export type QueryOrganizationServersArgs = {
	active?: InputMaybe<Scalars['Boolean']>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	installationTypes?: InputMaybe<Array<OrganizationServerInstallationTypeEnum>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** A Query into the graph. */
export type QueryOrganizationSsoDetailArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryOrganizationSsoDetailsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
};


/** A Query into the graph. */
export type QueryOrganizationsArgs = {
	accessTypes?: InputMaybe<Array<OrganizationAccessTypeEnum>>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	onPrem?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	status?: InputMaybe<OrganizationStatusEnum>;
	types?: InputMaybe<Array<OrganizationTypeEnum>>;
};


/** A Query into the graph. */
export type QueryPhotosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	userId: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryProductReleaseArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryProductReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	excludeLatestReleases?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	latestReleases?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	productTypes?: InputMaybe<Array<ProductReleaseTypeEnum>>;
	publicProductTypesOnly?: InputMaybe<Scalars['Boolean']>;
};


/** A Query into the graph. */
export type QueryProjectArgs = {
	databaseId?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	opened?: InputMaybe<Scalars['Boolean']>;
};


/** A Query into the graph. */
export type QueryProjectExportJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectExportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryProjectImportJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectImportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryProjectMergeJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ProjectImportJobStatusEnum>>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryProjectSaveFilesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	includeDeleted?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	projectId?: InputMaybe<Scalars['ID']>;
	saveTypes?: InputMaybe<Array<ProjectSaveFileSaveTypeEnum>>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
};


/** A Query into the graph. */
export type QueryProjectsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	latestRevisionOnly?: InputMaybe<Scalars['Boolean']>;
	name?: InputMaybe<Scalars['String']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scopeCreateVersions?: InputMaybe<Array<Scalars['String']>>;
	sharedList?: InputMaybe<Scalars['Boolean']>;
	sharedWithDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	sharedWithIds?: InputMaybe<Array<Scalars['ID']>>;
	states?: InputMaybe<Array<ProjectStateEnum>>;
	updatedAt?: InputMaybe<DateRangeInputObject>;
	updatedByIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** A Query into the graph. */
export type QueryRenderPreviewJobArgs = {
	databaseId?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryRenderPreviewJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<RenderPreviewJobStatusEnum>>;
};


/** A Query into the graph. */
export type QueryReviewsArgs = {
	ids?: InputMaybe<Array<Scalars['ID']>>;
	keys?: InputMaybe<Array<Scalars['String']>>;
};


/** A Query into the graph. */
export type QueryScenarioArgs = {
	databaseId?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	shortcode?: InputMaybe<Scalars['String']>;
};


/** A Query into the graph. */
export type QueryScenarioCatalogArgs = {
	id?: InputMaybe<Scalars['ID']>;
	shortcode?: InputMaybe<Scalars['String']>;
};


/** A Query into the graph. */
export type QueryScenarioCatalogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
};


/** A Query into the graph. */
export type QueryScenarioReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** A Query into the graph. */
export type QueryScenarioSessionArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryScenarioSessionEventArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryScenarioSessionEventsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	eventData?: InputMaybe<ScenarioSessionEventsEventDataInput>;
	eventTypes?: InputMaybe<Array<ScenarioSessionEventTypeEnum>>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioIds?: InputMaybe<Array<Scalars['ID']>>;
	scenarioSessionId?: InputMaybe<Scalars['ID']>;
	scenarioSessionPartId?: InputMaybe<Scalars['ID']>;
	startedAtRange?: InputMaybe<DateRangeInputObject>;
	user?: InputMaybe<ScenarioSessionEventsUserInput>;
	valueTypes?: InputMaybe<Array<ScenarioStepItemTypeEnum>>;
};


/** A Query into the graph. */
export type QueryScenarioSessionPartArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryScenarioSessionPartsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	excludeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	externalData?: InputMaybe<ScenarioSessionPartsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	includeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionPartsUserInput>;
};


/** A Query into the graph. */
export type QueryScenarioSessionStepArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryScenarioSessionStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	scenarioSessionId?: InputMaybe<Scalars['ID']>;
	scenarioStepId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryScenarioSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	externalData?: InputMaybe<ScenarioSessionsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionsUserInput>;
	versions?: InputMaybe<Array<Scalars['Int']>>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** A Query into the graph. */
export type QueryScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** A Query into the graph. */
export type QueryUserArgs = {
	id?: InputMaybe<Scalars['ID']>;
	username?: InputMaybe<Scalars['String']>;
};


/** A Query into the graph. */
export type QueryUsersArgs = {
	active?: InputMaybe<Scalars['Boolean']>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	emails?: InputMaybe<Array<Scalars['String']>>;
	excludeGroups?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	groupNames?: InputMaybe<Array<Scalars['String']>>;
	groups?: InputMaybe<Array<Scalars['String']>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	jobTitles?: InputMaybe<Array<Scalars['String']>>;
	last?: InputMaybe<Scalars['Int']>;
	licenseTypes?: InputMaybe<Array<LicenseTypeEnum>>;
	memberType?: InputMaybe<MemberTypeEnum>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	originGroupIds?: InputMaybe<Array<Scalars['ID']>>;
	usernames?: InputMaybe<Array<Scalars['String']>>;
};


/** A Query into the graph. */
export type QueryWebhookErrorArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryWebhookErrorsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	lastOccurrenceAt?: InputMaybe<DateRangeInputObject>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	webhookSubscriptionId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryWebhookRequestsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdAt?: InputMaybe<DateRangeInputObject>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	success?: InputMaybe<Scalars['Boolean']>;
	webhookSubscriptionId?: InputMaybe<Scalars['ID']>;
};


/** A Query into the graph. */
export type QueryWebhookSubscriptionArgs = {
	id: Scalars['ID'];
};


/** A Query into the graph. */
export type QueryWebhookSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	integrationId?: InputMaybe<Scalars['ID']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	status?: InputMaybe<Scalars['Boolean']>;
	topic?: InputMaybe<Array<Scalars['String']>>;
};


/** A Query into the graph. */
export type QueryWebhookTopicsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type QueryApiTokenConnection = {
	__typename?: 'QueryApiTokenConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryApiTokenEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ApiToken>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryApiTokenConnection. */
	permissions: QueryApiTokenConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryApiTokenConnectionPermissions = {
	__typename?: 'QueryApiTokenConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryApiTokenEdge = {
	__typename?: 'QueryApiTokenEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ApiToken>;
};

/** A connection from a Node. */
export type QueryAssetConnection = {
	__typename?: 'QueryAssetConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryAssetEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Asset>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryAssetConnection. */
	permissions: QueryAssetConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryAssetConnectionPermissions = {
	__typename?: 'QueryAssetConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryAssetEdge = {
	__typename?: 'QueryAssetEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Asset>;
};

/** A connection from a Node. */
export type QueryCallConnection = {
	__typename?: 'QueryCallConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryCallEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Call>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryCallConnection. */
	permissions: QueryCallConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryCallConnectionPermissions = {
	__typename?: 'QueryCallConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryCallEdge = {
	__typename?: 'QueryCallEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Call>;
};

/** A connection from a Node. */
export type QueryCallLogConnection = {
	__typename?: 'QueryCallLogConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryCallLogEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallLog>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryCallLogConnection. */
	permissions: QueryCallLogConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryCallLogConnectionPermissions = {
	__typename?: 'QueryCallLogConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryCallLogEdge = {
	__typename?: 'QueryCallLogEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallLog>;
};

/** A connection from a Node. */
export type QueryCallRecordingConnection = {
	__typename?: 'QueryCallRecordingConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryCallRecordingEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<CallRecording>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryCallRecordingConnection. */
	permissions: QueryCallRecordingConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryCallRecordingConnectionPermissions = {
	__typename?: 'QueryCallRecordingConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryCallRecordingEdge = {
	__typename?: 'QueryCallRecordingEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<CallRecording>;
};

/** A connection from a Node. */
export type QueryClientCertificateConnection = {
	__typename?: 'QueryClientCertificateConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryClientCertificateEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ClientCertificate>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryClientCertificateConnection. */
	permissions: QueryClientCertificateConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryClientCertificateConnectionPermissions = {
	__typename?: 'QueryClientCertificateConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryClientCertificateEdge = {
	__typename?: 'QueryClientCertificateEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ClientCertificate>;
};

/** The connection type for DemoProject. */
export type QueryDemoProjectConnection = {
	__typename?: 'QueryDemoProjectConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryDemoProjectEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<DemoProject>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type QueryDemoProjectEdge = {
	__typename?: 'QueryDemoProjectEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<DemoProject>;
};

/** A connection from a Node. */
export type QueryEulaConnection = {
	__typename?: 'QueryEulaConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryEulaEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Eula>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryEulaConnection. */
	permissions: QueryEulaConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryEulaConnectionPermissions = {
	__typename?: 'QueryEulaConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryEulaEdge = {
	__typename?: 'QueryEulaEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Eula>;
};

/** A connection from a Node. */
export type QueryGroupConnection = {
	__typename?: 'QueryGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryGroupConnection. */
	permissions: QueryGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryGroupConnectionPermissions = {
	__typename?: 'QueryGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryGroupEdge = {
	__typename?: 'QueryGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A connection from a Node. */
export type QueryIntegrationConnection = {
	__typename?: 'QueryIntegrationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryIntegrationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Integration>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryIntegrationConnection. */
	permissions: QueryIntegrationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryIntegrationConnectionPermissions = {
	__typename?: 'QueryIntegrationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryIntegrationEdge = {
	__typename?: 'QueryIntegrationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Integration>;
};

/** A connection from a Node. */
export type QueryInvitationConnection = {
	__typename?: 'QueryInvitationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryInvitationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Invitation>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryInvitationConnection. */
	permissions: QueryInvitationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryInvitationConnectionPermissions = {
	__typename?: 'QueryInvitationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryInvitationEdge = {
	__typename?: 'QueryInvitationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Invitation>;
};

/** A connection from a Node. */
export type QueryModelProcessJobConnection = {
	__typename?: 'QueryModelProcessJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryModelProcessJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ModelProcessJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryModelProcessJobConnection. */
	permissions: QueryModelProcessJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryModelProcessJobConnectionPermissions = {
	__typename?: 'QueryModelProcessJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryModelProcessJobEdge = {
	__typename?: 'QueryModelProcessJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ModelProcessJob>;
};

/** A connection from a Node. */
export type QueryOrganizationConnection = {
	__typename?: 'QueryOrganizationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryOrganizationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Organization>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryOrganizationConnection. */
	permissions: QueryOrganizationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryOrganizationConnectionPermissions = {
	__typename?: 'QueryOrganizationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
	/** Whether the currently authenticated user can manage ALL companies. */
	canManage: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryOrganizationEdge = {
	__typename?: 'QueryOrganizationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Organization>;
};

/** A connection from a Node. */
export type QueryOrganizationServerConnection = {
	__typename?: 'QueryOrganizationServerConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryOrganizationServerEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<OrganizationServer>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryOrganizationServerConnection. */
	permissions: QueryOrganizationServerConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryOrganizationServerConnectionPermissions = {
	__typename?: 'QueryOrganizationServerConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryOrganizationServerEdge = {
	__typename?: 'QueryOrganizationServerEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<OrganizationServer>;
};

/** A connection from a Node. */
export type QueryOrganizationServerLicenseConnection = {
	__typename?: 'QueryOrganizationServerLicenseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryOrganizationServerLicenseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<OrganizationServerLicense>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryOrganizationServerLicenseConnection. */
	permissions: QueryOrganizationServerLicenseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryOrganizationServerLicenseConnectionPermissions = {
	__typename?: 'QueryOrganizationServerLicenseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryOrganizationServerLicenseEdge = {
	__typename?: 'QueryOrganizationServerLicenseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<OrganizationServerLicense>;
};

/** A connection from a Node. */
export type QueryOrganizationSsoDetailConnection = {
	__typename?: 'QueryOrganizationSsoDetailConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryOrganizationSsoDetailEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<OrganizationSsoDetail>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryOrganizationSsoDetailConnection. */
	permissions: QueryOrganizationSsoDetailConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryOrganizationSsoDetailConnectionPermissions = {
	__typename?: 'QueryOrganizationSsoDetailConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryOrganizationSsoDetailEdge = {
	__typename?: 'QueryOrganizationSsoDetailEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<OrganizationSsoDetail>;
};

/** A connection from a Node. */
export type QueryPhotoConnection = {
	__typename?: 'QueryPhotoConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryPhotoEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Photo>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryPhotoConnection. */
	permissions: QueryPhotoConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryPhotoConnectionPermissions = {
	__typename?: 'QueryPhotoConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryPhotoEdge = {
	__typename?: 'QueryPhotoEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Photo>;
};

/** A connection from a Node. */
export type QueryProductReleaseConnection = {
	__typename?: 'QueryProductReleaseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryProductReleaseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProductRelease>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryProductReleaseConnection. */
	permissions: QueryProductReleaseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryProductReleaseConnectionPermissions = {
	__typename?: 'QueryProductReleaseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryProductReleaseEdge = {
	__typename?: 'QueryProductReleaseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProductRelease>;
};

/** A connection from a Node. */
export type QueryProjectExportJobConnection = {
	__typename?: 'QueryProjectExportJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryProjectExportJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectExportJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryProjectExportJobConnection. */
	permissions: QueryProjectExportJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryProjectExportJobConnectionPermissions = {
	__typename?: 'QueryProjectExportJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryProjectExportJobEdge = {
	__typename?: 'QueryProjectExportJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectExportJob>;
};

/** A connection from a Node. */
export type QueryProjectImportJobConnection = {
	__typename?: 'QueryProjectImportJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryProjectImportJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectImportJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryProjectImportJobConnection. */
	permissions: QueryProjectImportJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryProjectImportJobConnectionPermissions = {
	__typename?: 'QueryProjectImportJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryProjectImportJobEdge = {
	__typename?: 'QueryProjectImportJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectImportJob>;
};

/** A connection from a Node. */
export type QueryProjectMergeJobConnection = {
	__typename?: 'QueryProjectMergeJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryProjectMergeJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectMergeJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryProjectMergeJobConnection. */
	permissions: QueryProjectMergeJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryProjectMergeJobConnectionPermissions = {
	__typename?: 'QueryProjectMergeJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryProjectMergeJobEdge = {
	__typename?: 'QueryProjectMergeJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectMergeJob>;
};

/** A connection from a Node. */
export type QueryProjectSaveFileConnection = {
	__typename?: 'QueryProjectSaveFileConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryProjectSaveFileEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ProjectSaveFile>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryProjectSaveFileConnection. */
	permissions: QueryProjectSaveFileConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryProjectSaveFileConnectionPermissions = {
	__typename?: 'QueryProjectSaveFileConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryProjectSaveFileEdge = {
	__typename?: 'QueryProjectSaveFileEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ProjectSaveFile>;
};

/** A connection from a Node. */
export type QueryRenderPreviewJobConnection = {
	__typename?: 'QueryRenderPreviewJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryRenderPreviewJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<RenderPreviewJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryRenderPreviewJobConnection. */
	permissions: QueryRenderPreviewJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryRenderPreviewJobConnectionPermissions = {
	__typename?: 'QueryRenderPreviewJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryRenderPreviewJobEdge = {
	__typename?: 'QueryRenderPreviewJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<RenderPreviewJob>;
};

/** A connection from a Node. */
export type QueryScenarioCatalogConnection = {
	__typename?: 'QueryScenarioCatalogConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioCatalogEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioCatalog>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioCatalogConnection. */
	permissions: QueryScenarioCatalogConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioCatalogConnectionPermissions = {
	__typename?: 'QueryScenarioCatalogConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioCatalogEdge = {
	__typename?: 'QueryScenarioCatalogEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioCatalog>;
};

/** A connection from a Node. */
export type QueryScenarioConnection = {
	__typename?: 'QueryScenarioConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Scenario>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioConnection. */
	permissions: QueryScenarioConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioConnectionPermissions = {
	__typename?: 'QueryScenarioConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioEdge = {
	__typename?: 'QueryScenarioEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Scenario>;
};

/** A connection from a Node. */
export type QueryScenarioReleaseConnection = {
	__typename?: 'QueryScenarioReleaseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioReleaseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioRelease>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioReleaseConnection. */
	permissions: QueryScenarioReleaseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioReleaseConnectionPermissions = {
	__typename?: 'QueryScenarioReleaseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioReleaseEdge = {
	__typename?: 'QueryScenarioReleaseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioRelease>;
};

/** A connection from a Node. */
export type QueryScenarioSessionConnection = {
	__typename?: 'QueryScenarioSessionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioSessionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSession>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioSessionConnection. */
	permissions: QueryScenarioSessionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioSessionConnectionPermissions = {
	__typename?: 'QueryScenarioSessionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioSessionEdge = {
	__typename?: 'QueryScenarioSessionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSession>;
};

/** A connection from a Node. */
export type QueryScenarioSessionEventConnection = {
	__typename?: 'QueryScenarioSessionEventConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioSessionEventEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionEvent>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioSessionEventConnection. */
	permissions: QueryScenarioSessionEventConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioSessionEventConnectionPermissions = {
	__typename?: 'QueryScenarioSessionEventConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioSessionEventEdge = {
	__typename?: 'QueryScenarioSessionEventEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionEvent>;
};

/** A connection from a Node. */
export type QueryScenarioSessionPartConnection = {
	__typename?: 'QueryScenarioSessionPartConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioSessionPartEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionPart>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioSessionPartConnection. */
	permissions: QueryScenarioSessionPartConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioSessionPartConnectionPermissions = {
	__typename?: 'QueryScenarioSessionPartConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioSessionPartEdge = {
	__typename?: 'QueryScenarioSessionPartEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionPart>;
};

/** A connection from a Node. */
export type QueryScenarioSessionStepConnection = {
	__typename?: 'QueryScenarioSessionStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryScenarioSessionStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryScenarioSessionStepConnection. */
	permissions: QueryScenarioSessionStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryScenarioSessionStepConnectionPermissions = {
	__typename?: 'QueryScenarioSessionStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryScenarioSessionStepEdge = {
	__typename?: 'QueryScenarioSessionStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionStep>;
};

/** A connection from a Node. */
export type QueryUserConnection = {
	__typename?: 'QueryUserConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryUserEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<User>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryUserConnection. */
	permissions: QueryUserConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryUserConnectionPermissions = {
	__typename?: 'QueryUserConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryUserEdge = {
	__typename?: 'QueryUserEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<User>;
};

/** A connection from a Node. */
export type QueryWebhookErrorConnection = {
	__typename?: 'QueryWebhookErrorConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryWebhookErrorEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookError>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryWebhookErrorConnection. */
	permissions: QueryWebhookErrorConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryWebhookErrorConnectionPermissions = {
	__typename?: 'QueryWebhookErrorConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryWebhookErrorEdge = {
	__typename?: 'QueryWebhookErrorEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookError>;
};

/** A connection from a Node. */
export type QueryWebhookRequestConnection = {
	__typename?: 'QueryWebhookRequestConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryWebhookRequestEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookRequest>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryWebhookRequestConnection. */
	permissions: QueryWebhookRequestConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryWebhookRequestConnectionPermissions = {
	__typename?: 'QueryWebhookRequestConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryWebhookRequestEdge = {
	__typename?: 'QueryWebhookRequestEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookRequest>;
};

/** A connection from a Node. */
export type QueryWebhookSubscriptionConnection = {
	__typename?: 'QueryWebhookSubscriptionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryWebhookSubscriptionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookSubscription>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryWebhookSubscriptionConnection. */
	permissions: QueryWebhookSubscriptionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryWebhookSubscriptionConnectionPermissions = {
	__typename?: 'QueryWebhookSubscriptionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryWebhookSubscriptionEdge = {
	__typename?: 'QueryWebhookSubscriptionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookSubscription>;
};

/** A connection from a Node. */
export type QueryWebhookTopicConnection = {
	__typename?: 'QueryWebhookTopicConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<QueryWebhookTopicEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookTopic>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the QueryWebhookTopicConnection. */
	permissions: QueryWebhookTopicConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type QueryWebhookTopicConnectionPermissions = {
	__typename?: 'QueryWebhookTopicConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type QueryWebhookTopicEdge = {
	__typename?: 'QueryWebhookTopicEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookTopic>;
};

/** Autogenerated input type of RecoverAssetMutation */
export type RecoverAssetMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database ID of the asset to recover. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** ID of the asset to recover. */
	id?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type RecoverAssetMutationPayload = {
	__typename?: 'RecoverAssetMutationPayload';
	/** The recovered asset. */
	asset?: Maybe<Asset>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of RecoverAssetsMutation */
export type RecoverAssetsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of database IDs for assets to recover. */
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	/** List of asset IDs to recover. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
};

/** An Object. */
export type RecoverAssetsMutationPayload = {
	__typename?: 'RecoverAssetsMutationPayload';
	/** List of successfully recovered assets. */
	assets?: Maybe<Array<Asset>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Indicates if the assets were successfully recovered. */
	success: Scalars['Boolean'];
	/** List of assets that could not be recovered. */
	unrecoveredItems?: Maybe<Array<Asset>>;
};

/** Autogenerated input type of RecoverProjectMutation */
export type RecoverProjectMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database Id of project. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** Id of project. */
	id?: InputMaybe<Scalars['ID']>;
};

/** An Object. */
export type RecoverProjectMutationPayload = {
	__typename?: 'RecoverProjectMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** A Node in the graph. */
export type RenderPreviewJob = NodeInterface & {
	__typename?: 'RenderPreviewJob';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Rendering direction for the preview job. */
	direction?: Maybe<Scalars['String']>;
	/** File associated with the render preview job. */
	file?: Maybe<Attachment>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the RenderPreviewJob. */
	permissions: RenderPreviewJobPermissions;
	/** Preview generated by the render job. */
	preview?: Maybe<Attachment>;
	/** Timestamp when the render preview process ended. */
	processEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Timestamp when the render preview process started. */
	processStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Current status of the render preview job. */
	processStatus?: Maybe<RenderPreviewJobStatusEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** User who initiated the render preview job. */
	user?: Maybe<User>;
};


/** A Node in the graph. */
export type RenderPreviewJobFileArgs = {
	fileSource?: InputMaybe<FileSourceEnum>;
};


/** A Node in the graph. */
export type RenderPreviewJobPreviewArgs = {
	fileSource?: InputMaybe<FileSourceEnum>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type RenderPreviewJobPermissions = {
	__typename?: 'RenderPreviewJobPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum RenderPreviewJobStatusEnum {
	/** The render preview job has been created. */
	Created = 'CREATED',
	/** The render preview job encountered an error. */
	Error = 'ERROR',
	/** The render preview job is currently being processed. */
	Processing = 'PROCESSING',
	/** The render preview job is queued for processing. */
	Queued = 'QUEUED',
	/** The render preview job completed successfully. */
	Success = 'SUCCESS',
	/** The render preview job timed out. */
	Timeout = 'TIMEOUT'
}

/** A Node in the graph. */
export type ResourcePermission = NodeInterface & {
	__typename?: 'ResourcePermission';
	/** The datetime when the resource permission was created at. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** The permissable object node. */
	permissable?: Maybe<NodeInterface>;
	/** The database id of the permissable object. */
	permissableDatabaseId?: Maybe<Scalars['String']>;
	/** The type of permissable object. */
	permissableType?: Maybe<PermissionPermissableTypeEnum>;
	/** A permission value. */
	permission?: Maybe<PermissionEnum>;
	/** A list of Permissions associated with the currently authenticated User and the ResourcePermission. */
	permissions: ResourcePermissionPermissions;
	/** The resource node. */
	resource?: Maybe<NodeInterface>;
	/** The database id of the resource. */
	resourceDatabaseId?: Maybe<Scalars['String']>;
	/** The type of resource. */
	resourceType?: Maybe<PermissionResourceTypeEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ResourcePermissionPermissions = {
	__typename?: 'ResourcePermissionPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type Review = NodeInterface & {
	__typename?: 'Review';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Unique identifier to the review. Used to look up the review. */
	key?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** Review pages associated with the review. */
	pages?: Maybe<Array<ReviewPage>>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Review. */
	permissions: ReviewPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Title of the review. */
	title?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A Node in the graph. */
export type ReviewOption = NodeInterface & {
	__typename?: 'ReviewOption';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The next review page if this option is selected. Supercedes the page next review page key. */
	nextReviewPageKey?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ReviewOption. */
	permissions: ReviewOptionPermissions;
	/** Prompt that is associated with the review option. */
	prompt?: Maybe<ReviewPrompt>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Type of option. Refer to the review option enum. */
	type?: Maybe<ReviewOptionTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** Value of the option to be selected. */
	value?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewOptionPermissions = {
	__typename?: 'ReviewOptionPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ReviewOptionTypeEnum {
	/** Default review option. Just the value is presented. */
	Default = 'DEFAULT',
	/** The user can add text to the selection as an addendum. */
	Text = 'TEXT'
}

/** A Node in the graph. */
export type ReviewPage = NodeInterface & {
	__typename?: 'ReviewPage';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** A unique key associated with the review page and scoped to the review. */
	key?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** Key for the review page that should proceed this review page. */
	nextReviewPageKey?: Maybe<Scalars['String']>;
	/** The default order of the review pages if the next review page is not set. */
	order?: Maybe<Scalars['Int']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ReviewPage. */
	permissions: ReviewPagePermissions;
	/** The User prompts to be presented on the review page. */
	prompts?: Maybe<Array<ReviewPrompt>>;
	/** Review that the page exists on. */
	review?: Maybe<Review>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewPagePermissions = {
	__typename?: 'ReviewPagePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewPermissions = {
	__typename?: 'ReviewPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type ReviewPrompt = NodeInterface & {
	__typename?: 'ReviewPrompt';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** The option that is default selected when the prompt is presented. */
	defaultOption?: Maybe<ReviewOption>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** User options associated with the prompt. */
	options?: Maybe<Array<ReviewOption>>;
	/** The review page that the prompt exists on. */
	page?: Maybe<ReviewPage>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ReviewPrompt. */
	permissions: ReviewPromptPermissions;
	/** Boolean to determine if the prompt needs to have a selection before continuing. */
	required?: Maybe<Scalars['Boolean']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The type of prompt. Check the enum for the review prompt type. */
	type?: Maybe<ReviewPromptTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** Value of the prompt to be presented to the user. */
	value?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewPromptPermissions = {
	__typename?: 'ReviewPromptPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ReviewPromptTypeEnum {
	/** Refers to the review prompt where the options are links to different pages. */
	Link = 'LINK',
	/** Refers to the review prompt where multiple options can be selected. */
	Multiple = 'MULTIPLE',
	/** Refers to the review prompt where a single option can be selected. */
	Single = 'SINGLE'
}

/** A Node in the graph. */
export type ReviewReviewable = NodeInterface & {
	__typename?: 'ReviewReviewable';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Unique key of the review associated with this reviewable object. */
	key?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The review pages of this reviewable object's review. */
	pages?: Maybe<Array<ReviewPage>>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ReviewReviewable. */
	permissions: ReviewReviewablePermissions;
	/** The users who are associated with the review of this reviewable object. */
	reviewers?: Maybe<Array<ReviewReviewableUser>>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The title of the review associated with this reviewable object. */
	title?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** A list of the user selections of this particular review of a reviewable object. */
	userSelections?: Maybe<Array<ReviewReviewableUserSelection>>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewReviewablePermissions = {
	__typename?: 'ReviewReviewablePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type ReviewReviewableUser = NodeInterface & {
	__typename?: 'ReviewReviewableUser';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The current page that the reviewer is on. */
	currentReviewPage?: Maybe<ReviewPage>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ReviewReviewableUser. */
	permissions: ReviewReviewableUserPermissions;
	/** Selections of the user associated with this review. */
	selections?: Maybe<Array<ReviewReviewableUserSelection>>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Current status of the reviewer and whether their review is complete or not. */
	status?: Maybe<ReviewReviewableUserStatusEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The user associated with the review. */
	user?: Maybe<User>;
	/** The appended value of the user selection when the input. */
	value?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewReviewableUserPermissions = {
	__typename?: 'ReviewReviewableUserPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type ReviewReviewableUserSelection = NodeInterface & {
	__typename?: 'ReviewReviewableUserSelection';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ReviewReviewableUserSelection. */
	permissions: ReviewReviewableUserSelectionPermissions;
	/** The review option of the user selection. */
	reviewOption?: Maybe<ReviewOption>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The user who made this selection. */
	user?: Maybe<User>;
	/** Addendum value of the user selection. */
	value?: Maybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ReviewReviewableUserSelectionPermissions = {
	__typename?: 'ReviewReviewableUserSelectionPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ReviewReviewableUserStatusEnum {
	/** When the reviewing user still has active pages to select options on. */
	Active = 'ACTIVE',
	/** When the review by the user is completed. */
	Complete = 'COMPLETE'
}

/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type Scenario = NodeInterface & {
	__typename?: 'Scenario';
	/** Number of active sessions for this scenario. */
	activeSessionsCount?: Maybe<Scalars['Int']>;
	/** Number of active work instructions sessions for this scenario. */
	activeWorkInstructionSessionCount?: Maybe<Scalars['Int']>;
	/** The User that authored the Scenario. */
	author?: Maybe<User>;
	/** A list of Scenario ScenarioCatalogs associated with the Scenario. */
	catalogs?: Maybe<ScenarioScenarioCatalogConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The ScenarioRelease to be used when creating new ScenarioSessions associated with the Scenario. */
	currentRelease?: Maybe<ScenarioRelease>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Deferred link for active scenario content. */
	deferredLink?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The description of the Scenario. */
	description?: Maybe<Scalars['String']>;
	/** Global ID of the Scenario record. This should be persistent if data is migrated and is recommended to use. */
	guid?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** User of most recently started scenario session. */
	lastAccessedBy?: Maybe<User>;
	/** The last ScenarioRelease associated with the Scenario. */
	latestRelease?: Maybe<ScenarioRelease>;
	/** The name of the Scenario. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** A list of non default Groups that can access the Scenario. */
	nonOriginGroups?: Maybe<ScenarioGroupConnection>;
	/** The Organization associated with the Scenario. */
	organization?: Maybe<Organization>;
	/** The origin Group associated with the Scenario. */
	originGroup?: Maybe<Group>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the Scenario. */
	permissions: ScenarioPermissions;
	/** The Scenario's plan usage status. */
	planUsageStatus?: Maybe<PlanUsageStatusEnum>;
	/** The Project associated with the Scenario. */
	project?: Maybe<Project>;
	/** Whether the Scenario belongs to a public Catalog. */
	public?: Maybe<Scalars['Boolean']>;
	/** The date and time when the first ScenarioRelease associated with the Scenario was published. */
	publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Link to download qr code for the current release. */
	qrCodeImageLink?: Maybe<Scalars['String']>;
	/** A list of Groups that can access the Scenario. */
	recipientGroups?: Maybe<ScenarioGroupConnection>;
	/** A list of Groups except origin group that can access the Scenario. */
	recipientGroupsWithoutOriginGroup?: Maybe<ScenarioGroupConnection>;
	/** The date and time when the Scenario was first released. */
	releasedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of ScenarioReleases associated with the Scenario. */
	releases?: Maybe<ScenarioScenarioReleaseConnection>;
	/** The resource permissions for the Scenario. */
	resourcePermissions?: Maybe<Array<ResourcePermission>>;
	/** Name of the revision group associated with the scenario. */
	revisionGroupName?: Maybe<Scalars['String']>;
	/** Name of the current Scenario revision. */
	revisionName?: Maybe<Scalars['String']>;
	/** Notes or comments associated with the current Scenario revision. */
	revisionNotes?: Maybe<Scalars['String']>;
	/** List of revisions associated with the Scenario. */
	revisions?: Maybe<Array<Scenario>>;
	/** Attached scope file of latest version. */
	scopeFile?: Maybe<Scalars['String']>;
	/** A list of ScenarioSequences associated with the ScenarioRelease. */
	sequences?: Maybe<ScenarioScenarioSequenceConnection>;
	/** A list of ScenarioSessions associated with the Scenario. */
	sessions?: Maybe<ScenarioScenarioSessionConnection>;
	/** Number of ScenarioSessions associated with the Scenario. */
	sessionsCount?: Maybe<Scalars['Int']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The shortcode of the Scenario. */
	shortcode?: Maybe<Scalars['String']>;
	/** The state of the Scenario based on the associated Project. */
	state?: Maybe<ProjectStateEnum>;
	/** A list of ScenarioSteps associated with the ScenarioRelease. */
	steps?: Maybe<ScenarioScenarioStepConnection>;
	/** The number of steps within the scenario. */
	totalSteps?: Maybe<Scalars['Int']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The most recent version of the scenario. */
	version?: Maybe<Scalars['Int']>;
	/** A list of ScenarioSessionParts associated with the Scenario. */
	workInstructionSessions?: Maybe<ScenarioScenarioSessionPartConnection>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioCatalogsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioNonOriginGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioRecipientGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioRecipientGroupsWithoutOriginGroupArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioRevisionsArgs = {
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioSequencesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	externalData?: InputMaybe<ScenarioSessionsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionsUserInput>;
	versions?: InputMaybe<Array<Scalars['Int']>>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	externalData?: InputMaybe<Scalars['JSON']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	type?: InputMaybe<ScenarioStepTypeEnum>;
};


/** Represents a set of steps and sequences that a User can interact with (versioned). */
export type ScenarioWorkInstructionSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	excludeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	externalData?: InputMaybe<ScenarioSessionPartsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	includeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionPartsUserInput>;
};

/** Represents a set of Scenarios (usually related to a single real world asset). */
export type ScenarioCatalog = NodeInterface & {
	__typename?: 'ScenarioCatalog';
	/** The url of the ScenarioCatalog (a deeplink which opens Catalog in Worklink client). */
	appUrl?: Maybe<Scalars['Url']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Deferred link for catalog content. */
	deferredLink?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The identifier of the real world asset associated with the ScenarioCatalog (e.g. series-360-printer). */
	externalAssetId?: Maybe<Scalars['String']>;
	/** The name of the real world asset associated with the ScenarioCatalog (e.g. Series 360 Printer). */
	externalAssetName?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the ScenarioCatalog. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioCatalog. */
	organization?: Maybe<Organization>;
	/** A unique list of origin groups for the ScenarioCatalog. */
	originGroups?: Maybe<ScenarioCatalogGroupConnection>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioCatalog. */
	permissions: ScenarioCatalogPermissions;
	/** Represents whether catalog is publicly visible. */
	public?: Maybe<Scalars['Boolean']>;
	/** Link to download qr code for the current release. */
	qrCodeImageLink?: Maybe<Scalars['String']>;
	/** A list of Scenarios associated with the ScenarioCatalog. */
	scenarios?: Maybe<ScenarioCatalogScenarioConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The shortcode of the ScenarioCatalog. */
	shortcode?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents a set of Scenarios (usually related to a single real world asset). */
export type ScenarioCatalogOriginGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of Scenarios (usually related to a single real world asset). */
export type ScenarioCatalogScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};

/** A connection from a Node. */
export type ScenarioCatalogGroupConnection = {
	__typename?: 'ScenarioCatalogGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioCatalogGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioCatalogGroupConnection. */
	permissions: ScenarioCatalogGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioCatalogGroupConnectionPermissions = {
	__typename?: 'ScenarioCatalogGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioCatalogGroupEdge = {
	__typename?: 'ScenarioCatalogGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioCatalogPermissions = {
	__typename?: 'ScenarioCatalogPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from an Organization to Scenarios. */
export type ScenarioCatalogScenarioConnection = {
	__typename?: 'ScenarioCatalogScenarioConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioCatalogScenarioEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Scenario>>>;
	/** List of name and ids of origin groups for all scenarios in the connection. */
	originGroups: ScenarioCatalogScenarioConnectionGroupConnection;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioCatalogScenarioConnection. */
	permissions: ScenarioCatalogScenarioConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};


/** A connection from an Organization to Scenarios. */
export type ScenarioCatalogScenarioConnectionOriginGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	before?: InputMaybe<Scalars['String']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type ScenarioCatalogScenarioConnectionGroupConnection = {
	__typename?: 'ScenarioCatalogScenarioConnectionGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioCatalogScenarioConnectionGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioCatalogScenarioConnectionGroupConnection. */
	permissions: ScenarioCatalogScenarioConnectionGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioCatalogScenarioConnectionGroupConnectionPermissions = {
	__typename?: 'ScenarioCatalogScenarioConnectionGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioCatalogScenarioConnectionGroupEdge = {
	__typename?: 'ScenarioCatalogScenarioConnectionGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioCatalogScenarioConnectionPermissions = {
	__typename?: 'ScenarioCatalogScenarioConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioCatalogScenarioEdge = {
	__typename?: 'ScenarioCatalogScenarioEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Scenario>;
};

/** Autogenerated nested input type of ScenarioCreateInputObject */
export type ScenarioCreateInputObjectScenarioInput = {
	/** Description of scenario. */
	description?: InputMaybe<Scalars['String']>;
	/** Name of scenario. */
	name: Scalars['String'];
	/** Database ID of the Project the Scenario was published from. */
	projectDatabaseId?: InputMaybe<Scalars['String']>;
	/** ID of the Project the Scenario was published from. */
	projectId?: InputMaybe<Scalars['String']>;
	/** Boolean to make the scenario publically available to not. */
	public?: InputMaybe<Scalars['Boolean']>;
};

/** A connection from a Node. */
export type ScenarioGroupConnection = {
	__typename?: 'ScenarioGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioGroupConnection. */
	permissions: ScenarioGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioGroupConnectionPermissions = {
	__typename?: 'ScenarioGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioGroupEdge = {
	__typename?: 'ScenarioGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioPermissions = {
	__typename?: 'ScenarioPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Represents a version of a Scenario. */
export type ScenarioRelease = NodeInterface & {
	__typename?: 'ScenarioRelease';
	/** The User that authored the ScenarioRelease. */
	author?: Maybe<User>;
	/** The name of the User that authored the ScenarioRelease. */
	authorName?: Maybe<Scalars['String']>;
	/** The content associated with the ScenarioRelease. */
	content?: Maybe<Attachment>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url to download this ScenarioRelease. */
	downloadUrl?: Maybe<Scalars['String']>;
	/** Boolean on whether the ScenarioRelease content is encrypted. */
	encrypted?: Maybe<Scalars['Boolean']>;
	/** 3rd party data associated with the ScenarioRelease. */
	externalData?: Maybe<Scalars['JSON']>;
	/** Boolean on whether the ScenarioRelease has multi point alignment. */
	hasMultiPointAlignment?: Maybe<Scalars['Boolean']>;
	/** Boolean on whether the ScenarioRelease has a prescanned holographic area. */
	hasPreScannedAreaHolographic?: Maybe<Scalars['Boolean']>;
	/** Boolean on whether the ScenarioRelease has room scale. */
	hasRoomScale?: Maybe<Scalars['Boolean']>;
	/** Boolean on whether the ScenarioRelease has vuforia. */
	hasVuforia?: Maybe<Scalars['Boolean']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioRelease. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioRelease. */
	permissions: ScenarioReleasePermissions;
	/** The project save file associated with the ScenarioRelease. */
	projectSaveFile?: Maybe<ProjectSaveFile>;
	/** The date and time when the ScenarioRelease was published. */
	publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The Scenario associated with the ScenarioRelease. */
	scenario?: Maybe<Scenario>;
	/** The name of the scene. */
	sceneName?: Maybe<Scalars['String']>;
	/** The SDK version associated with the ScenarioRelease. */
	sdkVersion?: Maybe<Scalars['String']>;
	/** A list of ScenarioSequences associated with the ScenarioRelease. */
	sequences?: Maybe<ScenarioReleaseScenarioSequenceConnection>;
	/** A list of ScenarioSessions associated with the ScenarioRelease. */
	sessions?: Maybe<ScenarioReleaseScenarioSessionConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** A list of ScenarioSteps associated with the ScenarioRelease. */
	steps?: Maybe<ScenarioReleaseScenarioStepConnection>;
	/** The number of steps within the scenario. */
	totalSteps?: Maybe<Scalars['Int']>;
	/** The type of the ScenarioRelease. */
	type?: Maybe<ScenarioReleaseTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The version number of the ScenarioRelease. */
	version?: Maybe<Scalars['Int']>;
	/** The work instruction type of the ScenarioRelease. */
	workInstructionType?: Maybe<ScenarioReleaseWorkInstructionTypeEnum>;
};


/** Represents a version of a Scenario. */
export type ScenarioReleaseSequencesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a version of a Scenario. */
export type ScenarioReleaseSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	dateRange?: InputMaybe<DateRangeInputObject>;
	externalData?: InputMaybe<ScenarioSessionsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionsUserInput>;
	versions?: InputMaybe<Array<Scalars['Int']>>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents a version of a Scenario. */
export type ScenarioReleaseStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	externalData?: InputMaybe<Scalars['JSON']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	type?: InputMaybe<ScenarioStepTypeEnum>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioReleasePermissions = {
	__typename?: 'ScenarioReleasePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioReleaseScenarioSequenceConnection = {
	__typename?: 'ScenarioReleaseScenarioSequenceConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioReleaseScenarioSequenceEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSequence>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioReleaseScenarioSequenceConnection. */
	permissions: ScenarioReleaseScenarioSequenceConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioReleaseScenarioSequenceConnectionPermissions = {
	__typename?: 'ScenarioReleaseScenarioSequenceConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioReleaseScenarioSequenceEdge = {
	__typename?: 'ScenarioReleaseScenarioSequenceEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSequence>;
};

/** A connection from a Node. */
export type ScenarioReleaseScenarioSessionConnection = {
	__typename?: 'ScenarioReleaseScenarioSessionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioReleaseScenarioSessionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSession>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioReleaseScenarioSessionConnection. */
	permissions: ScenarioReleaseScenarioSessionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioReleaseScenarioSessionConnectionPermissions = {
	__typename?: 'ScenarioReleaseScenarioSessionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioReleaseScenarioSessionEdge = {
	__typename?: 'ScenarioReleaseScenarioSessionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSession>;
};

/** A connection from a Node. */
export type ScenarioReleaseScenarioStepConnection = {
	__typename?: 'ScenarioReleaseScenarioStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioReleaseScenarioStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioReleaseScenarioStepConnection. */
	permissions: ScenarioReleaseScenarioStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioReleaseScenarioStepConnectionPermissions = {
	__typename?: 'ScenarioReleaseScenarioStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioReleaseScenarioStepEdge = {
	__typename?: 'ScenarioReleaseScenarioStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStep>;
};

export enum ScenarioReleaseTypeEnum {
	/** A ScenarioRelease that supports demo sessions. */
	DemoSession = 'DEMO_SESSION',
	/** A ScenarioRelease that supports local sessions. */
	LocalSession = 'LOCAL_SESSION',
	/** A ScenarioRelease that supports no sessions. */
	NoSession = 'NO_SESSION',
	/** A ScenarioRelease that supports passive sessions. */
	PassiveSession = 'PASSIVE_SESSION',
	/** A ScenarioRelease that supports persistent per user sessions. */
	PersistentPerUser = 'PERSISTENT_PER_USER',
	/** A ScenarioRelease that supports persistent sessions. */
	PersistentSession = 'PERSISTENT_SESSION'
}

export enum ScenarioReleaseWorkInstructionTypeEnum {
	/** A ScenarioRelease with quiz graded items. */
	GradedAssessment = 'GRADED_ASSESSMENT',
	/** A ScenarioRelease with quiz ungraded items. */
	KnowledgeCheck = 'KNOWLEDGE_CHECK',
	/** A ScenarioRelease with non-quiz items. */
	WorkInstruction = 'WORK_INSTRUCTION'
}

/** A connection from a Node. */
export type ScenarioScenarioCatalogConnection = {
	__typename?: 'ScenarioScenarioCatalogConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioScenarioCatalogEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioCatalog>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioScenarioCatalogConnection. */
	permissions: ScenarioScenarioCatalogConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioScenarioCatalogConnectionPermissions = {
	__typename?: 'ScenarioScenarioCatalogConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioScenarioCatalogEdge = {
	__typename?: 'ScenarioScenarioCatalogEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioCatalog>;
};

/** A connection from a Node. */
export type ScenarioScenarioReleaseConnection = {
	__typename?: 'ScenarioScenarioReleaseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioScenarioReleaseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioRelease>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioScenarioReleaseConnection. */
	permissions: ScenarioScenarioReleaseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioScenarioReleaseConnectionPermissions = {
	__typename?: 'ScenarioScenarioReleaseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioScenarioReleaseEdge = {
	__typename?: 'ScenarioScenarioReleaseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioRelease>;
};

/** A connection from a Node. */
export type ScenarioScenarioSequenceConnection = {
	__typename?: 'ScenarioScenarioSequenceConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioScenarioSequenceEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSequence>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioScenarioSequenceConnection. */
	permissions: ScenarioScenarioSequenceConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioScenarioSequenceConnectionPermissions = {
	__typename?: 'ScenarioScenarioSequenceConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioScenarioSequenceEdge = {
	__typename?: 'ScenarioScenarioSequenceEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSequence>;
};

/** A connection from a Node. */
export type ScenarioScenarioSessionConnection = {
	__typename?: 'ScenarioScenarioSessionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioScenarioSessionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSession>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioScenarioSessionConnection. */
	permissions: ScenarioScenarioSessionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioScenarioSessionConnectionPermissions = {
	__typename?: 'ScenarioScenarioSessionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioScenarioSessionEdge = {
	__typename?: 'ScenarioScenarioSessionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSession>;
};

/** A connection from a Node. */
export type ScenarioScenarioSessionPartConnection = {
	__typename?: 'ScenarioScenarioSessionPartConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioScenarioSessionPartEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionPart>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioScenarioSessionPartConnection. */
	permissions: ScenarioScenarioSessionPartConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioScenarioSessionPartConnectionPermissions = {
	__typename?: 'ScenarioScenarioSessionPartConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioScenarioSessionPartEdge = {
	__typename?: 'ScenarioScenarioSessionPartEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionPart>;
};

/** A connection from a Node. */
export type ScenarioScenarioStepConnection = {
	__typename?: 'ScenarioScenarioStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioScenarioStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioScenarioStepConnection. */
	permissions: ScenarioScenarioStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioScenarioStepConnectionPermissions = {
	__typename?: 'ScenarioScenarioStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioScenarioStepEdge = {
	__typename?: 'ScenarioScenarioStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStep>;
};

/** Represents a set of ScenarioSteps which are intended to be performed sequencially. */
export type ScenarioSequence = NodeInterface & {
	__typename?: 'ScenarioSequence';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** 3rd party data associated with the ScenarioSequence. */
	externalData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the ScenarioSequence. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioSequence. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSequence. */
	permissions: ScenarioSequencePermissions;
	/** The ScenarioRelease associated with the ScenarioSequence. */
	scenarioRelease?: Maybe<ScenarioRelease>;
	/** A list of ScenarioSteps associated with the ScenarioSequence. */
	scenarioSteps?: Maybe<ScenarioSequenceScenarioStepConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents a set of ScenarioSteps which are intended to be performed sequencially. */
export type ScenarioSequenceScenarioStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	externalData?: InputMaybe<Scalars['JSON']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	type?: InputMaybe<ScenarioStepTypeEnum>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSequencePermissions = {
	__typename?: 'ScenarioSequencePermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioSequenceScenarioStepConnection = {
	__typename?: 'ScenarioSequenceScenarioStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSequenceScenarioStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSequenceScenarioStepConnection. */
	permissions: ScenarioSequenceScenarioStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSequenceScenarioStepConnectionPermissions = {
	__typename?: 'ScenarioSequenceScenarioStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSequenceScenarioStepEdge = {
	__typename?: 'ScenarioSequenceScenarioStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStep>;
};

/** Represents an execution of a ScenarioRelease. */
export type ScenarioSession = NodeInterface & {
	__typename?: 'ScenarioSession';
	/** A list of CallSessions associated with the ScenarioSession. */
	calls?: Maybe<ScenarioSessionCallConnection>;
	/** A list of Step Items completed in the current Scenario Session. */
	completedItems?: Maybe<ScenarioSessionScenarioStepItemConnection>;
	/** A list of Steps completed in the current Scenario Session. */
	completedSteps?: Maybe<ScenarioSessionScenarioStepConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The duration of the ScenarioSession in seconds. */
	duration?: Maybe<Scalars['Int']>;
	/** The date and time that the ScenarioSession ended. */
	endedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of ScenarioSessionEvents associated with the ScenarioSession. */
	events?: Maybe<ScenarioSessionScenarioSessionEventConnection>;
	/** 3rd party data associated with the ScenarioSession. */
	externalData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The duration of the ScenarioSession where User was idle. */
	idleDuration?: Maybe<Scalars['Int']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The number of steps possible to view during the ScenarioSession. */
	numberOfStepsPossible?: Maybe<Scalars['Int']>;
	/** The number of steps viewed during the ScenarioSession. */
	numberOfStepsViewed?: Maybe<Scalars['Int']>;
	/** The Organization associated with the ScenarioSession. */
	organization?: Maybe<Organization>;
	/** The origin group of the parent Scenario at time of creation. */
	originGroup?: Maybe<Group>;
	/** The list of users that added events to the ScenarioSession. */
	participants?: Maybe<Array<User>>;
	/** A list of ScenarioSessionParts associated with the ScenarioSession. */
	parts?: Maybe<ScenarioSessionScenarioSessionPartConnection>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** The percentage of steps completed during the ScenarioSession (i.e. all checklist items have been completed). */
	percentOfStepsCompleted?: Maybe<Scalars['Float']>;
	/** The percentage of steps viewed during the ScenarioSession. */
	percentOfStepsViewed?: Maybe<Scalars['Float']>;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSession. */
	permissions: ScenarioSessionPermissions;
	/** Status that states if a scenario has been completed. */
	progress?: Maybe<Scalars['String']>;
	/** Quiz related data. */
	quizData?: Maybe<Scalars['JSON']>;
	/** The recipient groups of the parent Scenario at time of creation. */
	recipientGroups?: Maybe<ScenarioSessionGroupConnection>;
	/** The Scenario associated with the ScenarioSession. */
	scenario?: Maybe<Scenario>;
	/** The name of the scenario associated with the Scenario Session. */
	scenarioName?: Maybe<Scalars['String']>;
	/** The ScenarioRelease associated with the ScenarioSession. */
	scenarioRelease?: Maybe<ScenarioRelease>;
	/** The version of the ScenarioRelease. */
	scenarioReleaseVersion?: Maybe<Scalars['Int']>;
	/** The type of ScenarioRelease. */
	scenarioReleaseWorkInstructionType?: Maybe<ScenarioReleaseWorkInstructionTypeEnum>;
	/** The user-defined name of the session. */
	sessionName?: Maybe<Scalars['String']>;
	/** An ArContent session type to filter the session. */
	sessionType?: Maybe<ScenarioReleaseTypeEnum>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The date and time that the ScenarioSession began. */
	startedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The state of the ScenarioSession. */
	state?: Maybe<ScenarioSessionStateEnum>;
	/** A list of ScenarioSessionSteps associated with the ScenarioSession. */
	steps?: Maybe<ScenarioSessionScenarioSessionStepConnection>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User associated with the ScenarioSession. */
	user?: Maybe<User>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionCallsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionCompletedItemsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionCompletedStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionEventsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	eventData?: InputMaybe<ScenarioSessionEventsEventDataInput>;
	eventTypes?: InputMaybe<Array<ScenarioSessionEventTypeEnum>>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioIds?: InputMaybe<Array<Scalars['ID']>>;
	scenarioSessionId?: InputMaybe<Scalars['ID']>;
	scenarioSessionPartId?: InputMaybe<Scalars['ID']>;
	startedAtRange?: InputMaybe<DateRangeInputObject>;
	user?: InputMaybe<ScenarioSessionEventsUserInput>;
	valueTypes?: InputMaybe<Array<ScenarioStepItemTypeEnum>>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionPartsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	excludeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	externalData?: InputMaybe<ScenarioSessionPartsExternalDataInput>;
	first?: InputMaybe<Scalars['Int']>;
	includeStates?: InputMaybe<Array<ScenarioSessionStateEnum>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	sessionTypes?: InputMaybe<Array<ScenarioReleaseTypeEnum>>;
	user?: InputMaybe<ScenarioSessionPartsUserInput>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionRecipientGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an execution of a ScenarioRelease. */
export type ScenarioSessionStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	scenarioSessionId?: InputMaybe<Scalars['ID']>;
	scenarioStepId?: InputMaybe<Scalars['ID']>;
};

/** A connection from a Node. */
export type ScenarioSessionCallConnection = {
	__typename?: 'ScenarioSessionCallConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionCallEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Call>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionCallConnection. */
	permissions: ScenarioSessionCallConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionCallConnectionPermissions = {
	__typename?: 'ScenarioSessionCallConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionCallEdge = {
	__typename?: 'ScenarioSessionCallEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Call>;
};

/** Represents an event that occurred during a ScenarioSession. */
export type ScenarioSessionEvent = NodeInterface & {
	__typename?: 'ScenarioSessionEvent';
	/** Barcode value submitted by the user when the value type is BARCODE. */
	barcode?: Maybe<Scalars['JSON']>;
	/** The Call associated with the ScenarioSessionEvent. */
	call?: Maybe<Call>;
	/** The date and time when the ScenarioSessionEvent was saved on the server. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The duration of the ScenarioSessionEvent in seconds. */
	duration?: Maybe<Scalars['Int']>;
	/** The date and time when the ScenarioSession ended. */
	endedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** 3rd party data associated with the ScenarioSessionEvent. */
	eventData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioSessionEvent. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionEvent. */
	permissions: ScenarioSessionEventPermissions;
	/** Photo attachment. This field will be nil for any event where type is not SCREENSHOT_CAPTURED, or when value_type is not PHOTO. */
	photo?: Maybe<Attachment>;
	/** The date and time when the ScenarioSession was sent to the server. */
	receivedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The Scenario associated with the ScenarioSessionEvent. */
	scenario?: Maybe<Scenario>;
	/** The ScenarioSession associated with the ScenarioSessionEvent. */
	scenarioSession?: Maybe<ScenarioSession>;
	/** The ScenarioSessionPart associated with the ScenarioSessionEvent. */
	scenarioSessionPart?: Maybe<ScenarioSession>;
	/** The ScenarioSessionStep associated with the ScenarioSessionEvent. */
	scenarioSessionStep?: Maybe<ScenarioSessionStep>;
	/** The ScenarioSessionStepItem associated with the ScenarioSessionEvent. */
	scenarioSessionStepItem?: Maybe<ScenarioSessionStepItem>;
	/** The ScenarioStep associated with the ScenarioSessionEvent. */
	scenarioStep?: Maybe<ScenarioStep>;
	/** The ScenarioStepItem associated with the ScenarioSessionEvent. */
	scenarioStepItem?: Maybe<ScenarioStepItem>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The date and time when the ScenarioReleaseEvent started. */
	startedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The type of the ScenarioSessionEvent. */
	type?: Maybe<ScenarioSessionEventTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The user who created the event. */
	user?: Maybe<User>;
	/** The value submitted by the user in the event data. */
	value?: Maybe<Scalars['String']>;
	/** Value type of the event data. */
	valueType?: Maybe<ScenarioStepItemTypeEnum>;
};

/** Scenario Session Event creation arguments. */
export type ScenarioSessionEventCreateInputObject = {
	/** Attribute identifier. */
	attributeIdentifier?: InputMaybe<Scalars['String']>;
	/** Json object of event data. */
	eventData?: InputMaybe<Scalars['JSON']>;
	/** Type of event to create. */
	eventType: Scalars['String'];
	/** Date of when the event was recorded. */
	recordedAt: Scalars['ISO8601DateTime'];
	/** Guid for the scenario session. */
	sessionGuid: Scalars['String'];
	/** Scenario session step id. */
	stepIdentifier: Scalars['String'];
	/** User permalink. */
	userPermalink?: InputMaybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSessionEventPermissions = {
	__typename?: 'ScenarioSessionEventPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum ScenarioSessionEventSourceEnum {
	/** A branch_step ScenarioSessionStepItem item value. */
	BranchStep = 'BRANCH_STEP',
	/** A call_connect ScenarioSessionStepItem item value. */
	CallConnect = 'CALL_CONNECT',
	/** A first_step ScenarioSessionStepItem item value. */
	FirstStep = 'FIRST_STEP',
	/** A header ScenarioSessionStepItem item value. */
	Header = 'HEADER',
	/** A incoming_call_ended ScenarioSessionStepItem item value. */
	IncomingCallEnded = 'INCOMING_CALL_ENDED',
	/** A load_project ScenarioSessionStepItem item value. */
	LoadProject = 'LOAD_PROJECT',
	/** A menu ScenarioSessionStepItem item value. */
	Menu = 'MENU',
	/** A next_button ScenarioSessionStepItem item value. */
	NextButton = 'NEXT_BUTTON',
	/** A project_load ScenarioSessionStepItem item value. */
	ProjectLoad = 'PROJECT_LOAD',
	/** A remote ScenarioSessionStepItem item value. */
	Remote = 'REMOTE',
	/** A remote_load ScenarioSessionStepItem item value. */
	RemoteLoad = 'REMOTE_LOAD',
	/** A step_type ScenarioSessionStepItem item value. */
	StepType = 'STEP_TYPE'
}

export enum ScenarioSessionEventTypeEnum {
	/** A ScenarioSession call connect event. */
	CallConnect = 'CALL_CONNECT',
	/** A ScenarioSession call disconnect event. */
	CallDisconnect = 'CALL_DISCONNECT',
	/** A ScenarioSession checklist item complete event. */
	ChecklistItemComplete = 'CHECKLIST_ITEM_COMPLETE',
	/** A ScenarioSession continue event. */
	ContinueSession = 'CONTINUE_SESSION',
	/** A ScenarioSession create event. */
	CreateSession = 'CREATE_SESSION',
	/** A ScenarioSession end event. */
	EndSession = 'END_SESSION',
	/** A ScenarioSession enter event. */
	EnterSession = 'ENTER_SESSION',
	/** A ScenarioSession exit event. */
	ExitSession = 'EXIT_SESSION',
	/** A ScenarioSession end event. */
	FinishSession = 'FINISH_SESSION',
	/** A ScenarioSession event when a scenario quiz is completed. */
	QuizComplete = 'QUIZ_COMPLETE',
	/** A ScenarioSession event when a scenario quiz question or item is completed. */
	QuizItemComplete = 'QUIZ_ITEM_COMPLETE',
	/** A ScenarioSession screenshot captured event. */
	ScreenshotCaptured = 'SCREENSHOT_CAPTURED',
	/** A ScenarioSession event when a user views an attachment. */
	ViewAttachment = 'VIEW_ATTACHMENT',
	/** A ScenarioSession view step event. */
	ViewStep = 'VIEW_STEP'
}

/** Autogenerated nested input type of ScenarioSessionEvents */
export type ScenarioSessionEventsEventDataInput = {
	/** The event data key (or JSON key path) to be used to filter scenario session events. */
	key?: InputMaybe<Scalars['String']>;
	/** The type of way to find the key-value pair in the event data. Can be MATCH or CONTAINS. */
	type?: InputMaybe<Scalars['String']>;
	/** The value of the event data key to be used to filter scenario session events. */
	value?: InputMaybe<Scalars['Alphanumeric']>;
};

/** Autogenerated nested input type of ScenarioSessionEvents */
export type ScenarioSessionEventsUserInput = {
	/** The GQL ID of a user to filter the scenario sessions by. */
	id?: InputMaybe<Scalars['ID']>;
	/** The username to filter the scenario sessions by. */
	username?: InputMaybe<Scalars['String']>;
};

/** A connection from a Node. */
export type ScenarioSessionGroupConnection = {
	__typename?: 'ScenarioSessionGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionGroupConnection. */
	permissions: ScenarioSessionGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionGroupConnectionPermissions = {
	__typename?: 'ScenarioSessionGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionGroupEdge = {
	__typename?: 'ScenarioSessionGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** Represents one part of a ScenarioSession (note: resuming a Session creates a new part). */
export type ScenarioSessionPart = NodeInterface & {
	__typename?: 'ScenarioSessionPart';
	/** A list of CallSessions associated with the ScenarioSessionPart. */
	calls?: Maybe<ScenarioSessionPartCallConnection>;
	/** when the record was created. this may not be the same as started at. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The user who created this ScenarioSessionPart. */
	createdBy?: Maybe<User>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The duration of the ScenarioSessionPart in seconds. */
	duration?: Maybe<Scalars['Int']>;
	/** The date and time when the ScenarioSessionPart ended. */
	endedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** A list of ScenarioSessionEvents associated with the ScenarioSessionPart. */
	events?: Maybe<ScenarioSessionPartScenarioSessionEventConnection>;
	/** 3rd party data associated with the ScenarioSessionPart. */
	externalData?: Maybe<Scalars['JSON']>;
	/** Global ID of the ScenarioSessionPart record. This should be persistent if data is migrated and is recommended to use. */
	guid?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The date that the scenario session was last accessed. */
	lastAccessedDate?: Maybe<Scalars['ISO8601DateTime']>;
	/** The id of the step that was last accessed. */
	lastAccessedStepIdentifier?: Maybe<Scalars['Int']>;
	/** The position or number of the last accessed step by the user. */
	lastAccessedStepPosition?: Maybe<Scalars['Int']>;
	/** The most recent event associated with the viewing a step by a user. */
	lastViewStepEvent?: Maybe<ScenarioSessionEvent>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The order of the ScenarioSessionPart within the context of a ScenarioSession. */
	orderIndex?: Maybe<Scalars['Int']>;
	/** The Organization associated with the ScenarioSessionPart. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionPart. */
	permissions: ScenarioSessionPartPermissions;
	/** The ScenarioSession associated with the ScenarioSessionPart. */
	scenarioSession?: Maybe<ScenarioSession>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The date and time when the ScenarioSessionPart started. */
	startedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The state of the session part. Corresponds to ScenarioSessionStateEnum. */
	state?: Maybe<ScenarioSessionStateEnum>;
	/** A list of ScenarioSessionSteps associated with the ScenarioSessionPart. */
	steps?: Maybe<ScenarioSessionPartScenarioSessionStepConnection>;
	/** when the record was last updated at. usually does not change. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** Information about the associated user. */
	userInfo?: Maybe<ScenarioSessionPartUserInfo>;
};


/** Represents one part of a ScenarioSession (note: resuming a Session creates a new part). */
export type ScenarioSessionPartCallsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents one part of a ScenarioSession (note: resuming a Session creates a new part). */
export type ScenarioSessionPartEventsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	eventData?: InputMaybe<ScenarioSessionEventsEventDataInput>;
	eventTypes?: InputMaybe<Array<ScenarioSessionEventTypeEnum>>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioIds?: InputMaybe<Array<Scalars['ID']>>;
	scenarioSessionId?: InputMaybe<Scalars['ID']>;
	scenarioSessionPartId?: InputMaybe<Scalars['ID']>;
	startedAtRange?: InputMaybe<DateRangeInputObject>;
	user?: InputMaybe<ScenarioSessionEventsUserInput>;
	valueTypes?: InputMaybe<Array<ScenarioStepItemTypeEnum>>;
};


/** Represents one part of a ScenarioSession (note: resuming a Session creates a new part). */
export type ScenarioSessionPartStepsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	externalData?: InputMaybe<Scalars['JSON']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	type?: InputMaybe<ScenarioStepTypeEnum>;
};

/** A connection from a Node. */
export type ScenarioSessionPartCallConnection = {
	__typename?: 'ScenarioSessionPartCallConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionPartCallEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Call>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionPartCallConnection. */
	permissions: ScenarioSessionPartCallConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionPartCallConnectionPermissions = {
	__typename?: 'ScenarioSessionPartCallConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionPartCallEdge = {
	__typename?: 'ScenarioSessionPartCallEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Call>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSessionPartPermissions = {
	__typename?: 'ScenarioSessionPartPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioSessionPartScenarioSessionEventConnection = {
	__typename?: 'ScenarioSessionPartScenarioSessionEventConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionPartScenarioSessionEventEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionEvent>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionPartScenarioSessionEventConnection. */
	permissions: ScenarioSessionPartScenarioSessionEventConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionPartScenarioSessionEventConnectionPermissions = {
	__typename?: 'ScenarioSessionPartScenarioSessionEventConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionPartScenarioSessionEventEdge = {
	__typename?: 'ScenarioSessionPartScenarioSessionEventEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionEvent>;
};

/** A connection from a Node. */
export type ScenarioSessionPartScenarioSessionStepConnection = {
	__typename?: 'ScenarioSessionPartScenarioSessionStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionPartScenarioSessionStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionPartScenarioSessionStepConnection. */
	permissions: ScenarioSessionPartScenarioSessionStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionPartScenarioSessionStepConnectionPermissions = {
	__typename?: 'ScenarioSessionPartScenarioSessionStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionPartScenarioSessionStepEdge = {
	__typename?: 'ScenarioSessionPartScenarioSessionStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionStep>;
};

/** Represents the user information of one part of a ScenarioSession. */
export type ScenarioSessionPartUserInfo = NodeInterface & {
	__typename?: 'ScenarioSessionPartUserInfo';
	/** when the record was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The user devices model. */
	deviceModel?: Maybe<Scalars['String']>;
	/** The user device operating system. */
	deviceOs?: Maybe<Scalars['String']>;
	/** The user device platform. */
	devicePlatform?: Maybe<PlatformTypeEnum>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** User's geolocation latitude coordinate. */
	latitude?: Maybe<Scalars['Float']>;
	/** User's geolocation longitude coordinate. */
	longitude?: Maybe<Scalars['Float']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The organization the user belongs to. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionPartUserInfo. */
	permissions: ScenarioSessionPartUserInfoPermissions;
	/** The associated ScenarioSessionPart. */
	scenarioSessionPart?: Maybe<ScenarioSessionPart>;
	/** The SDK version associated with the ScenarioRelease. */
	sdkVersion?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** when the record was last updated at. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User record associated with the information. */
	user?: Maybe<User>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSessionPartUserInfoPermissions = {
	__typename?: 'ScenarioSessionPartUserInfoPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Autogenerated nested input type of ScenarioSessionParts */
export type ScenarioSessionPartsExternalDataInput = {
	/** The external data key (or JSON key path) to be used to filter scenario session parts. */
	key?: InputMaybe<Scalars['String']>;
	/** The type of way to find the key-value pair in the external data. Can be MATCH or CONTAINS. */
	type?: InputMaybe<Scalars['String']>;
	/** The value of the external data key to be used to filter scenario session parts. */
	value?: InputMaybe<Scalars['Alphanumeric']>;
};

/** Autogenerated nested input type of ScenarioSessionParts */
export type ScenarioSessionPartsUserInput = {
	/** The GQL ID of a user to filter the scenario session parts by. */
	id?: InputMaybe<Scalars['ID']>;
	/** The username to filter the scenario session parts by. */
	username?: InputMaybe<Scalars['String']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSessionPermissions = {
	__typename?: 'ScenarioSessionPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioSessionScenarioSessionEventConnection = {
	__typename?: 'ScenarioSessionScenarioSessionEventConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionScenarioSessionEventEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionEvent>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionScenarioSessionEventConnection. */
	permissions: ScenarioSessionScenarioSessionEventConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionScenarioSessionEventConnectionPermissions = {
	__typename?: 'ScenarioSessionScenarioSessionEventConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionScenarioSessionEventEdge = {
	__typename?: 'ScenarioSessionScenarioSessionEventEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionEvent>;
};

/** A connection from a Node. */
export type ScenarioSessionScenarioSessionPartConnection = {
	__typename?: 'ScenarioSessionScenarioSessionPartConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionScenarioSessionPartEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionPart>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionScenarioSessionPartConnection. */
	permissions: ScenarioSessionScenarioSessionPartConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionScenarioSessionPartConnectionPermissions = {
	__typename?: 'ScenarioSessionScenarioSessionPartConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionScenarioSessionPartEdge = {
	__typename?: 'ScenarioSessionScenarioSessionPartEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionPart>;
};

/** A connection from a Node. */
export type ScenarioSessionScenarioSessionStepConnection = {
	__typename?: 'ScenarioSessionScenarioSessionStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionScenarioSessionStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionScenarioSessionStepConnection. */
	permissions: ScenarioSessionScenarioSessionStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionScenarioSessionStepConnectionPermissions = {
	__typename?: 'ScenarioSessionScenarioSessionStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionScenarioSessionStepEdge = {
	__typename?: 'ScenarioSessionScenarioSessionStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionStep>;
};

/** A connection from a Node. */
export type ScenarioSessionScenarioStepConnection = {
	__typename?: 'ScenarioSessionScenarioStepConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionScenarioStepEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStep>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionScenarioStepConnection. */
	permissions: ScenarioSessionScenarioStepConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionScenarioStepConnectionPermissions = {
	__typename?: 'ScenarioSessionScenarioStepConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionScenarioStepEdge = {
	__typename?: 'ScenarioSessionScenarioStepEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStep>;
};

/** A connection from a Node. */
export type ScenarioSessionScenarioStepItemConnection = {
	__typename?: 'ScenarioSessionScenarioStepItemConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionScenarioStepItemEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStepItem>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionScenarioStepItemConnection. */
	permissions: ScenarioSessionScenarioStepItemConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionScenarioStepItemConnectionPermissions = {
	__typename?: 'ScenarioSessionScenarioStepItemConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionScenarioStepItemEdge = {
	__typename?: 'ScenarioSessionScenarioStepItemEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStepItem>;
};

export enum ScenarioSessionStateEnum {
	/** A ScenarioSession that is finished. */
	Finished = 'FINISHED',
	/** A ScenarioSession that is locked. */
	Locked = 'LOCKED',
	/** A ScenarioSession that is resumed. */
	Resumed = 'RESUMED',
	/** A ScenarioSession that is unlocked. */
	Unlocked = 'UNLOCKED'
}

/** Represents a set of events associated with a ScenarioSession pertaining to a ScenarioStep. */
export type ScenarioSessionStep = NodeInterface & {
	__typename?: 'ScenarioSessionStep';
	/** Whether all checklist items in the ScenarioStep have been completed or not. */
	completed?: Maybe<Scalars['Boolean']>;
	/** A list of Step Items completed in the current Scenario Session Step. */
	completedItems?: Maybe<ScenarioSessionStepScenarioStepItemConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The amount of time taken to complete a scenario session step. */
	duration?: Maybe<Scalars['Int']>;
	/** The time the user completes the scenario session step. */
	endedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioSessionStep. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionStep. */
	permissions: ScenarioSessionStepPermissions;
	/** The ScenarioSession associated with the ScenarioSessionStep. */
	scenarioSession?: Maybe<ScenarioSession>;
	/** A list of ScenarioSessionEvents associated with the ScenarioSessionStep. */
	scenarioSessionEvents?: Maybe<ScenarioSessionStepScenarioSessionEventConnection>;
	/** The ScenarioSessionPart associated with the ScenarioSessionStep. */
	scenarioSessionPart?: Maybe<ScenarioSessionPart>;
	/** A list of ScenarioSessionStepItems associated with the ScenarioSessionStep. */
	scenarioSessionStepItems?: Maybe<ScenarioSessionStepScenarioSessionStepItemConnection>;
	/** The ScenarioStep associated with the ScenarioSessionStep. */
	scenarioStep?: Maybe<ScenarioStep>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The time the user starts the scenario session step. */
	startedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents a set of events associated with a ScenarioSession pertaining to a ScenarioStep. */
export type ScenarioSessionStepCompletedItemsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of events associated with a ScenarioSession pertaining to a ScenarioStep. */
export type ScenarioSessionStepScenarioSessionEventsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	eventData?: InputMaybe<ScenarioSessionEventsEventDataInput>;
	eventTypes?: InputMaybe<Array<ScenarioSessionEventTypeEnum>>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	scenarioIds?: InputMaybe<Array<Scalars['ID']>>;
	scenarioSessionId?: InputMaybe<Scalars['ID']>;
	scenarioSessionPartId?: InputMaybe<Scalars['ID']>;
	startedAtRange?: InputMaybe<DateRangeInputObject>;
	user?: InputMaybe<ScenarioSessionEventsUserInput>;
	valueTypes?: InputMaybe<Array<ScenarioStepItemTypeEnum>>;
};


/** Represents a set of events associated with a ScenarioSession pertaining to a ScenarioStep. */
export type ScenarioSessionStepScenarioSessionStepItemsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** Represents a set of events associated with a ScenarioSession pertaining to a ScenerioCheckbox. */
export type ScenarioSessionStepItem = NodeInterface & {
	__typename?: 'ScenarioSessionStepItem';
	/**
   * A list of Attachments associated with the ScenarioSessionStepItem.
   * @deprecated Not yet implemented.
   */
	attachments?: Maybe<ScenarioSessionStepItemAttachmentConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioSessionStepItem. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionStepItem. */
	permissions: ScenarioSessionStepItemPermissions;
	/** The ScenarioSession associated with the ScenarioSessionStepItem. */
	scenarioSession?: Maybe<ScenarioSession>;
	/** A list of ScenarioSessionEvents associated with the ScenarioSessionStepItem. */
	scenarioSessionEvents?: Maybe<ScenarioSessionStepItemScenarioSessionEventConnection>;
	/** The ScenarioSessionStep associated with the ScenarioSessionStepItem. */
	scenarioSessionStep?: Maybe<ScenarioSessionStep>;
	/** The ScenarioStepItem associated with the ScenarioSessionStepItem. */
	scenarioStepItem?: Maybe<ScenarioStepItem>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The source associated with the ScenarioSessionStepItem. */
	source?: Maybe<ScenarioSessionEventSourceEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The value of the ScenarioSessionStepItem. */
	value?: Maybe<Scalars['String']>;
	/** The history of values previously set for the ScenarioSessionStepItem. */
	valueHistory?: Maybe<Array<Scalars['String']>>;
};


/** Represents a set of events associated with a ScenarioSession pertaining to a ScenerioCheckbox. */
export type ScenarioSessionStepItemAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a set of events associated with a ScenarioSession pertaining to a ScenerioCheckbox. */
export type ScenarioSessionStepItemScenarioSessionEventsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Attachment. */
export type ScenarioSessionStepItemAttachmentConnection = {
	__typename?: 'ScenarioSessionStepItemAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionStepItemAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Attachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ScenarioSessionStepItemAttachmentEdge = {
	__typename?: 'ScenarioSessionStepItemAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Attachment>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSessionStepItemPermissions = {
	__typename?: 'ScenarioSessionStepItemPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioSessionStepItemScenarioSessionEventConnection = {
	__typename?: 'ScenarioSessionStepItemScenarioSessionEventConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionStepItemScenarioSessionEventEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionEvent>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionStepItemScenarioSessionEventConnection. */
	permissions: ScenarioSessionStepItemScenarioSessionEventConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionStepItemScenarioSessionEventConnectionPermissions = {
	__typename?: 'ScenarioSessionStepItemScenarioSessionEventConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionStepItemScenarioSessionEventEdge = {
	__typename?: 'ScenarioSessionStepItemScenarioSessionEventEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionEvent>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioSessionStepPermissions = {
	__typename?: 'ScenarioSessionStepPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioSessionStepScenarioSessionEventConnection = {
	__typename?: 'ScenarioSessionStepScenarioSessionEventConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionStepScenarioSessionEventEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionEvent>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionStepScenarioSessionEventConnection. */
	permissions: ScenarioSessionStepScenarioSessionEventConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionStepScenarioSessionEventConnectionPermissions = {
	__typename?: 'ScenarioSessionStepScenarioSessionEventConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionStepScenarioSessionEventEdge = {
	__typename?: 'ScenarioSessionStepScenarioSessionEventEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionEvent>;
};

/** A connection from a Node. */
export type ScenarioSessionStepScenarioSessionStepItemConnection = {
	__typename?: 'ScenarioSessionStepScenarioSessionStepItemConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionStepScenarioSessionStepItemEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionStepItem>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionStepScenarioSessionStepItemConnection. */
	permissions: ScenarioSessionStepScenarioSessionStepItemConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionStepScenarioSessionStepItemConnectionPermissions = {
	__typename?: 'ScenarioSessionStepScenarioSessionStepItemConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionStepScenarioSessionStepItemEdge = {
	__typename?: 'ScenarioSessionStepScenarioSessionStepItemEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionStepItem>;
};

/** A connection from a Node. */
export type ScenarioSessionStepScenarioStepItemConnection = {
	__typename?: 'ScenarioSessionStepScenarioStepItemConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioSessionStepScenarioStepItemEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStepItem>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioSessionStepScenarioStepItemConnection. */
	permissions: ScenarioSessionStepScenarioStepItemConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioSessionStepScenarioStepItemConnectionPermissions = {
	__typename?: 'ScenarioSessionStepScenarioStepItemConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioSessionStepScenarioStepItemEdge = {
	__typename?: 'ScenarioSessionStepScenarioStepItemEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStepItem>;
};

/** Autogenerated nested input type of ScenarioSessions */
export type ScenarioSessionsExternalDataInput = {
	/** The external data key (or JSON key path) to be used to filter scenario sessions. */
	key?: InputMaybe<Scalars['String']>;
	/** The type of way to find the key-value pair in the external data. Can be MATCH or CONTAINS. */
	type?: InputMaybe<Scalars['String']>;
	/** The value of the external data key to be used to filter scenario sessions. */
	value?: InputMaybe<Scalars['Alphanumeric']>;
};

/** Autogenerated nested input type of ScenarioSessions */
export type ScenarioSessionsUserInput = {
	/** The GQL ID of a user to filter the scenario sessions by. */
	id?: InputMaybe<Scalars['ID']>;
	/** The username to filter the scenario sessions by. */
	username?: InputMaybe<Scalars['String']>;
};

export enum ScenarioStateEnum {
	/** Approved. */
	Approved = 'APPROVED',
	/** Archived. */
	Archived = 'ARCHIVED',
	/** Major Change Requested. */
	ChangeRequested = 'CHANGE_REQUESTED',
	/** Minor Change Requested. */
	MinorChangeRequested = 'MINOR_CHANGE_REQUESTED',
	/** Stateless. */
	Null = 'NULL',
	/** Under Review. */
	UnderReview = 'UNDER_REVIEW',
	/** Work In Progress. */
	WorkInProgress = 'WORK_IN_PROGRESS'
}

/** Represents one step in a multi-step ScenarioRelease. */
export type ScenarioStep = NodeInterface & {
	__typename?: 'ScenarioStep';
	/**
   * A list of Attachments associated with the ScenarioStep.
   * @deprecated Not yet implemented.
   */
	attachments?: Maybe<ScenarioStepAttachmentConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The identifier associated with the ScenarioStep in the authoring system. */
	externalData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** A list of ScenarioStep attributes associated with the ScenarioStep. */
	items?: Maybe<ScenarioStepScenarioStepItemConnection>;
	/** The name of the ScenarioStep. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The order of the ScenarioStep within the context of a ScenarioRelease &/ ScenarioSequence. */
	orderIndex?: Maybe<Scalars['Int']>;
	/** The Organization associated with the ScenarioStep. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioStep. */
	permissions: ScenarioStepPermissions;
	/** The ScenarioRelease associated with the ScenarioStep. */
	scenarioRelease?: Maybe<ScenarioRelease>;
	/** The ScenarioSequence associated with the ScenarioStep. */
	scenarioSequence?: Maybe<ScenarioSequence>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The type of the ScenarioStep. */
	type?: Maybe<ScenarioStepTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents one step in a multi-step ScenarioRelease. */
export type ScenarioStepAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents one step in a multi-step ScenarioRelease. */
export type ScenarioStepItemsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Attachment. */
export type ScenarioStepAttachmentConnection = {
	__typename?: 'ScenarioStepAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioStepAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Attachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ScenarioStepAttachmentEdge = {
	__typename?: 'ScenarioStepAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Attachment>;
};

/** Represents a checklist item in a ScenarioStep (where the step behaves like a checklist). */
export type ScenarioStepItem = NodeInterface & {
	__typename?: 'ScenarioStepItem';
	/**
   * A list of Attachments associated with the ScenarioStepItem.
   * @deprecated Not yet implemented.
   */
	attachments?: Maybe<ScenarioStepItemAttachmentConnection>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The description of the ScenarioStepItem. */
	description?: Maybe<Scalars['String']>;
	/** Identifies the unique id used by the authoring tool. */
	externalData?: Maybe<Scalars['JSON']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the ScenarioStepItem. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the ScenarioStepItem. */
	permissions: ScenarioStepItemPermissions;
	/** A list of ScenarioSessionStepItems associated with the ScenarioStepItem. */
	scenarioSessionStepItems?: Maybe<ScenarioStepItemScenarioSessionStepItemConnection>;
	/** The ScenarioStep associated with the ScenarioStepItem. */
	scenarioStep?: Maybe<ScenarioStep>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** The type of the ScenarioStepItem. */
	type?: Maybe<ScenarioStepItemTypeEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};


/** Represents a checklist item in a ScenarioStep (where the step behaves like a checklist). */
export type ScenarioStepItemAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a checklist item in a ScenarioStep (where the step behaves like a checklist). */
export type ScenarioStepItemScenarioSessionStepItemsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Attachment. */
export type ScenarioStepItemAttachmentConnection = {
	__typename?: 'ScenarioStepItemAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioStepItemAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Attachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ScenarioStepItemAttachmentEdge = {
	__typename?: 'ScenarioStepItemAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Attachment>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioStepItemPermissions = {
	__typename?: 'ScenarioStepItemPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioStepItemScenarioSessionStepItemConnection = {
	__typename?: 'ScenarioStepItemScenarioSessionStepItemConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioStepItemScenarioSessionStepItemEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSessionStepItem>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioStepItemScenarioSessionStepItemConnection. */
	permissions: ScenarioStepItemScenarioSessionStepItemConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioStepItemScenarioSessionStepItemConnectionPermissions = {
	__typename?: 'ScenarioStepItemScenarioSessionStepItemConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioStepItemScenarioSessionStepItemEdge = {
	__typename?: 'ScenarioStepItemScenarioSessionStepItemEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSessionStepItem>;
};

export enum ScenarioStepItemTypeEnum {
	/** A barcode ScenarioSessionStepItem item. */
	Barcode = 'BARCODE',
	/** A boolean ScenarioSessionStepItem item. */
	Boolean = 'BOOLEAN',
	/** A multi_option ScenarioSessionStepItem item. */
	MultiOption = 'MULTI_OPTION',
	/** A multi_option ScenarioSessionStepItem item in 3d space. */
	MultiOption_3D = 'MULTI_OPTION_3D',
	/** Multiple selections can be made. */
	MultiSelect = 'MULTI_SELECT',
	/** Multiple selections of objects in 3d space. */
	MultiSelect_3D = 'MULTI_SELECT_3D',
	/** A number ScenarioSessionStepItem item. */
	Number = 'NUMBER',
	/** A photo ScenarioSessionStepItem item. */
	Photo = 'PHOTO',
	/** Multiple quiz choice selections. */
	QuizMultipleChoice_2D = 'QUIZ_MULTIPLE_CHOICE_2D',
	/** Multiple quiz choice selections in 3d space. */
	QuizMultipleChoice_3D = 'QUIZ_MULTIPLE_CHOICE_3D',
	/** Multiple quiz selections. */
	QuizMultiSelect_2D = 'QUIZ_MULTI_SELECT_2D',
	/** Multiple quiz selections in 3d space. */
	QuizMultiSelect_3D = 'QUIZ_MULTI_SELECT_3D',
	/** A text ScenarioSessionStepItem item. */
	Text = 'TEXT',
	/** A yes_no_option ScenarioSessionStepItem item. */
	YesNoOption = 'YES_NO_OPTION'
}

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ScenarioStepPermissions = {
	__typename?: 'ScenarioStepPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ScenarioStepScenarioStepItemConnection = {
	__typename?: 'ScenarioStepScenarioStepItemConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ScenarioStepScenarioStepItemEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioStepItem>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ScenarioStepScenarioStepItemConnection. */
	permissions: ScenarioStepScenarioStepItemConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ScenarioStepScenarioStepItemConnectionPermissions = {
	__typename?: 'ScenarioStepScenarioStepItemConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ScenarioStepScenarioStepItemEdge = {
	__typename?: 'ScenarioStepScenarioStepItemEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioStepItem>;
};

export enum ScenarioStepTypeEnum {
	/** A ScenarioStep that prompts the user to jump to another step. */
	Branch = 'BRANCH',
	/** A ScenarioStep that prompts the user to complete items. */
	Checklist = 'CHECKLIST',
	/** A ScenarioStep that prompts the user to place the AR content. */
	ContentPlacement = 'CONTENT_PLACEMENT',
	/** The default type for a ScenarioStep that isn't otherwise like the other types. */
	Default = 'DEFAULT',
	/** A ScenarioStep that prompts the user to complete quiz items. */
	Quiz = 'QUIZ'
}

/** Scenario update arguments. */
export type ScenarioUpdateInputObject = {
	/** Scenario database id. */
	databaseId?: InputMaybe<Scalars['Int']>;
	/** Scenario id. */
	id?: InputMaybe<Scalars['String']>;
	/** groups requested for scenario. */
	requestedGroups?: InputMaybe<Array<Scalars['ID']>>;
	/** origin group requested for scenario. */
	requestedOriginGroup?: InputMaybe<Scalars['ID']>;
	scenario?: InputMaybe<ScenarioUpdateInputObjectScenarioInput>;
	scenarioRelease?: InputMaybe<ScenarioUpdateInputObjectScenarioReleaseInput>;
	/** Scope file binary for direct upload. */
	scopeFile?: InputMaybe<Scalars['Upload']>;
	/** ID of S3 uploaded scope file. */
	uploadId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated nested input type of ScenarioUpdateInputObject */
export type ScenarioUpdateInputObjectScenarioInput = {
	/** Description of scenario. */
	description?: InputMaybe<Scalars['String']>;
	/** Name of scenario. */
	name?: InputMaybe<Scalars['String']>;
	/** Whether the scenario is publicly available or not. */
	public?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated nested input type of ScenarioUpdateInputObject */
export type ScenarioUpdateInputObjectScenarioReleaseInput = {
	/** External data of the release. */
	externalData?: InputMaybe<Scalars['JSON']>;
	/** Scene name of the release. */
	sceneName?: InputMaybe<Scalars['String']>;
	/** SDK version of the release. */
	sdkVersion?: InputMaybe<Scalars['String']>;
	/** Session type of the release. */
	sessionType?: InputMaybe<ScenarioReleaseTypeEnum>;
};

/** Scenarios query arguments. */
export type ScenariosQueryInputObject = {
	/** Used by the Worklink App to correctly return a list of scenarios for display purposes. */
	appList?: InputMaybe<Scalars['Boolean']>;
	/** Array of GQL scenario author ids. */
	authorIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A Catalog ID. */
	catalogId?: InputMaybe<Scalars['ID']>;
	/** Array of scenario database ids. */
	databaseIds?: InputMaybe<Array<Scalars['Int']>>;
	/** Array of excluded GQL scenario catalog ids. */
	excludeCatalogIds?: InputMaybe<Array<Scalars['ID']>>;
	/** Array of excluded GQL scenario group ids. */
	excludeGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
	/** String matching the name of a Scenario. */
	fullText?: InputMaybe<Scalars['String']>;
	/** Array of GQL scenario group ids. */
	groupIds?: InputMaybe<Array<Scalars['ID']>>;
	/** Array of GQL scenario ids. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
	/** A boolean input to also get deleted Scenarios. */
	includeDeleted?: InputMaybe<Scalars['Boolean']>;
	/** A boolean input to get a list with only the latest revision of each scenario. */
	latestRevisionOnly?: InputMaybe<Scalars['Boolean']>;
	/** A sort order input object. */
	orderBy?: InputMaybe<SortOrderInputObject>;
	/** A distinct list of scenario origin group ids. */
	originGroupIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A boolean input to get only Public or Private Scenarios. */
	publicVisibility?: InputMaybe<Scalars['Boolean']>;
	/** A boolean input to get only published Scenarios. */
	published?: InputMaybe<Scalars['Boolean']>;
	/** A date range input object with starting and ending published at values. */
	publishedAt?: InputMaybe<DateRangeInputObject>;
	/** A boolean input to get only released Scenarios. */
	released?: InputMaybe<Scalars['Boolean']>;
	/** A date range input object with starting and ending released at values. */
	releasedAt?: InputMaybe<DateRangeInputObject>;
	/** A list of project states. */
	states?: InputMaybe<Array<ScenarioStateEnum>>;
	/** A list of work instruction types. */
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};

/** Represents an Attachment shared from one User to another User. */
export type SharedAttachment = NodeInterface & {
	__typename?: 'SharedAttachment';
	/**
   * The Attachment associated with the SharedAttachment.
   * @deprecated Not yet implemented.
   */
	attachment?: Maybe<Attachment>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the SharedAttachment. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the SharedAttachment. */
	permissions: SharedAttachmentPermissions;
	/** The User that received the associated SharedAttachment. */
	receiver?: Maybe<User>;
	/** The User that sent the associated SharedAttachment. */
	sender?: Maybe<User>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type SharedAttachmentPermissions = {
	__typename?: 'SharedAttachmentPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

export enum SortOrderDirectionEnum {
	/** Sort ascending. */
	Asc = 'ASC',
	/** Sort descending. */
	Desc = 'DESC'
}

/** Sort order. */
export type SortOrderInputObject = {
	/** Column or attribute be sorted. */
	attribute: Scalars['String'];
	/** Sorting direction either ascending or descending. */
	direction: SortOrderDirectionEnum;
};

export enum SsoLoginHintEnum {
	/** Send the user's email as the login_hint parameter in the SSO route. */
	Email = 'EMAIL',
	/** Do not send the login_hint parameter in the SSO route. */
	None = 'NONE',
	/** Send the user's username as the login_hint parameter in the SSO route. */
	Username = 'USERNAME'
}

export enum SsoProviderEnum {
	/** A User provisioned with OPENID. */
	OpenidConnect = 'OPENID_CONNECT',
	/** A User provisioned with SAML. */
	Saml = 'SAML',
	/** A User provisioned with Scope AZ OAUTH. */
	ScopeAzOauth = 'SCOPE_AZ_OAUTH'
}

export enum StarRatingEnum {
	/** A rating of five stars. */
	Five = 'FIVE',
	/** A rating of four stars. */
	Four = 'FOUR',
	/** A rating of one star. */
	One = 'ONE',
	/** A rating of three stars. */
	Three = 'THREE',
	/** A rating of two stars. */
	Two = 'TWO',
	/** A rating of zero stars. */
	Zero = 'ZERO'
}

/** API Token upsert arguments. */
export type UpdateApiTokenMutationInput = {
	/** Whether the API Token has permissions on all Groups in the Organization. */
	allGroups: Scalars['Boolean'];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of Groups the API Token has permissions over. */
	groups?: InputMaybe<Array<Scalars['ID']>>;
	/** API Token ID. */
	id: Scalars['ID'];
	/** Name of the API Token. */
	name: Scalars['String'];
};

/** An Object. */
export type UpdateApiTokenMutationPayload = {
	__typename?: 'UpdateApiTokenMutationPayload';
	/** Resulted API Token. */
	apiToken?: Maybe<ApiToken>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Input object for updating an existing asset. */
export type UpdateAssetMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Marks the S3 file upload as complete. */
	completeFileUpload?: InputMaybe<Scalars['Boolean']>;
	/** Marks the S3 preview file upload as complete. */
	completePreviewFileUpload?: InputMaybe<Scalars['Boolean']>;
	/** Marks the S3 processed file upload as complete. */
	completeProcessedFileUpload?: InputMaybe<Scalars['Boolean']>;
	/** The database ID of the asset to be updated. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** The database ID of the folder where the asset is located. */
	folderDatabaseId?: InputMaybe<Scalars['String']>;
	/** The ID of the folder where the asset is located. */
	folderId?: InputMaybe<Scalars['ID']>;
	/** The ID of the asset to be updated. */
	id?: InputMaybe<Scalars['String']>;
	/** The new name of the asset. */
	name?: InputMaybe<Scalars['String']>;
	/** The ID of the new owner of the asset. It can either be a user, an organization or null to unset it. */
	ownerId?: InputMaybe<Scalars['ID']>;
	/** File used for preview generation. */
	previewFile?: InputMaybe<Scalars['Upload']>;
	/** Name of the preview file. */
	previewFileName?: InputMaybe<Scalars['String']>;
	/** Processed version of the uploaded asset. */
	processedFile?: InputMaybe<Scalars['Upload']>;
	/** Name of the processed file. */
	processedFileName?: InputMaybe<Scalars['String']>;
	/** A list of revision database IDs to be removed from the asset. */
	removeRevisionsDatabaseIds?: InputMaybe<Array<Scalars['String']>>;
	/** A list of revision IDs to be removed from the asset. */
	removeRevisionsIds?: InputMaybe<Array<Scalars['ID']>>;
	/** Requests an S3 pre-signed URL for uploading a preview file. */
	requestPreviewFileUploadUrl?: InputMaybe<Scalars['Boolean']>;
	/** Requests an S3 pre-signed URL for uploading a processed file. */
	requestProcessedFileUploadUrl?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type UpdateAssetMutationPayload = {
	__typename?: 'UpdateAssetMutationPayload';
	/** The asset that was updated. */
	asset?: Maybe<Asset>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Input object for updating an asset revision. */
export type UpdateAssetRevisionMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The database ID of the asset revision to be updated. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** The ID of the asset revision to be updated. */
	id?: InputMaybe<Scalars['String']>;
	/** The new name of the asset revision. */
	name?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type UpdateAssetRevisionMutationPayload = {
	__typename?: 'UpdateAssetRevisionMutationPayload';
	/** The asset revision that was updated. */
	assetRevision?: Maybe<AssetRevision>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Call Update Arguments. */
export type UpdateCallMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Boolean value to set if the call is complete. */
	done?: InputMaybe<Scalars['Boolean']>;
	/** Altitude of expert device. */
	expertAltitude?: InputMaybe<Scalars['String']>;
	/** Model of the expert's device. */
	expertDeviceModel?: InputMaybe<Scalars['String']>;
	/** Operating System of the expert's device. */
	expertDeviceOs?: InputMaybe<Scalars['String']>;
	/** Unique ID of the expert's device. */
	expertDeviceUniqueIdentifier?: InputMaybe<Scalars['String']>;
	/** Known latitude of the expert's device. */
	expertLatitude?: InputMaybe<Scalars['String']>;
	/** Longitude of the expert's device. */
	expertLongitude?: InputMaybe<Scalars['String']>;
	/** OS Version of the expert's device. */
	expertVersion?: InputMaybe<Scalars['String']>;
	/** JSON object of any externally provided data. */
	externalData?: InputMaybe<Scalars['JSON']>;
	/** Altitude of tech's device. */
	techAltitude?: InputMaybe<Scalars['String']>;
	/** Which platform the tech is using. */
	techArPlatform?: InputMaybe<Scalars['String']>;
	/** Model of the tech's device. */
	techDeviceModel?: InputMaybe<Scalars['String']>;
	/** Operating System of the tech's device. */
	techDeviceOs?: InputMaybe<Scalars['String']>;
	/** Unique ID of the tech's device. */
	techDeviceUniqueIdentifier?: InputMaybe<Scalars['String']>;
	/** Known latitude of the tech's device. */
	techLatitude?: InputMaybe<Scalars['String']>;
	/** Longitude of the tech's device. */
	techLongitude?: InputMaybe<Scalars['String']>;
	/** OS Version of the tech's device. */
	techVersion?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type UpdateCallMutationPayload = {
	__typename?: 'UpdateCallMutationPayload';
	/** A call instance. */
	call?: Maybe<Call>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateCallRecordingsMutation */
export type UpdateCallRecordingsMutationInput = {
	/** A list of call recording input objects. */
	callRecordings?: InputMaybe<Array<CallRecordingInputObject>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Boolean to determine if the call recordings are to be reprocessed. */
	reprocess?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type UpdateCallRecordingsMutationPayload = {
	__typename?: 'UpdateCallRecordingsMutationPayload';
	/** List of call recordings returned. */
	callRecordings?: Maybe<Array<CallRecording>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateEulaMutation */
export type UpdateEulaMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Content for EULA. */
	content: Scalars['String'];
	/** Boolean value for identified update/create eula for company or system-wide. */
	forScope?: InputMaybe<Scalars['Boolean']>;
	/** Eula id. */
	id: Scalars['ID'];
	/** Name for EULA. */
	name: Scalars['String'];
};

/** An Object. */
export type UpdateEulaMutationPayload = {
	__typename?: 'UpdateEulaMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted EULA. */
	eula?: Maybe<Eula>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateEulasMutation */
export type UpdateEulasMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Eulas record which needd to be update. */
	eulas?: InputMaybe<Array<Scalars['String']>>;
	/** Boolean value for identified update eulas for company or system-wide. */
	forScope?: InputMaybe<Scalars['Boolean']>;
	/** Eula ids. */
	ids: Array<Scalars['ID']>;
	/** Boolean value to check for updating order for eula. */
	updateOrder?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type UpdateEulasMutationPayload = {
	__typename?: 'UpdateEulasMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted EULAs. */
	eulas?: Maybe<Array<Eula>>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateGroupMutation */
export type UpdateGroupMutationInput = {
	/** List of GQL group ids. */
	callRecipientGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Group id. */
	id: Scalars['ID'];
	/** Name for group. */
	name: Scalars['String'];
	/** List of GQL group ids. */
	scenarioRecipientGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** An Object. */
export type UpdateGroupMutationPayload = {
	__typename?: 'UpdateGroupMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted group. */
	group?: Maybe<Group>;
	success: Scalars['Boolean'];
};

/** Integration upsert arguments. */
export type UpdateIntegrationMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	config?: InputMaybe<IntegrationUpsertInputObjectConfigInput>;
	/** Description of the Integration. */
	description?: InputMaybe<Scalars['String']>;
	/** Integration id. */
	id: Scalars['ID'];
	/** Name of the Integration, generally the provider name. */
	name?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type UpdateIntegrationMutationPayload = {
	__typename?: 'UpdateIntegrationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Upserted Integration if the mutation is successful. */
	integration?: Maybe<Integration>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateInvitationsMutation */
export type UpdateInvitationsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Ids of the users invitation. */
	ids?: InputMaybe<Array<Scalars['String']>>;
	invitations: Array<InviteUpdateInputObject>;
};

/** An Object. */
export type UpdateInvitationsMutationPayload = {
	__typename?: 'UpdateInvitationsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The invitations to update. */
	invitations?: Maybe<Array<Invitation>>;
	success: Scalars['Boolean'];
};

/** Organization Update Arguments. */
export type UpdateOrganizationMutationInput = {
	/** Number of days Organization Audit Logs will be retained for. */
	auditLogsRetentionPeriod?: InputMaybe<Scalars['Days']>;
	/** Boolean value enabled/disabled call recording option in organization. */
	callRecordingEnabled?: InputMaybe<Scalars['Boolean']>;
	/** Calling access for organization. */
	callingAccess?: InputMaybe<OrganizationUpsertInputObjectCallingAccessInput>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The data storage region for the Organization. Do not edit this or otherwise files might not be available. Proceed with caution! */
	dataStorageRegion?: InputMaybe<OrganizationDataStorageRegionEnum>;
	/** Default expiration duration for attachments. */
	defaultAttachmentExpirationDuration?: InputMaybe<Scalars['Days']>;
	/** flag to disable APP upgrade prompts. */
	disableAppUpgradePrompts?: InputMaybe<Scalars['Boolean']>;
	/** Feature flag settings for organization. String as key, bool as value. */
	features?: InputMaybe<Array<FeatureFlagInputObject>>;
	guestAccountPolicy?: InputMaybe<OrganizationUpsertInputObjectGuestAccountPolicyInput>;
	/** Scope license file. */
	licenseFile?: InputMaybe<Scalars['Upload']>;
	/** Company Logo. */
	logo?: InputMaybe<Scalars['Upload']>;
	/** Name for organization. */
	name: Scalars['String'];
	/** id of organization to update. */
	organizationId: Scalars['ID'];
	/** Boolean value for company reopen confirmation. */
	reopen?: InputMaybe<Scalars['Boolean']>;
	/** Scenario access for organization. */
	scenarioAccess?: InputMaybe<OrganizationUpsertInputObjectScenarioAccessInput>;
	/** Type for organization. */
	type?: InputMaybe<OrganizationTypeEnum>;
	/** flag to apply check for cms access. */
	viewerCmsAccess?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type UpdateOrganizationMutationPayload = {
	__typename?: 'UpdateOrganizationMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted organization. */
	organization?: Maybe<Organization>;
	success: Scalars['Boolean'];
};

/** Organization Server License input Arguments. */
export type UpdateOrganizationServerLicenseMutationInput = {
	/** calling license. */
	callingAccess?: InputMaybe<Scalars['Boolean']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** encryption key of the associated on-prem organization. */
	encryptionKey?: InputMaybe<Scalars['String']>;
	/** When the license expires. */
	expiresAt: Scalars['ISO8601DateTime'];
	/** OrganizationServerLicense id. */
	id: Scalars['ID'];
	/** author licenses. */
	licensesAllottedToAuthors?: InputMaybe<Scalars['Int']>;
	/** expert licenses. */
	licensesAllottedToExperts?: InputMaybe<Scalars['Int']>;
	/** tech+ licenses. */
	licensesAllottedToTechPluses?: InputMaybe<Scalars['Int']>;
	/** tech licenses. */
	licensesAllottedToTechs?: InputMaybe<Scalars['Int']>;
	/** viewer licenses. */
	licensesAllottedToViewers?: InputMaybe<Scalars['Int']>;
	/** name of the Organization Server License. */
	name: Scalars['String'];
	organizationServer: OrganizationServerLicenseUpsertInputObjectOrganizationServerInput;
	/** permalink of the associated on-prem organization. */
	permalink?: InputMaybe<Scalars['String']>;
	/** scenario access. */
	scenarioAccess?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type UpdateOrganizationServerLicenseMutationPayload = {
	__typename?: 'UpdateOrganizationServerLicenseMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The OrganizationServerLicense object. */
	organizationServerLicense?: Maybe<OrganizationServerLicense>;
	success: Scalars['Boolean'];
};

/** Organization Server input Arguments. */
export type UpdateOrganizationServerMutationInput = {
	/** server address. */
	address?: InputMaybe<Scalars['String']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** OrganizationServer id. */
	id: Scalars['ID'];
	/** the type of server. */
	installationType: OrganizationServerInstallationTypeEnum;
	/** the name of the server. */
	name: Scalars['String'];
};

/** An Object. */
export type UpdateOrganizationServerMutationPayload = {
	__typename?: 'UpdateOrganizationServerMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The OrganizationServer object. */
	organizationServer?: Maybe<OrganizationServer>;
	success: Scalars['Boolean'];
};

/** Organization SSO Details input Arguments. */
export type UpdateOrganizationSsoDetailMutationInput = {
	/** The full URL for the SSO provider. */
	baseUrl?: InputMaybe<Scalars['String']>;
	/** The Client ID generated by the SSO provider for authentication. */
	clientId?: InputMaybe<Scalars['String']>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The Client Secret generated by the SSO provider for authentication. */
	clientSecret?: InputMaybe<Scalars['String']>;
	config?: InputMaybe<OrganizationSsoDetailInputObjectConfigInput>;
	/** List of Organization SSO Domains. */
	domains?: InputMaybe<Array<OrganizationSsoDomainInputObject>>;
	/** Sso detail id to update SSO detail. */
	id: Scalars['ID'];
	/** The name for the SSO provider. */
	name?: InputMaybe<Scalars['String']>;
	/** The SSO provider used by the Organization. */
	providerName?: InputMaybe<SsoProviderEnum>;
	/** The Tenant ID of the Azure AD. */
	tenantId?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type UpdateOrganizationSsoDetailMutationPayload = {
	__typename?: 'UpdateOrganizationSsoDetailMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Resulted SSO detail. */
	organizationSsoDetail?: Maybe<OrganizationSsoDetail>;
	success: Scalars['Boolean'];
};

/** A project. */
export type UpdateProjectMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** The database id of the project used to find the project (if not using the GQL id). */
	databaseId?: InputMaybe<Scalars['String']>;
	/** the GQL id of the project used to find the project. */
	id?: InputMaybe<Scalars['String']>;
	/** The name of the project. When revision management is enabled, this will set the name of the revision group. */
	name?: InputMaybe<Scalars['String']>;
	/** Resource permissions that will replace the old ones. */
	replaceResourcePermissions?: InputMaybe<Array<NodeResourcePermissionInputObject>>;
	/** The name of the revision group. */
	revisionGroupName?: InputMaybe<Scalars['String']>;
	/** The name of the revision to be created. */
	revisionName?: InputMaybe<Scalars['String']>;
	/** Notes or comments associated with the revision. */
	revisionNotes?: InputMaybe<Scalars['String']>;
	/** The new state for the project. */
	state?: InputMaybe<ProjectStateEnum>;
};

/** An Object. */
export type UpdateProjectMutationPayload = {
	__typename?: 'UpdateProjectMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The updated project. */
	project?: Maybe<Project>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateProjectsMutation */
export type UpdateProjectsMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database Ids of projects to delete. */
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	/** Ids of projects to delete. */
	ids?: InputMaybe<Array<Scalars['ID']>>;
	/** A list of projects. */
	projects: Array<ProjectUpdateInputObject>;
	/** A boolean that will recover deleted projects. */
	recover?: InputMaybe<Scalars['Boolean']>;
};

/** An Object. */
export type UpdateProjectsMutationPayload = {
	__typename?: 'UpdateProjectsMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** A list of projects that were updated. */
	projects?: Maybe<Array<Project>>;
	/** Status of completed mutation. */
	success: Scalars['Boolean'];
};

/** Scenario catalog update arguments. */
export type UpdateScenarioCatalogMutationInput = {
	/** Scenairos to be add in catalog. */
	addedScenarios?: InputMaybe<Array<Scalars['ID']>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** String argument takes a id of external asset. */
	externalAssetId?: InputMaybe<Scalars['String']>;
	/** String argument takes a name of external asset. */
	externalAssetName?: InputMaybe<Scalars['String']>;
	/** Catalog id which need to be update. */
	id: Scalars['ID'];
	/** Catalog name. */
	name?: InputMaybe<Scalars['String']>;
	/** Boolean argument decide to make catalog public to all user or not. */
	public?: InputMaybe<Scalars['Boolean']>;
	/** Scenarios to be removed from catalog. */
	removedScenarios?: InputMaybe<Array<Scalars['ID']>>;
};

/** An Object. */
export type UpdateScenarioCatalogMutationPayload = {
	__typename?: 'UpdateScenarioCatalogMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** scenario catalog instance. */
	scenarioCatalog?: Maybe<ScenarioCatalog>;
	success: Scalars['Boolean'];
};

/** Scenario update arguments. */
export type UpdateScenarioMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Scenario database id. */
	databaseId?: InputMaybe<Scalars['Int']>;
	/** Scenario id. */
	id?: InputMaybe<Scalars['String']>;
	/** Resource permissions that will replace the old ones. */
	replaceResourcePermissions?: InputMaybe<Array<NodeResourcePermissionInputObject>>;
	/** groups requested for scenario. */
	requestedGroups?: InputMaybe<Array<Scalars['ID']>>;
	/** origin group requested for scenario. */
	requestedOriginGroup?: InputMaybe<Scalars['ID']>;
	scenario?: InputMaybe<ScenarioUpdateInputObjectScenarioInput>;
	scenarioRelease?: InputMaybe<ScenarioUpdateInputObjectScenarioReleaseInput>;
	/** Scope file binary for direct upload. */
	scopeFile?: InputMaybe<Scalars['Upload']>;
	/** ID of S3 uploaded scope file. */
	uploadId?: InputMaybe<Scalars['Int']>;
};

/** An Object. */
export type UpdateScenarioMutationPayload = {
	__typename?: 'UpdateScenarioMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Scenario object updated or created. */
	scenario?: Maybe<Scenario>;
	success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateScenariosMutation */
export type UpdateScenariosMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of scenario input objects. */
	scenarios: Array<ScenarioUpdateInputObject>;
};

/** An Object. */
export type UpdateScenariosMutationPayload = {
	__typename?: 'UpdateScenariosMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** Scenarios with attributes regardless if mutation is successful. */
	scenarios?: Maybe<Array<Scenario>>;
	success: Scalars['Boolean'];
};

/** Input object for updating a user. */
export type UpdateUserMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Database ID for user to lookup. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** User id. */
	id?: InputMaybe<Scalars['ID']>;
	/** List of Groups the user is requesting to join. */
	requestedGroups?: InputMaybe<Array<Scalars['String']>>;
	/** List of Licenses the user is requesting. */
	requestedLicenses?: InputMaybe<Array<LicenseTypeEnum>>;
	/** Extra configuration options for the Licenses requested by the user. */
	requestedLicensesExtraData?: InputMaybe<Array<LicenseExtraDataInputObject>>;
	/** origin group requested for user. */
	requestedOriginGroup?: InputMaybe<Scalars['String']>;
	/** Fields for user to be created. */
	user?: InputMaybe<UserUpdateInputObjectUserInput>;
	/** Username for user to lookup. */
	username?: InputMaybe<Scalars['String']>;
};

/** An Object. */
export type UpdateUserMutationPayload = {
	__typename?: 'UpdateUserMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
	/** User with attributes regardless if mutation is successful. */
	user?: Maybe<User>;
};

/** Autogenerated input type of UpdateUsersMutation */
export type UpdateUsersMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** List of users input objects. */
	users: Array<UserUpdateInputObject>;
};

/** An Object. */
export type UpdateUsersMutationPayload = {
	__typename?: 'UpdateUsersMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
	/** Users with attributes regardless if mutation is successful. */
	users?: Maybe<Array<User>>;
};

/** WebhookSubscription upsert arguments. */
export type UpdateWebhookSubscriptionMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	/** Id for the WebhookSubscription. */
	id?: InputMaybe<Scalars['ID']>;
	/** Set this to true and it will test the webhook request in the transaction. */
	testWebhook?: InputMaybe<Scalars['Boolean']>;
	webhookSubscription: WebhookSubscriptionUpsertInputObjectWebhookSubscriptionInput;
};

/** An Object. */
export type UpdateWebhookSubscriptionMutationPayload = {
	__typename?: 'UpdateWebhookSubscriptionMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	success: Scalars['Boolean'];
	/** The WebhookSubscription modified by the mutation. */
	webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Autogenerated input type of UpsertReviewUserSelectionMutation */
export type UpsertReviewUserSelectionMutationInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']>;
	review: UpsertReviewUserSelectionMutationReviewInput;
	reviewable: UpsertReviewUserSelectionMutationReviewableInput;
	/** Selections to replace the current user selections for the review page. */
	userSelections?: InputMaybe<Array<UserSelectionInputObject>>;
};

/** An Object. */
export type UpsertReviewUserSelectionMutationPayload = {
	__typename?: 'UpsertReviewUserSelectionMutationPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']>;
	errors: Array<Error>;
	/** The review object along with the reviewable properties. */
	review?: Maybe<ReviewReviewable>;
	success: Scalars['Boolean'];
	/** The selections that are not stored for the user for that page. */
	userSelections?: Maybe<Array<ReviewReviewableUserSelection>>;
};

/** Autogenerated nested input type of UpsertReviewUserSelectionMutation */
export type UpsertReviewUserSelectionMutationReviewInput = {
	/** Unique identifier to the review. Used to look up the review. */
	key: Scalars['String'];
	/** Id to be used to look up the page of the review to associate the user selections. */
	pageId: Scalars['ID'];
};

/** Autogenerated nested input type of UpsertReviewUserSelectionMutation */
export type UpsertReviewUserSelectionMutationReviewableInput = {
	/** Database ID of the reviewable object record. This will change if the data is migrated. */
	databaseId?: InputMaybe<Scalars['ID']>;
	/** Global ID of the reviewable object record. This should be persistent if data is migrated and is recommended to use. */
	id?: InputMaybe<Scalars['ID']>;
	/** The class name of the reviewable object. */
	type?: InputMaybe<Scalars['String']>;
};

/** Represents an individual person's account. */
export type User = NodeInterface & {
	__typename?: 'User';
	/** The active/Inactive status. */
	active?: Maybe<Scalars['Boolean']>;
	/** The list of assets in the User's library. */
	assets?: Maybe<UserAssetConnection>;
	/**
   * A list of Attachments associated with the User.
   * @deprecated Not yet implemented.
   */
	attachments?: Maybe<UserAttachmentConnection>;
	/** The avatar associated with the User. */
	avatar?: Maybe<ImageAttachment>;
	/**
   * A list of tech Calls associated with the User.
   * @deprecated Not yet implemented.
   */
	calls?: Maybe<UserCallConnection>;
	/** The date and time when the confirmation email associated with the User was last sent . */
	confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the User last confirmed their email. */
	confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the User last signed in. */
	currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The IP of the User when they last signed in. */
	currentSignInIp?: Maybe<Scalars['String']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Link to the User to create call session with that user. */
	deferredLink?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The email of the User. */
	email?: Maybe<Scalars['String']>;
	/** A unique encryption key for the user. */
	encryptionKey?: Maybe<Scalars['String']>;
	/** A list of EulaPrompts associated with the User. */
	eulaPrompts?: Maybe<UserEulaPromptConnection>;
	/** The number of times this User has attempted and failed to sign in. */
	failedSignInAttempts?: Maybe<Scalars['Int']>;
	/** The first name of the User. */
	firstName?: Maybe<Scalars['String']>;
	/** Whether to force password reset of the User when they sign in next. */
	forcePasswordReset?: Maybe<Scalars['Boolean']>;
	/** The formatted phone number of the User. */
	formattedPhone?: Maybe<Scalars['String']>;
	/** A list of Groups associated with the User. */
	groups?: Maybe<UserGroupConnection>;
	/** Whether the user is a Guest. */
	guest?: Maybe<Scalars['Boolean']>;
	/** Boolean value to determine if the user is allowed to access the cms. */
	hasCmsAccess?: Maybe<Scalars['Boolean']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The initials of the user based on their first name and last name. */
	initials?: Maybe<Scalars['String']>;
	/** A list of Invitations associated with the User. */
	invitations?: Maybe<UserInvitationConnection>;
	/** The job title of the User. */
	jobTitle?: Maybe<Scalars['String']>;
	/** The last name of the User. */
	lastName?: Maybe<Scalars['String']>;
	/** A list of Licenses associated with the User. */
	licenses?: Maybe<UserLicenseConnection>;
	/** The location of the user. */
	location?: Maybe<Scalars['String']>;
	/** The date and time when sign in was disabled for the User. */
	lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** List of model processing jobs associated with the user. */
	modelProcessJobs?: Maybe<UserModelProcessJobConnection>;
	/** The full name of the User. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the User. */
	organization?: Maybe<Organization>;
	/** User's origin group. */
	originGroup?: Maybe<Group>;
	/** The date and time when the User last received a password reset email. */
	passwordResetSentAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** The permalink for the user. */
	permalink?: Maybe<Scalars['String']>;
	/** A list of Permissions associated with the currently authenticated User and the User. */
	permissions: UserPermissions;
	/** The phone number of the User. */
	phone?: Maybe<Scalars['String']>;
	/** Link to the QR code image. */
	qrCodeImageLink?: Maybe<Scalars['String']>;
	/** A list of ScenarioReleases associated with the User. */
	scenarioReleases?: Maybe<UserScenarioReleaseConnection>;
	/**
   * A list of ScenarioSessions associated with the User.
   * @deprecated Not yet implemented.
   */
	scenarioSessions?: Maybe<UserScenarioSessionConnection>;
	/** A list of Scenarios associated with the User. */
	scenarios?: Maybe<UserScenarioConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/**
   * A list of SharedAttachments associated with the User.
   * @deprecated Not yet implemented.
   */
	sharedAttachments?: Maybe<UserSharedAttachmentConnection>;
	/** The shortcode of the User. */
	shortcode?: Maybe<Scalars['String']>;
	/** The number of times the User has signed in. */
	signInCount?: Maybe<Scalars['Int']>;
	/** ID of the SsoDetail associated with the User. */
	ssoDetailId?: Maybe<Scalars['ID']>;
	/**
   * The provider of the User.
   * @deprecated Not yet implemented.
   */
	ssoProvider?: Maybe<SsoProviderEnum>;
	/** The unique identifier for the user in the SSO provider. */
	ssoUid?: Maybe<Scalars['ID']>;
	/**
   * The state of the User.
   * 
   * The default value is "PENDING".
   * @deprecated Not yet implemented.
   */
	state?: Maybe<UserStateEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The username of the User. */
	username?: Maybe<Scalars['String']>;
	/** A list of WebhookSubscriptions associated with the User. */
	webhookSubscriptions?: Maybe<UserWebhookSubscriptionConnection>;
	/** User's WorkLink Create profile settings. */
	wlcProfileSettings?: Maybe<UserWlcProfileSettings>;
};


/** Represents an individual person's account. */
export type UserAssetsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	folderDatabaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	folderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	inRootFolder?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	notInLatestVersions?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	ownerId?: InputMaybe<Scalars['ID']>;
	types?: InputMaybe<Array<AssetTypeEnum>>;
};


/** Represents an individual person's account. */
export type UserAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserCallsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserEulaPromptsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserInvitationsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserLicensesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserModelProcessJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assetDatabaseId?: InputMaybe<Scalars['String']>;
	assetId?: InputMaybe<Scalars['ID']>;
	baseRevisionDatabaseId?: InputMaybe<Scalars['String']>;
	baseRevisionId?: InputMaybe<Scalars['ID']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ModelProcessJobStatusEnum>>;
	queuedAt?: InputMaybe<DateRangeInputObject>;
};


/** Represents an individual person's account. */
export type UserScenarioReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents an individual person's account. */
export type UserScenarioSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** Represents an individual person's account. */
export type UserSharedAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual person's account. */
export type UserWebhookSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type UserAssetConnection = {
	__typename?: 'UserAssetConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserAssetEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Asset>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserAssetConnection. */
	permissions: UserAssetConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserAssetConnectionPermissions = {
	__typename?: 'UserAssetConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserAssetEdge = {
	__typename?: 'UserAssetEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Asset>;
};

/** The connection type for Attachment. */
export type UserAttachmentConnection = {
	__typename?: 'UserAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Attachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserAttachmentEdge = {
	__typename?: 'UserAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Attachment>;
};

/** A connection from a Node. */
export type UserCallConnection = {
	__typename?: 'UserCallConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserCallEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Call>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserCallConnection. */
	permissions: UserCallConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserCallConnectionPermissions = {
	__typename?: 'UserCallConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserCallEdge = {
	__typename?: 'UserCallEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Call>;
};

/** Autogenerated nested input type of UserCreateInputObject */
export type UserCreateInputObjectUserInput = {
	credentials?: InputMaybe<UserCreateInputObjectUserInputCredentialsInput>;
	/** Email for user. */
	email: Scalars['String'];
	/** First name for user. */
	firstName: Scalars['String'];
	/** Job title for user. */
	jobTitle?: InputMaybe<Scalars['String']>;
	/** Last name for user. */
	lastName: Scalars['String'];
	/** Location of the user. */
	location?: InputMaybe<Scalars['String']>;
	/** Password for user. */
	password?: InputMaybe<Scalars['String']>;
	/** Phone number for user. */
	phone?: InputMaybe<Scalars['String']>;
	/** The unique identifier for the user in the SSO provider. */
	ssoUid?: InputMaybe<Scalars['String']>;
	/** Username for user. */
	username?: InputMaybe<Scalars['String']>;
};

/** Autogenerated nested input type of UserCreateInputObjectUserInput */
export type UserCreateInputObjectUserInputCredentialsInput = {
	/** Password for user (deprecated). */
	password: Scalars['String'];
	/** Username for user (deprecated). */
	username: Scalars['String'];
};

/** A connection from a Node. */
export type UserEulaPromptConnection = {
	__typename?: 'UserEulaPromptConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserEulaPromptEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<EulaPrompt>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserEulaPromptConnection. */
	permissions: UserEulaPromptConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserEulaPromptConnectionPermissions = {
	__typename?: 'UserEulaPromptConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserEulaPromptEdge = {
	__typename?: 'UserEulaPromptEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<EulaPrompt>;
};

/** A connection from a Node. */
export type UserGroupConnection = {
	__typename?: 'UserGroupConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserGroupEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Group>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserGroupConnection. */
	permissions: UserGroupConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserGroupConnectionPermissions = {
	__typename?: 'UserGroupConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserGroupEdge = {
	__typename?: 'UserGroupEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Group>;
};

/** A connection from a Node. */
export type UserInvitationConnection = {
	__typename?: 'UserInvitationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserInvitationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Invitation>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserInvitationConnection. */
	permissions: UserInvitationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserInvitationConnectionPermissions = {
	__typename?: 'UserInvitationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserInvitationEdge = {
	__typename?: 'UserInvitationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Invitation>;
};

/** A connection from a Node. */
export type UserLicenseConnection = {
	__typename?: 'UserLicenseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserLicenseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<License>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserLicenseConnection. */
	permissions: UserLicenseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserLicenseConnectionPermissions = {
	__typename?: 'UserLicenseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserLicenseEdge = {
	__typename?: 'UserLicenseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<License>;
};

/** A connection from a Node. */
export type UserModelProcessJobConnection = {
	__typename?: 'UserModelProcessJobConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserModelProcessJobEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ModelProcessJob>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserModelProcessJobConnection. */
	permissions: UserModelProcessJobConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserModelProcessJobConnectionPermissions = {
	__typename?: 'UserModelProcessJobConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserModelProcessJobEdge = {
	__typename?: 'UserModelProcessJobEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ModelProcessJob>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type UserPermissions = {
	__typename?: 'UserPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated user can perform update operations on password field of the parent Node. */
	canUpdatePassword: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type UserScenarioConnection = {
	__typename?: 'UserScenarioConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserScenarioEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Scenario>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserScenarioConnection. */
	permissions: UserScenarioConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserScenarioConnectionPermissions = {
	__typename?: 'UserScenarioConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserScenarioEdge = {
	__typename?: 'UserScenarioEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Scenario>;
};

/** A connection from a Node. */
export type UserScenarioReleaseConnection = {
	__typename?: 'UserScenarioReleaseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserScenarioReleaseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioRelease>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserScenarioReleaseConnection. */
	permissions: UserScenarioReleaseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserScenarioReleaseConnectionPermissions = {
	__typename?: 'UserScenarioReleaseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserScenarioReleaseEdge = {
	__typename?: 'UserScenarioReleaseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioRelease>;
};

/** A connection from a Node. */
export type UserScenarioSessionConnection = {
	__typename?: 'UserScenarioSessionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserScenarioSessionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<ScenarioSession>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserScenarioSessionConnection. */
	permissions: UserScenarioSessionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserScenarioSessionConnectionPermissions = {
	__typename?: 'UserScenarioSessionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserScenarioSessionEdge = {
	__typename?: 'UserScenarioSessionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<ScenarioSession>;
};

/** Represents the user selection of an option of a review prompt. */
export type UserSelectionInputObject = {
	/** The database id of the review option. Can change with a data migraiton. */
	reviewOptionId: Scalars['ID'];
	/** The addendum value of a user selection. */
	value?: InputMaybe<Scalars['String']>;
};

/** A connection from a Node. */
export type UserSharedAttachmentConnection = {
	__typename?: 'UserSharedAttachmentConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserSharedAttachmentEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<SharedAttachment>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserSharedAttachmentConnection. */
	permissions: UserSharedAttachmentConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserSharedAttachmentConnectionPermissions = {
	__typename?: 'UserSharedAttachmentConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserSharedAttachmentEdge = {
	__typename?: 'UserSharedAttachmentEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<SharedAttachment>;
};

export enum UserStateEnum {
	/** A User that is active. */
	Active = 'ACTIVE',
	/** A User that has yet to sign in. */
	Pending = 'PENDING',
	/** A User that has been suspended. */
	Suspended = 'SUSPENDED'
}

/** Input object for updating a user. */
export type UserUpdateInputObject = {
	/** Database ID for user to lookup. */
	databaseId?: InputMaybe<Scalars['String']>;
	/** User id. */
	id?: InputMaybe<Scalars['ID']>;
	/** List of Groups the user is requesting to join. */
	requestedGroups?: InputMaybe<Array<Scalars['String']>>;
	/** List of Licenses the user is requesting. */
	requestedLicenses?: InputMaybe<Array<LicenseTypeEnum>>;
	/** Extra configuration options for the Licenses requested by the user. */
	requestedLicensesExtraData?: InputMaybe<Array<LicenseExtraDataInputObject>>;
	/** origin group requested for user. */
	requestedOriginGroup?: InputMaybe<Scalars['String']>;
	/** Fields for user to be created. */
	user?: InputMaybe<UserUpdateInputObjectUserInput>;
	/** Username for user to lookup. */
	username?: InputMaybe<Scalars['String']>;
};

/** Autogenerated nested input type of UserUpdateInputObject */
export type UserUpdateInputObjectUserInput = {
	/** New avatar image for the user. */
	avatar?: InputMaybe<Scalars['Upload']>;
	companyUserFeatures?: InputMaybe<UserUpdateInputObjectUserInputCompanyUserFeaturesInput>;
	/** In order to change the password of a user, the current password must also be provided. */
	currentPassword?: InputMaybe<Scalars['String']>;
	/** New email for user. */
	email?: InputMaybe<Scalars['String']>;
	/** New first name for user. */
	firstName?: InputMaybe<Scalars['String']>;
	/** New job title for user. */
	jobTitle?: InputMaybe<Scalars['String']>;
	/** New last name for user. */
	lastName?: InputMaybe<Scalars['String']>;
	/** New location for the user. */
	location?: InputMaybe<Scalars['String']>;
	/** New password for the user. */
	password?: InputMaybe<Scalars['String']>;
	/** Confirm the new password for the user. */
	passwordConfirmation?: InputMaybe<Scalars['String']>;
	/** New phone number for user. */
	phone?: InputMaybe<Scalars['String']>;
	/** ID of the SsoDetail directly associated with the User. */
	ssoDetailId?: InputMaybe<Scalars['ID']>;
	/** The unique identifier for the user in the SSO provider. */
	ssoUid?: InputMaybe<Scalars['String']>;
	/** Boolean to determine whether the user is a super admin. Only another super admin can modify this. */
	superAdmin?: InputMaybe<Scalars['Boolean']>;
	/** New username for the user. */
	username?: InputMaybe<Scalars['String']>;
	/** User's WorkLink Create profile settings update input. */
	wlcProfileSettings?: InputMaybe<UserUpdateInputObjectUserInputWlcProfileSettingsInput>;
};

/** Autogenerated nested input type of UserUpdateInputObjectUserInput */
export type UserUpdateInputObjectUserInputCompanyUserFeaturesInput = {
	/** Boolean value to determine whether the feature is on or off for that user. Admin only. */
	enabled: Scalars['Boolean'];
	/** The id of the company user feature to associate to the user. Admin only. */
	id: Scalars['String'];
};

/** Autogenerated nested input type of UserUpdateInputObjectUserInput */
export type UserUpdateInputObjectUserInputWlcProfileSettingsInput = {
	/** Version of the End User License Agreement (EULA) the user has confirmed. */
	eulaVersionConfirmed?: InputMaybe<Scalars['String']>;
	/** Timestamp of the user's last login to WorkLink Create. */
	lastLogin?: InputMaybe<Scalars['ISO8601DateTime']>;
	/** List of projects the user has seen in WorkLink Create. */
	projectListSeen?: InputMaybe<Scalars['JSON']>;
	/** Version of the WorkLink Create release notes last seen by the user. */
	releaseNotesVersionSeen?: InputMaybe<Scalars['String']>;
	/** User-specific WorkLink Create settings. */
	wlcSettings?: InputMaybe<Scalars['JSON']>;
};

/** A connection from a Node. */
export type UserWebhookSubscriptionConnection = {
	__typename?: 'UserWebhookSubscriptionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<UserWebhookSubscriptionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookSubscription>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the UserWebhookSubscriptionConnection. */
	permissions: UserWebhookSubscriptionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type UserWebhookSubscriptionConnectionPermissions = {
	__typename?: 'UserWebhookSubscriptionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type UserWebhookSubscriptionEdge = {
	__typename?: 'UserWebhookSubscriptionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookSubscription>;
};

/** An Object. */
export type UserWlcProfileSettings = {
	__typename?: 'UserWlcProfileSettings';
	/** Version of the End User License Agreement (EULA) that the user has confirmed. */
	eulaVersionConfirmed?: Maybe<Scalars['String']>;
	/** The ID of the user's WorkLink Create profile. */
	id?: Maybe<Scalars['String']>;
	/** Timestamp of the user's User's last login to WorkLink Create. */
	lastLogin?: Maybe<Scalars['ISO8601DateTime']>;
	/** List of projects the user has seen in WorkLink Create. */
	projectListSeen?: Maybe<Scalars['JSON']>;
	/** Version of the User's WorkLink Create release notes last seen by the user. */
	releaseNotesVersionSeen?: Maybe<Scalars['String']>;
	/** WLC server options, including available upload extensions and CAD optimization operations. */
	serverOptions?: Maybe<Scalars['JSON']>;
	/** User-specific WorkLink Create settings. */
	wlcSettings?: Maybe<Scalars['JSON']>;
};

/** Represents a currently authenticated User. */
export type Viewer = NodeInterface & {
	__typename?: 'Viewer';
	/** The active/Inactive status. */
	active?: Maybe<Scalars['Boolean']>;
	/** The list of assets in the User's library. */
	assets?: Maybe<UserAssetConnection>;
	/**
   * A list of Attachments associated with the User.
   * @deprecated Not yet implemented.
   */
	attachments?: Maybe<UserAttachmentConnection>;
	/** The avatar associated with the User. */
	avatar?: Maybe<ImageAttachment>;
	/**
   * A list of tech Calls associated with the User.
   * @deprecated Not yet implemented.
   */
	calls?: Maybe<UserCallConnection>;
	/** The date and time when the confirmation email associated with the User was last sent . */
	confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the User last confirmed their email. */
	confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The Organization associated with the Viewer. */
	currentOrganization?: Maybe<Organization>;
	/** The date and time when the User last signed in. */
	currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The IP of the User when they last signed in. */
	currentSignInIp?: Maybe<Scalars['String']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Link to the User to create call session with that user. */
	deferredLink?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The email of the User. */
	email?: Maybe<Scalars['String']>;
	/** A unique encryption key for the user. */
	encryptionKey?: Maybe<Scalars['String']>;
	/** A list of EulaPrompts associated with the User. */
	eulaPrompts?: Maybe<UserEulaPromptConnection>;
	/** The number of times this User has attempted and failed to sign in. */
	failedSignInAttempts?: Maybe<Scalars['Int']>;
	/** The first name of the User. */
	firstName?: Maybe<Scalars['String']>;
	/** Whether to force password reset of the User when they sign in next. */
	forcePasswordReset?: Maybe<Scalars['Boolean']>;
	/** The formatted phone number of the User. */
	formattedPhone?: Maybe<Scalars['String']>;
	/** A list of Groups associated with the User. */
	groups?: Maybe<UserGroupConnection>;
	/** Whether the user is a Guest. */
	guest?: Maybe<Scalars['Boolean']>;
	/** Boolean value to determine if the user is allowed to access the cms. */
	hasCmsAccess?: Maybe<Scalars['Boolean']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The initials of the user based on their first name and last name. */
	initials?: Maybe<Scalars['String']>;
	/** A list of Invitations associated with the User. */
	invitations?: Maybe<UserInvitationConnection>;
	/** The job title of the User. */
	jobTitle?: Maybe<Scalars['String']>;
	/** The last name of the User. */
	lastName?: Maybe<Scalars['String']>;
	/** A list of Licenses associated with the User. */
	licenses?: Maybe<ViewerLicenseConnection>;
	/** The location of the user. */
	location?: Maybe<Scalars['String']>;
	/** The date and time when sign in was disabled for the User. */
	lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** List of model processing jobs associated with the user. */
	modelProcessJobs?: Maybe<UserModelProcessJobConnection>;
	/** The full name of the User. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the User. */
	organization?: Maybe<Organization>;
	/** A list of Organizations associated with the currently authenticated User. */
	organizations?: Maybe<ViewerOrganizationConnection>;
	/** User's origin group. */
	originGroup?: Maybe<Group>;
	/** The date and time when the User last received a password reset email. */
	passwordResetSentAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** The permalink for the user. */
	permalink?: Maybe<Scalars['String']>;
	/** A list of Permissions associated with the currently authenticated User and the Viewer. */
	permissions: ViewerPermissions;
	/** The phone number of the User. */
	phone?: Maybe<Scalars['String']>;
	/** Link to the QR code image. */
	qrCodeImageLink?: Maybe<Scalars['String']>;
	/** A list of ScenarioReleases associated with the User. */
	scenarioReleases?: Maybe<UserScenarioReleaseConnection>;
	/**
   * A list of ScenarioSessions associated with the User.
   * @deprecated Not yet implemented.
   */
	scenarioSessions?: Maybe<UserScenarioSessionConnection>;
	/** A list of Scenarios associated with the User. */
	scenarios?: Maybe<ViewerScenarioConnection>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/**
   * A list of SharedAttachments associated with the User.
   * @deprecated Not yet implemented.
   */
	sharedAttachments?: Maybe<UserSharedAttachmentConnection>;
	/** The shortcode of the User. */
	shortcode?: Maybe<Scalars['String']>;
	/** The number of times the User has signed in. */
	signInCount?: Maybe<Scalars['Int']>;
	/** ID of the SsoDetail associated with the User. */
	ssoDetailId?: Maybe<Scalars['ID']>;
	/**
   * The provider of the User.
   * @deprecated Not yet implemented.
   */
	ssoProvider?: Maybe<SsoProviderEnum>;
	/** The unique identifier for the user in the SSO provider. */
	ssoUid?: Maybe<Scalars['ID']>;
	/**
   * The state of the User.
   * 
   * The default value is "PENDING".
   * @deprecated Not yet implemented.
   */
	state?: Maybe<UserStateEnum>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The username of the User. */
	username?: Maybe<Scalars['String']>;
	/** A list of WebhookSubscriptions associated with the User. */
	webhookSubscriptions?: Maybe<UserWebhookSubscriptionConnection>;
	/** User's WorkLink Create profile settings. */
	wlcProfileSettings?: Maybe<UserWlcProfileSettings>;
};


/** Represents a currently authenticated User. */
export type ViewerAssetsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	deleted?: InputMaybe<Scalars['Boolean']>;
	first?: InputMaybe<Scalars['Int']>;
	folderDatabaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	folderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	inRootFolder?: InputMaybe<Scalars['Boolean']>;
	last?: InputMaybe<Scalars['Int']>;
	notInLatestVersions?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	ownerId?: InputMaybe<Scalars['ID']>;
	types?: InputMaybe<Array<AssetTypeEnum>>;
};


/** Represents a currently authenticated User. */
export type ViewerAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerCallsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerEulaPromptsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerGroupsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerInvitationsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerLicensesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerModelProcessJobsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	assetDatabaseId?: InputMaybe<Scalars['String']>;
	assetId?: InputMaybe<Scalars['ID']>;
	baseRevisionDatabaseId?: InputMaybe<Scalars['String']>;
	baseRevisionId?: InputMaybe<Scalars['ID']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	createdByIds?: InputMaybe<Array<Scalars['ID']>>;
	databaseIds?: InputMaybe<Array<Scalars['String']>>;
	first?: InputMaybe<Scalars['Int']>;
	ids?: InputMaybe<Array<Scalars['ID']>>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	processStatus?: InputMaybe<Array<ModelProcessJobStatusEnum>>;
	queuedAt?: InputMaybe<DateRangeInputObject>;
};


/** Represents a currently authenticated User. */
export type ViewerOrganizationsArgs = {
	accessTypes?: InputMaybe<Array<OrganizationAccessTypeEnum>>;
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	onPrem?: InputMaybe<Scalars['Boolean']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	status?: InputMaybe<OrganizationStatusEnum>;
	types?: InputMaybe<Array<OrganizationTypeEnum>>;
};


/** Represents a currently authenticated User. */
export type ViewerScenarioReleasesArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	fullText?: InputMaybe<Scalars['String']>;
	last?: InputMaybe<Scalars['Int']>;
	orderBy?: InputMaybe<SortOrderInputObject>;
	publishedAt?: InputMaybe<DateRangeInputObject>;
	scenarioId?: InputMaybe<Scalars['ID']>;
	workInstructionTypes?: InputMaybe<Array<ScenarioReleaseWorkInstructionTypeEnum>>;
};


/** Represents a currently authenticated User. */
export type ViewerScenarioSessionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerScenariosArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
	scenariosQueryArguments?: InputMaybe<ScenariosQueryInputObject>;
};


/** Represents a currently authenticated User. */
export type ViewerSharedAttachmentsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};


/** Represents a currently authenticated User. */
export type ViewerWebhookSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A connection from a Node. */
export type ViewerLicenseConnection = {
	__typename?: 'ViewerLicenseConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ViewerLicenseEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<License>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ViewerLicenseConnection. */
	permissions: ViewerLicenseConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ViewerLicenseConnectionPermissions = {
	__typename?: 'ViewerLicenseConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ViewerLicenseEdge = {
	__typename?: 'ViewerLicenseEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<License>;
};

/** A connection from a Node. */
export type ViewerOrganizationConnection = {
	__typename?: 'ViewerOrganizationConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ViewerOrganizationEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Organization>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ViewerOrganizationConnection. */
	permissions: ViewerOrganizationConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ViewerOrganizationConnectionPermissions = {
	__typename?: 'ViewerOrganizationConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
	/** Whether the currently authenticated user can manage ALL companies. */
	canManage: AuthorizationResult;
};

/** An edge in a connection. */
export type ViewerOrganizationEdge = {
	__typename?: 'ViewerOrganizationEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Organization>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type ViewerPermissions = {
	__typename?: 'ViewerPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type ViewerScenarioConnection = {
	__typename?: 'ViewerScenarioConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ViewerScenarioEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Scenario>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the ViewerScenarioConnection. */
	permissions: ViewerScenarioConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type ViewerScenarioConnectionPermissions = {
	__typename?: 'ViewerScenarioConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type ViewerScenarioEdge = {
	__typename?: 'ViewerScenarioEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<Scenario>;
};

/** A Node in the graph. */
export type WebhookError = NodeInterface & {
	__typename?: 'WebhookError';
	/** The datetime the error was added. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The datetime of the last occurrence of an error. */
	lastOccurrenceAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Full error message. */
	message?: Maybe<Scalars['String']>;
	/** Brief description of the error. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The number of times an error with a given name has occurred. */
	occurrences?: Maybe<Scalars['Int']>;
	/** The Organization the associated Webhook Subscription belongs to. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the WebhookError. */
	permissions: WebhookErrorPermissions;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** List of method calls that the application was in the middle of when an Exception was thrown. */
	stackTrace?: Maybe<Array<Scalars['String']>>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The Webhook Subscription that generated the error. */
	webhookSubscription?: Maybe<WebhookSubscription>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type WebhookErrorPermissions = {
	__typename?: 'WebhookErrorPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type WebhookRequest = NodeInterface & {
	__typename?: 'WebhookRequest';
	/** The date and time the WebhookRequest was executed. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Result of the associated WebhookSubscription's validation template. */
	dataValidationTemplateResult?: Maybe<Scalars['Boolean']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Result of the associated WebhookSubscription's error handing template. */
	errorHandlingTemplateResult?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The name of the WebhookRequest. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** An object including ID and type of the node that triggered the WebhookRequest. */
	node?: Maybe<Scalars['JSON']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the WebhookRequest. */
	permissions: WebhookRequestPermissions;
	/** Response to the GQL query defined in the associated WebhookSubscription. */
	queryResponse?: Maybe<Scalars['JSON']>;
	/** Result of the associated WebhookSubscription's query template. */
	queryTemplateResult?: Maybe<Scalars['JSON']>;
	/** Response of the HTTP request triggered by the WebhookRequest. */
	response?: Maybe<Scalars['JSON']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** A boolean indicating whether the request was successful or not. */
	success?: Maybe<Scalars['Boolean']>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type WebhookRequestPermissions = {
	__typename?: 'WebhookRequestPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A Node in the graph. */
export type WebhookSubscription = NodeInterface & {
	__typename?: 'WebhookSubscription';
	/** The callback_url of the WebhookSubscription. */
	callbackUrl?: Maybe<Scalars['String']>;
	/** The content type of the webhook request. Defaults to json. */
	contentType?: Maybe<WebhookSubscriptionContentTypeEnum>;
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Liquid template used to validate the webhook triggering. */
	dataValidationTemplate?: Maybe<Scalars['String']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the WebhookSubscription what last disabled (if disabled). */
	disabledAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The reason given when the WebhookSubscription was disabled (if disabled). */
	disabledReason?: Maybe<Scalars['String']>;
	/** Liquid template used to handle errors in the webhook reponse. */
	errorHandlingTemplate?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** Integration associated with the WebhookSubscription. */
	integration?: Maybe<Integration>;
	/** Name for the webhook subscription for easy identification. */
	name?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The Organization associated with the WebhookSubscription. */
	organization?: Maybe<Organization>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the WebhookSubscription. */
	permissions: WebhookSubscriptionPermissions;
	/** The graphql query to be executed whenever Webhooks are triggered for this WebhookSubscription. */
	query?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** Public secret for the WebhookSubscription. */
	sharedSecret?: Maybe<Scalars['String']>;
	/** Liquid template that can be used to customize the returned JSON data. */
	template?: Maybe<Scalars['String']>;
	/** The WebhookTopic associated with the WebhookSubscription. */
	topic?: Maybe<WebhookTopic>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The User associated with the WebhookSubscription. */
	user?: Maybe<User>;
	/** List of Webhook Errors generated by the WebhookSubscription. */
	webhookErrors?: Maybe<WebhookSubscriptionWebhookErrorConnection>;
};


/** A Node in the graph. */
export type WebhookSubscriptionWebhookErrorsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

export enum WebhookSubscriptionContentTypeEnum {
	/** JSON content type. Default if content type is not provided. */
	Json = 'JSON',
	/** Url encoded content type. All params will be passed through the query params. */
	UrlEncoded = 'URL_ENCODED',
	/** XML content type. */
	Xml = 'XML'
}

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type WebhookSubscriptionPermissions = {
	__typename?: 'WebhookSubscriptionPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** Autogenerated nested input type of WebhookSubscriptionUpsertInputObject */
export type WebhookSubscriptionUpsertInputObjectWebhookSubscriptionInput = {
	/** URL for the WebhookSubscription. */
	callbackUrl: Scalars['String'];
	/** Content type of the webhook request. Defaults to json. */
	contentType?: InputMaybe<WebhookSubscriptionContentTypeEnum>;
	/** String for the Liquid template used to validate the webhook triggering. */
	dataValidationTemplate?: InputMaybe<Scalars['String']>;
	/** Disabled state for the WebhookSubscription. */
	disabled?: InputMaybe<Scalars['Boolean']>;
	/** The reason for disabling the WebhookSubscription. */
	disabledReason?: InputMaybe<Scalars['String']>;
	/** String for the Liquid template used to handle errors in the webhook reponse. */
	errorHandlingTemplate?: InputMaybe<Scalars['String']>;
	/** The ID of the WebhookSubscription. */
	id?: InputMaybe<Scalars['ID']>;
	/** The ID for the integration to connect the Webhook to. */
	integrationId?: InputMaybe<Scalars['ID']>;
	/** Name for the webhook subscription for easy identification. */
	name?: InputMaybe<Scalars['String']>;
	/** GraphQL query for the WebhookSubscription. */
	query?: InputMaybe<Scalars['String']>;
	/** Public secret for the WebhookSubscription. */
	sharedSecret?: InputMaybe<Scalars['String']>;
	/** String for the Liquid template used to customize the JSON data. */
	template?: InputMaybe<Scalars['String']>;
	/** WebhookTopic arguments for the WebhookSubscription. */
	topic: WebhookSubscriptionUpsertInputObjectWebhookSubscriptionInputTopicInput;
};

/** Autogenerated nested input type of WebhookSubscriptionUpsertInputObjectWebhookSubscriptionInput */
export type WebhookSubscriptionUpsertInputObjectWebhookSubscriptionInputTopicInput = {
	/** WebhookTopic id for the WebhookSubscription (required if key is not provided). */
	id?: InputMaybe<Scalars['ID']>;
	/** WebhookTopic key for the WebhookSubscription (required if id not provided). */
	key?: InputMaybe<Scalars['String']>;
	/** WebhookTopic version for the WebhookSubscription. */
	version?: InputMaybe<Scalars['String']>;
};

/** A connection from a Node. */
export type WebhookSubscriptionWebhookErrorConnection = {
	__typename?: 'WebhookSubscriptionWebhookErrorConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<WebhookSubscriptionWebhookErrorEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookError>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the WebhookSubscriptionWebhookErrorConnection. */
	permissions: WebhookSubscriptionWebhookErrorConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type WebhookSubscriptionWebhookErrorConnectionPermissions = {
	__typename?: 'WebhookSubscriptionWebhookErrorConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type WebhookSubscriptionWebhookErrorEdge = {
	__typename?: 'WebhookSubscriptionWebhookErrorEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookError>;
};

/** A Node in the graph. */
export type WebhookTopic = NodeInterface & {
	__typename?: 'WebhookTopic';
	/** Identifies the date and time when the object was created. */
	createdAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** Identifies the primary key from the data store. */
	databaseId?: Maybe<Scalars['String']>;
	/** Identifies the date and time when the object was deleted. */
	deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The date and time when the WebhookTopic what last disabled (if disabled). */
	disabledAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The reason given when the WebhookTopic was disabled (if disabled). */
	disabledReason?: Maybe<Scalars['String']>;
	/** ID of the object. */
	id: Scalars['ID'];
	/** The key of the WebhookTopic. */
	key?: Maybe<Scalars['String']>;
	/** Object name to be identified in Audit Logs. */
	nameForLog?: Maybe<Scalars['String']>;
	/** The relative path of the object. */
	path: Scalars['Url'];
	/** A list of Permissions associated with the currently authenticated User and the WebhookTopic. */
	permissions: WebhookTopicPermissions;
	/** The graphql query to be executed whenever Webhooks are triggered for this WebhookTopic. */
	query?: Maybe<Scalars['String']>;
	/** The settings associated with the object. */
	settings: Scalars['JSON'];
	/** A list of WebhookSubscriptions associated with the WebhookTopic. */
	subscriptions?: Maybe<WebhookTopicWebhookSubscriptionConnection>;
	/** Identifies the date and time when the object was last updated. */
	updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
	/** The url of the object. */
	url: Scalars['Url'];
	/** The version of the WebhookTopic. */
	version?: Maybe<Scalars['String']>;
};


/** A Node in the graph. */
export type WebhookTopicSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']>;
	afterIndex?: InputMaybe<Scalars['Int']>;
	before?: InputMaybe<Scalars['String']>;
	beforeIndex?: InputMaybe<Scalars['Int']>;
	first?: InputMaybe<Scalars['Int']>;
	last?: InputMaybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Node. */
export type WebhookTopicPermissions = {
	__typename?: 'WebhookTopicPermissions';
	/** Whether the currently authenticated User can perform delete operations on the parent Node. */
	canDelete: AuthorizationResult;
	/** Whether the currently authenticated User can perform any operation on the parent Node. */
	canManage: AuthorizationResult;
	/** Whether the currently authenticated User can review a node resource like a Project. */
	canReview: AuthorizationResult;
	/** Whether the currently authenticated User can perform update operations on the parent Node. */
	canUpdate: AuthorizationResult;
	/** Whether the currently authenticated User can perform view operations on the parent Node. */
	canView: AuthorizationResult;
};

/** A connection from a Node. */
export type WebhookTopicWebhookSubscriptionConnection = {
	__typename?: 'WebhookTopicWebhookSubscriptionConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<WebhookTopicWebhookSubscriptionEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<WebhookSubscription>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
	/** A list of Permissions associated with the currently authenticated User and the WebhookTopicWebhookSubscriptionConnection. */
	permissions: WebhookTopicWebhookSubscriptionConnectionPermissions;
	/** Identifies the total count of items in the connection. */
	totalCount?: Maybe<Scalars['Int']>;
};

/** A list of Permissions associated with the currently authenticated User and the parent Connection. */
export type WebhookTopicWebhookSubscriptionConnectionPermissions = {
	__typename?: 'WebhookTopicWebhookSubscriptionConnectionPermissions';
	/** Whether the currently authenticated User can perform create operations on the parent Connection. */
	canCreate: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection. */
	canIndex: AuthorizationResult;
	/** Whether the currently authenticated User can perform index operations on the parent Connection and can access all entries within the Company. */
	canIndexAll: AuthorizationResult;
};

/** An edge in a connection. */
export type WebhookTopicWebhookSubscriptionEdge = {
	__typename?: 'WebhookTopicWebhookSubscriptionEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String'];
	/** The index of the specified edge. */
	index?: Maybe<Scalars['Int']>;
	/** The item at the end of the edge. */
	node?: Maybe<WebhookSubscription>;
};
